
(function() {
function cpcInitConfigurator(cfg) {
var SID = cfg.sid;
var EYEBROW = cfg.eyebrow;
var CREATE_URL = cfg.createUrl;
var UPDATE_URL = cfg.updateUrl;
var PHONE_HREF = cfg.phoneHref || 'tel:+18773177505';
var PHONE_LABEL = cfg.phoneLabel || 'US (877) 317-7505';
var VISITOR_ISO = String(cfg.visitorIso || '').toUpperCase();
var _sessionStart = Date.now();
var F = 'https://cdn.shopify.com/s/files/1/0435/4631/2853/files/';
var CDN = 'https://coolperformance.com/cdn/shop/files/';

var DISPLAY_FOR = {
single49e:  'Best all rounder',
single49:   'Best all rounder',
single34:   'Smallest footprint',
triple27:   'Widest view, compact',
triple32:   'Widest view',
ark55:      'Most immersive, largest space',
projection: 'Showpiece installs'
};
var DISPLAYS = {
single34:   { name: '34″ Single Screen',      desc: 'Single curved', img: CDN + '39-Inch-Screen-Web.jpg?v=1745583282&width=900' },
single49e:  { name: '49″ Single Screen',      desc: 'Single ultrawide | DFHD | 165hz', img: CDN + '49-Inch-Screen-Web.jpg?v=1745583282&width=900' },
single49:   { name: '49″ Single Screen DQHD', desc: 'Single ultrawide | DQHD | 240hz', img: CDN + '49-Inch-Screen-Web.jpg?v=1745583282&width=900' },
triple27:   { name: 'Triple 27″ Curved',      desc: 'Three curved 27 inch displays - wraparound immersion', img: CDN + '27-Inch-Screen-Web.jpg?v=1745583282&width=900' },
triple32:   { name: 'Triple 32″ Curved Monitors', desc: 'Three curved wraparound monitors - wide peripheral vision', img: CDN + '32-Inch-Screen-Web.jpg?v=1745583283&width=900' },
ark55:      { name: 'Triple Wrap-Around 55″', desc: 'Three 4K curved widescreen gaming display - ultimate immersive experience', img: CDN + '55-Inch-Ark-Screen-Web.jpg?v=1745583283&width=900' },
projection: { name: 'Full Projection',            desc: 'Triple cinema-screen projection. Details on request.', img: CDN + 'Projector-Screen-WebV2.jpg?width=900' }
};
var MOTION = {
none:    { name: 'Static',                     desc: 'No motion or haptic system', img: null },
haptics: { name: 'Tactile Feedback System',    desc: 'CPS Haptic vibration system - feel kerbs, gear changes and bumps', img: CDN + 'Tactile-Feedback-compressed.jpg?v=1741336303&width=1200' },
motion:  { name: 'D-BOX Full Motion Platform', desc: 'FIA Licensed D-BOX 3DOF system - provides pitch, roll, and heave', img: F + 'D-BOX-Motion-Platform-Cool-Performance-Racing-Simulators.jpg?v=1775095473', video: 'https://cdn.shopify.com/videos/c/vp/230c0725a03d486c99662a8eec19c337/230c0725a03d486c99662a8eec19c337.HD-720p-4.5Mbps-48728065.mp4' }
};
var FS_HAPTICS_IMG = F + 'Formula-Sport-Tactile-Feedback.jpg?v=1790170003';
function motionImg(k) {
if (k === 'haptics' && String(state.sim).indexOf('formula-sport') === 0) return FS_HAPTICS_IMG;
return MOTION[k].img || null;
}
var AUDIO = {
none:     { name: 'No Audio',                   desc: 'No additional audio system' },
headset:  { name: 'Pro Gaming Headset',         desc: 'Logitech professional gaming headset with microphone', img: F + '3203206_R_Z001A.webp?v=1774946239' },
soundbar: { name: 'Bose HD Soundbar',           desc: 'High-fidelity Bose soundbar integrated into the cockpit surround', img: CDN + 'Sound-Compressed.jpg?v=1741336793&width=1000' },
surround: { name: 'Full Surround With Subwoofer', desc: 'Multi-speaker surround system with dedicated subwoofer for full immersion', img: F + 's-l1600.webp?v=1774946196' }
};
var EXTRAS = {
installation: { name: 'White Glove Installation', desc: 'Our team delivers and installs your simulator at your premises providing full user training & handover', img: F + 'CP-Sim-Install-Web.jpg?v=1790090971' },
clutch:       { name: 'Clutch Pedal',             desc: 'CP-S clutch pedal for manual starts and launches', img: CDN + 'CP-S-Bespoke-Hydraulic-Pedals-Cool-Performance-Racing-Simulators-5.jpg?v=1768356378' },   // same shot as the live Formula Pro configurator
hpattern:     { name: 'H-Pattern Shifter',        desc: 'Traditional H-pattern gear shift for authentic racing simulation', img: F + 'Pro-Sim-H-Pattern-Simulator-Shifter-Cool-Performance-Racing-Simulators-5_1.jpg?v=1774946926' },
handbrake:    { name: 'Handbrake',               desc: 'Load cell handbrake with two-stage resistance, for rally, drift and handbrake turns', img: F + 'Sim-Handbrake.jpg?v=1790238470' },
sequential:   { name: 'Sequential Shifter',       desc: 'Fast sequential shift for competitor-style gear changes', img: F + 'Sequential-1.jpg?v=1774947015' },
rtx5090:      { name: 'RTX 5090 PC Upgrade',       desc: 'Upgrade the water-cooled PC to an NVIDIA GeForce RTX 5090', img: F + 'PC.jpg?v=1767856009' },
pirelli:      { name: 'Genuine Pirelli Tyres',  desc: 'Real Pirelli tyres fitted to the car body', img: null },
belts:        { name: 'Seatbelt Tensioners',    desc: 'Harness tensioners that tighten under braking', img: null },
rally:        { name: 'Rally Pack',              desc: 'Load cell handbrake and H-pattern shifter, set up for stage and gravel rally', img: F + 'Rally-Pack.jpg?v=1790146151' },
drift:        { name: 'Drift Pack',              desc: 'Load cell handbrake, sequential shifter and the D-BOX motion platform', img: F + 'Drift-Sim-Pack.jpg?v=1790177391' },
classic:      { name: 'Classic Car Pack',        desc: 'Wood-rim classic wheel, white-knob H-pattern shifter, clutch pedal and analogue Smiths cluster gauges', img: F + 'Classic-Car-Pack.jpg?v=1790143882' },
bespoke:      { name: 'Fully Bespoke',            desc: 'Complete custom solutions available - full tailored bespoke sim build', img: F + 'Mclaren-F1-Sim.jpg?v=1774947415' }
};
var COLOURWAYS = [
['standard', 'Red & Black',            'linear-gradient(135deg,#FF2200 0%,#CC0000 25%,#880000 45%,#330000 58%,#111111 80%,#0a0a0a 100%)', 'img_red_black'],
['stealth',  'Black & Silver',         'linear-gradient(135deg,#1a1a1a 0%,#0a0a0a 40%,#3a3a3a 70%,#888 100%)', 'stealth'],
['navy',     'Metallic Blue',          'linear-gradient(135deg,#001a4d 0%,#003087 50%,#0055cc 100%)', 'navy'],
['brg',      'British Racing Green',   'linear-gradient(135deg,#001a0e 0%,#004225 50%,#006b3f 100%)', 'brg'],
['white',    'Championship White',     'linear-gradient(135deg,#f0f0f0 0%,#fcfcfc 40%,#ffffff 100%)', 'white'],
['yellow',   'LN4 Fluro',              'linear-gradient(135deg,#d4f000 0%,#e8ff00 40%,#f5ff66 100%)', 'yellow'],
['purple',   'Midnight Purple',        'linear-gradient(135deg,#1a0030 0%,#4A0082 50%,#8800cc 100%)', 'purple'],
['cobalt',   'Cobalt Blue',            'linear-gradient(135deg,#003380 0%,#0047AB 25%,#2e6cc7 45%,#5aaad8 65%,#87CEEB 85%,#b8e4f7 100%)', 'cobalt'],
['papaya',   'Papaya Orange',          'linear-gradient(135deg,#f07020 0%,#FF9a30 40%,#ffc470 100%)', 'papaya'],
['custom',   'Custom Colour',          'linear-gradient(135deg,#ff4060 0%,#ff8c38 15%,#f0d040 30%,#40c870 45%,#38a0e0 60%,#7040e0 75%,#e040a0 90%,#ff4060 100%)', 'custom']
];
var FP_PHOTO = F + 'FP-Garage-Photo-v2.jpg?v=1790248938';   // the photograph, untouched
var FP_MASK  = F + 'FP-Garage-Mask-v8.png?v=1790260754'; // 255 chassis, 128 side panel, from the PSD;
var FP_KEYED = F + 'FP-Garage-Keyed-Base.png?v=1790241974';   // garage shot, keyed off the original photograph so its own lighting survives; PNG because JPEG blurs the two keys together at the seam
var FP_KEYED_NATIVE = '#d0202a';   // the red the outer frame is keyed in
var FP_COLOUR_IMAGES = {
standard: F + 'Formula-Pro-Red-BLACK-SILVER-BOLTS.jpg?v=1776065089',
stealth:  F + 'img_blacksilver_32124dad-2de0-424b-b38a-880804495f3a.jpg?v=1775716554',
navy:     F + 'img_metallic_blue_ade6d8cd-89ba-4d98-b736-35432bd9ed81.jpg?v=1775717028',
brg:      F + 'img_british_green.jpg?v=1775552640',
white:    F + 'img_championship_white.jpg?v=1775552641',
yellow:   F + 'img_ln4_fluo_813ab323-a0ee-46e2-8c1f-96159737c552.jpg?v=1775716528',
purple:   F + 'img_midnight_purple_ca6712ae-b58f-4c42-bb29-a0a04677fc78.jpg?v=1775716543',
cobalt:   F + 'img_cobalt_blue.jpg?v=1775552641',
papaya:   F + 'img_papaya_b08e18cc-55fc-4c83-8d83-a882b7fba0a8.jpg?v=1775716529',
custom:   F + 'Colour-Options.jpg?v=1774946761'
};
function colourName(k) { for (var i = 0; i < COLOURWAYS.length; i++) if (COLOURWAYS[i][0] === k) return COLOURWAYS[i][1]; return ''; }
var FINISHES = {
standard: { name: 'Signature Finish',    desc: 'Powder-coated' },
custom:   { name: 'Custom Colour',       desc: 'Full custom colour spray, any colour you choose' },
carbon:   { name: 'Carbon Fibre Trim Pack', desc: 'Carbon floor tray, carbon spacers, carbon back plate. Carbon frame panels on request', img: F + 'LH-Carbon.jpg?v=1741349496' }
};
var SEAT_COLOURS    = { black: 'Black', tan: 'Tan', cognac: 'Cognac', custom: 'Custom Colour' };
var SEAT_SWATCH     = { black: '#111111', tan: '#C4A882', cognac: '#8B4513', custom: 'linear-gradient(135deg,#ff4060,#f0d040,#40c870,#38a0e0,#e040a0)' };
var STITCH_COLOURS  = { black: 'Black', red: 'Red', blue: 'Royal Blue', orange: 'Orange', white: 'White', custom: 'Custom Colour' };
var STITCH_SWATCH   = { black: '#111111', red: '#CC0000', blue: '#003087', orange: '#F97316', white: '#F0F0F0', custom: 'linear-gradient(135deg,#ff4060,#f0d040,#40c870,#38a0e0,#e040a0)' };

function gallery(base, n) { var a = []; for (var i = 0; i < n; i++) a.push(F + base[i]); return a; }

var SIMS = {
'formula-pro': {
name: 'Formula Pro', prefix: 'FP', url: '/products/formula-simulator', tag: 'The iconic F1 simulator',
who: 'Professional and aspiring formula drivers', blurb: 'The rig used by 10 F1 drivers. Full hydraulic pedals, 26Nm force feedback and an F1 driving position.',
proof: ['Used by 10 F1 drivers', 'For professionals and those who simply want the best', '26Nm force feedback and 200kg hydraulic braking'],
images: gallery(['F1-Simulator-Cool-Performance-Racing-Simulators-3_aed6da37.jpg?v=1775630118', 'F1-Simulator-Cool-Performance-Racing-Simulators-4_61915ea7.jpg?v=1775630118', 'F1-Simulator-Cool-Performance-Racing-Simulators-5_975a180b.jpg?v=1775630118'], 3),
packages: [{ id: 'pro', name: 'Formula Pro', price: '£30,600', preset: { wheel: 'cps-formula', base: 'bodnar', pedals: 'cps-hydraulic', pc: 'pc-std' }, spec: [
['Frame', 'Formula Pro, powder-coated aluminium, handbuilt in the UK'],
['Wheel Base', 'Leo Bodnar SimSteering 2 FFB 26Nm, CP-S tuned'],
['Steering Wheel', 'CP-S Formula Wheel'],
['Pedals', 'CP-S Custom Hydraulic Pedals'],
['Pedal Actuation', 'Electronic Pedal Actuation'],
['Seat', 'CP-S Formula seat'],
['Computing', 'Water-cooled PC, RTX 5080, Intel Core i9'],
['Warranty', 'Lifetime frame warranty, 24 months electrical']] }],
seat: 'CP-S Formula seat', seatCustom: true,
displays: ['single49', 'triple27', 'ark55'], stdDisplay: 'single49',
extras: ['installation', 'clutch', 'hpattern', 'sequential', 'rtx5090', 'bespoke']
},
'gt-pro': {
name: 'GT Pro', prefix: 'GTP', url: '/products/gt-simulator', tag: 'Our most versatile pro-grade rig',
who: 'Drivers who race more than one discipline', blurb: 'GT3 driving position with a FIA homologated race seat, set up for GT, road, rally, drift and NASCAR on the same rig.',
proof: ['Used by GT, road, rally and Le Mans champions', 'For professionals and those who simply want the best', 'One rig for GT, road, rally, drift and NASCAR'],
images: gallery(['GT-Pro-Side-On.jpg?v=1790241542', 'GT-Pro-Racing-Simulator-Cool-Performance-Racing-Simulators-2_e5dbe584.jpg?v=1750064733', 'GT-Pro-Racing-Simulator-Cool-Performance-Racing-Simulators-3_db07b8be.jpg?v=1750064732', 'GT-Pro-Racing-Simulator-Cool-Performance-Racing-Simulators-4_11c1f22a.jpg?v=1750064735'], 4),
packages: [{ id: 'pro', name: 'GT Pro', price: '£28,900', preset: { wheel: 'cps-gt', base: 'bodnar', pedals: 'cps-hydraulic', pc: 'pc-std' }, spec: [
['Frame', 'Powder-coated aluminium, handbuilt in the UK to ISO 9001'],
['Wheel Base', 'Leo Bodnar SimSteering 26Nm, CP-S software'],
['Steering Wheel', 'CP-S GT Carbon Wheel + DD-R display unit'],
['Pedals', 'CP-S Hydraulic, AP Racing master cylinder, 200kg'],
['Pedal Actuation', 'Electronic Pedal Actuation'],
['Seat', 'FIA homologated GT race seat'],
['Computing', 'Water-cooled PC, RTX 5080, Intel Core i9'],
['Warranty', 'Lifetime frame warranty, 24 months electrical']] }],
seat: 'FIA GT Seat', seatCustom: true,
displays: ['single49', 'triple32', 'ark55'], stdDisplay: 'single49',   // GT Pro: no triple 27
extras: ['installation', 'clutch', 'hpattern', 'sequential', 'handbrake', 'rally', 'drift', 'classic', 'rtx5090', 'bespoke']
},
'formula-sport': {
noCarbon: true,
colours: ['standard', 'stealth', 'papaya', 'navy', 'white', 'custom'],   // Sport range: six colour options
name: 'Formula Sport', prefix: 'FS', url: '/products/formula-sport-racing-simulator', tag: 'Formula driving position, three stages',
who: 'Serious home drivers who want the formula position', blurb: 'The formula layout in three stages, so you can start where your budget sits and upgrade the hardware later.',
proof: ['Three stages, upgrade the hardware later', 'For serious enthusiasts', 'Upgrade stage by stage on the same lifetime frame'],
images: gallery(['Formula-Sport-Studio-Web.jpg?v=1790060182', 'Formula-Sport-F1-Simulator-Cool-Performance-Racing-Simulators_77455869.jpg?v=1778551428', 'Formula-Sport-F1-Simulator-Cool-Performance-Racing-Simulators-2_d4a97735.jpg?v=1778551442', 'Formula-Sport-F1-Simulator-Cool-Performance-Racing-Simulators-3_c38b7ae9.jpg?v=1778551455', 'Formula-Sport-F1-Simulator-Cool-Performance-Racing-Simulators-4_dc0c314d.jpg?v=1778551468'], 5),
packages: [
{ id: 's1', name: 'Stage 1', price: '£13,950', display: 'single49e', preset: { wheel: 'gsv2p', base: 'r12', pedals: 'crp2', pc: 'pc-std' } },
{ id: 's2', name: 'Stage 2', price: '£16,950', display: 'single49e', preset: { wheel: 'csx3', base: 'sc-sport', pedals: 'sprint', pc: 'pc-std' } },
{ id: 's3', name: 'Stage 3', price: '£21,950', display: 'single49', preset: { wheel: 'cps-formula', base: 'sc-pro', pedals: 'cps-custom', pc: 'pc-5080' } },
{ id: 'custom', name: 'Custom Spec', price: 'POA', custom: true, display: 'single49' }],
components: [
{ id: 'wheel',  title: 'Steering Wheel', options: [['gsv2p', 'MOZA Racing GS V2P', 'Stage 1'], ['csx3', 'Cube CSX-3 Formula', 'Stage 2'], ['cps-formula', 'CP-S Formula Wheel', 'Stage 3']] },
{ id: 'base',   title: 'Wheel Base',     options: [['r12', 'MOZA Racing R12', 'Stage 1'], ['sc-sport', 'Simucube Sport', 'Stage 2'], ['sc-pro', 'Simucube Pro', 'Stage 3']] },
{ id: 'pedals', title: 'Pedals',         options: [['crp2', 'MOZA Racing CRP2', 'Stage 1'], ['sprint', 'Heusinkveld Sprint', 'Stage 2'], ['cps-custom', 'CP-S Custom Pedals', 'Stage 3']] },
{ id: 'pc',     title: 'Computer',       options: [['pc-std', 'Water-cooled PC, RTX 5070, Intel Core i9', 'Stage 1'], ['pc-5080', 'Water-cooled PC, RTX 5080, Intel Core i9', 'Stage 3']] }],
common: [['Seat', 'CP-S Formula seat'], ['Warranty', 'Lifetime frame warranty, 24 months electrical']],
seat: 'CP-S Formula seat', seatCustom: true,
displays: ['single49e', 'single49', 'triple32', 'ark55'],
extras: ['installation', 'clutch', 'hpattern', 'sequential', 'bespoke']
},
'gt-sport': {
noCarbon: true,
colours: ['standard', 'stealth', 'papaya', 'navy', 'white', 'custom'],   // Sport range: six colour options
name: 'GT Sport', prefix: 'GTS', url: '/products/e-sport-gaming-simulator', tag: 'GT driving position, three stages',
who: 'Home and esports drivers in a GT position', blurb: 'The GT seating position in three stages, with a road-car race seat and room to grow into pro-grade hardware.',
proof: ['Three stages, upgrade the hardware later', 'For serious enthusiasts', 'Upgrade stage by stage on the same lifetime frame'],
images: gallery(['GT-Sport-Racing-Simulator-Cool-Performance-Racing-Simulators_7200ec8b.jpg?v=1750064739', 'GT-Sport-Racing-Simulator-Cool-Performance-Racing-Simulators-2_f59f2b25.jpg?v=1750064741', 'GT-Sport-Racing-Simulator-Cool-Performance-Racing-Simulators-3_a1d72af1.jpg?v=1750064742', 'GT-Sport-Racing-Simulator-Cool-Performance-Racing-Simulators-4_78f29d50.jpg?v=1750064743'], 4),
packages: [
{ id: 's1', name: 'Stage 1', price: '£11,950', display: 'single49e', preset: { wheel: 'ks', base: 'r12', pedals: 'crp2', pc: 'pc-std', ddu: 'none' } },
{ id: 's2', name: 'Stage 2', price: '£14,950', display: 'single49e', preset: { wheel: 'cube-gt', base: 'sc-sport', pedals: 'sprint', pc: 'pc-std', ddu: 'ddr' } },
{ id: 's3', name: 'Stage 3', price: '£19,950', display: 'single49', preset: { wheel: 'cps-gt', base: 'sc-pro', pedals: 'cps-custom', pc: 'pc-5080', ddu: 'none' } },   // CP-S wheel has the display built in
{ id: 'custom', name: 'Custom Spec', price: 'POA', custom: true, display: 'single49' }],
components: [
{ id: 'wheel',  title: 'Steering Wheel', options: [['ks', 'MOZA Racing KS', 'Stage 1'], ['cube-gt', 'Cube GT Pro', 'Stage 2'], ['cps-gt', 'CP-S GT Pro', 'Stage 3']] },
{ id: 'base',   title: 'Wheel Base',     options: [['r12', 'MOZA Racing R12', 'Stage 1'], ['sc-sport', 'Simucube Sport', 'Stage 2'], ['sc-pro', 'Simucube Pro', 'Stage 3']] },
{ id: 'pedals', title: 'Pedals',         options: [['crp2', 'MOZA Racing CRP2', 'Stage 1'], ['sprint', 'Heusinkveld Sprint', 'Stage 2'], ['cps-custom', 'CP-S Custom Pedals', 'Stage 3']] },
{ id: 'ddu',    title: 'DDU Digital Display', options: [['none', 'None', 'Stage 1'], ['ddr', 'Precision Sim Engineering DD-R', 'Stage 2']] },
{ id: 'pc',     title: 'Computer',       options: [['pc-std', 'Water-cooled PC, RTX 5070, Intel Core i9', 'Stage 1'], ['pc-5080', 'Water-cooled PC, RTX 5080, Intel Core i9', 'Stage 3']] }],
common: [['Seat', 'Road car racing seat'], ['Warranty', 'Lifetime frame warranty, 24 months electrical']],
seat: 'Road car racing seat', seatCustom: true,
displays: ['single49e', 'single49', 'triple32', 'ark55'],
extras: ['installation', 'clutch', 'hpattern', 'sequential', 'handbrake', 'rally', 'drift', 'bespoke']
},
'karting': {
enquireOnly: true, discover: true,   // specified with the team, not self-configured
noCarbon: true,
name: 'Karting Simulator Pro', prefix: 'KRT', url: '/products/karting-simulator', tag: 'Genuine OTK kart chassis',
who: 'Serious kart racing training', blurb: 'Built on a genuine OTK chassis that adjusts from Bambino to Senior, running KartSim, so a young driver grows with it.',
proof: ['Genuine OTK chassis, Bambino to Senior', 'KartSim circuits built from Lidar data where available', 'Kart pedals with cable throttle and hydraulic brake'],
images: gallery(['Karting-Simulator-Pro-Cool-Performance-Racing-Simulators.jpg?v=1765295468', 'Karting-Simulator-Pro-Cool-Performance-Racing-Simulators-2.jpg?v=1765295469', 'Karting-Simulator-Pro-Cool-Performance-Racing-Simulators-3.jpg?v=1765295471', 'Karting-Simulator-Pro-Cool-Performance-Racing-Simulators-4.jpg?v=1765295473', 'Karting-Simulator-Pro-Cool-Performance-Racing-Simulators-5.jpg?v=1765331816', 'Karting-Simulator-Pro-Cool-Performance-Racing-Simulators-6.jpg?v=1765295478'], 6),
packages: [{ id: 'pro', name: 'Karting Simulator Pro', price: '£9,950', preset: { base: 'moza', ddu: 'none' }, spec: [
['Chassis', 'Genuine OTK kart chassis, adjusts from Bambino to Senior'],
['Seat', 'CP Kart Pro replica seat, adjustable'],
['Pedals', 'CP-S Karting Pro Pedals'],
['Steering', 'OTK steering wheel'],
['Software', 'KartSim (rFactor 2 platform)'],
['Computing', 'Water-cooled PC, RTX 5070, Intel Core i9'],
['Warranty', 'Lifetime frame warranty, 24 months electrical']] }],
components: [
{ id: 'base', title: 'Wheel Base',          options: [['moza', 'Moza R12', 'Included'], ['sc-sport', 'Simucube Sport', 'Upgrade'], ['sc-pro', 'Simucube Pro', 'Upgrade']] },
{ id: 'ddu',  title: 'DDU Digital Display', options: [['none', 'None', 'Included'], ['ddr', 'Precision Sim Engineering DD-R', 'Upgrade']] }],
seat: 'CP Kart Pro replica seat', seatCustom: false,
displays: ['single49', 'triple32', 'ark55'],
extras: ['installation', 'rtx5090', 'bespoke']
},
'half-f1': {
noCarbon: true, noSeatStep: true, lead: 'Lead time confirmed on enquiry', discover: true, enquireOnly: true,   // specified with the team, not self-configured
name: 'Half F1 Car', prefix: 'HF1', url: '/products/half-f1-car-simulator', tag: 'Full-scale F1 cockpit',
who: 'Collectors, showrooms and event spaces', blurb: 'A full-scale F1 half car based on a real F1 car mould. The most visually striking simulator we build, and a working pro-grade rig.',
proof: ['Based on a real F1 car mould', 'Built for showrooms, events and collections', 'Full-scale cockpit with triple curved displays'],
images: gallery(['Half-F1-Silver-Web.jpg?v=1765295453'], 1),
packages: [{ id: 'pro', name: 'Half F1 Car', price: '£85,000', preset: { wheel: 'cps-formula', pedals: 'cps-hydraulic' }, spec: [
['Cockpit', 'Fibreglass F1 half car based on a real F1 car mould'],
['Seat', 'Custom fibreglass formula seat'],
['Wheel Base', 'Leo Bodnar SimSteering 26Nm, CP-S configuration'],
['Steering Wheel', 'CP-S replica formula carbon fibre wheel'],
['Pedals', 'CP-S hydraulic, AP Racing master cylinder'],
['Computing', 'Water-cooled PC, RTX 5080, Intel Core i9'],
['Warranty', 'Lifetime frame warranty, 24 months electrical']] }],
components: [
{ id: 'wheel',  title: 'Steering Wheel', options: [['cps-formula', 'CP-S Replica Formula Carbon', 'Included'], ['gpx', 'GPX F1 Wheel', 'Alternative']] },
{ id: 'pedals', title: 'Pedals',         options: [['cps-hydraulic', 'CP-S Hydraulic, AP Racing', 'Included'], ['sprint', 'Heusinkveld Sprint', 'Alternative']] }],
seat: 'Custom fibreglass formula seat', seatCustom: false, colourRequired: true,
displays: ['triple27', 'ark55'],
extras: ['installation', 'clutch', 'pirelli', 'belts', 'rtx5090', 'bespoke']
},
'full-f1': {
noCarbon: true, noSeatStep: true, lead: 'Lead time confirmed on enquiry', discover: true, enquireOnly: true,   // specified with the team, not self-configured
name: 'Full F1 Car', prefix: 'FF1', url: '/pages/bespoke', tag: 'Full-size F1 car',
who: 'Showrooms, collections and events', blurb: 'A full-size F1 car simulator, built to the same specification as the Half F1 Car.',
proof: ['Full-size F1 car body', 'Built for showrooms, events and collections', 'Same pro-grade hardware as the Half F1 Car'],
images: gallery(['Mclaren-F1-Sim.jpg?v=1774947415'], 1),
packages: [{ id: 'pro', name: 'Full F1 Car', price: 'POA', preset: { wheel: 'cps-formula', pedals: 'cps-hydraulic' }, spec: [
['Cockpit', 'Full-size F1 car body'],
['Wheel Base', 'Leo Bodnar SimSteering 26Nm, CP-S configuration'],
['Steering Wheel', 'CP-S replica formula carbon fibre wheel'],
['Pedals', 'CP-S hydraulic, AP Racing master cylinder'],
['Seat', 'Custom fibreglass formula race seat'],
['Computing', 'Water-cooled PC, RTX 5080, Intel Core i9'],
['Warranty', 'Lifetime frame warranty, 24 months electrical']] }],
components: [
{ id: 'wheel',  title: 'Steering Wheel', options: [['cps-formula', 'CP-S Replica Formula Carbon', 'Included'], ['gpx', 'GPX F1 Wheel', 'Alternative']] },
{ id: 'pedals', title: 'Pedals',         options: [['cps-hydraulic', 'CP-S Hydraulic, AP Racing', 'Included'], ['sprint', 'Heusinkveld Sprint', 'Alternative']] }],
seat: 'Custom fibreglass formula seat', seatCustom: false, colourRequired: true,
displays: ['triple27', 'ark55'],
extras: ['installation', 'clutch', 'pirelli', 'belts', 'rtx5090', 'bespoke']
},
'half-gt': {
noCarbon: true, noSeatStep: true, lead: 'Lead time confirmed on enquiry', discover: true, enquireOnly: true,   // specified with the team, not self-configured
name: 'Half Race Car', prefix: 'HRC', url: '/pages/bespoke', tag: 'Full-scale GT car cockpit',
who: 'Showrooms, collections and event spaces', blurb: 'A full-scale GT car half body built around a pro-grade GT rig, finished in your own livery.',
proof: ['Full-scale GT car cockpit', 'Donor car required', 'Pro-grade GT hardware underneath'],
images: gallery(['Aston-Half-Car.jpg?v=1741365835'], 1),
packages: [{ id: 'pro', name: 'Half GT Car', price: 'POA', preset: { wheel: 'cps-gt', pedals: 'cps-hydraulic' }, spec: [
['Cockpit', 'Full-scale GT car half body, finished in your livery'],
['Wheel Base', 'Leo Bodnar SimSteering 26Nm, CP-S configuration'],
['Steering Wheel', 'CP-S GT Carbon Wheel'],
['Pedals', 'CP-S hydraulic, AP Racing master cylinder'],
['Seat', 'FIA homologated GT race seat'],
['Computing', 'Water-cooled PC, RTX 5080, Intel Core i9'],
['Warranty', 'Lifetime frame warranty, 24 months electrical']] }],
components: [
{ id: 'wheel',  title: 'Steering Wheel', options: [['cps-gt', 'CP-S GT Carbon Wheel', 'Included'], ['cube-gt', 'Cube GT Pro', 'Alternative']] },
{ id: 'pedals', title: 'Pedals',         options: [['cps-hydraulic', 'CP-S Hydraulic, AP Racing', 'Included'], ['sprint', 'Heusinkveld Sprint', 'Alternative']] }],
seat: 'FIA homologated GT race seat', seatCustom: false, colourRequired: true,
displays: ['triple27', 'ark55'],
extras: ['installation', 'clutch', 'pirelli', 'belts', 'rtx5090', 'bespoke']
}
};
var EXAMPLES = {
'formula-pro': [
['Formula-Pro-garage-H1024.jpg?v=1769054921', 'Formula Pro in a private collection'],
['Formula_Pro_Motion_4x5_1.jpg', 'Formula Pro with D-BOX motion and triple screens'],
['Kimi-Sim-Landscape-Collection-page-2.jpg', 'Kimi Antonelli\'s Formula Pro'],
['Formula-7.jpg', 'Formula Pro in a home studio'],
['Formula-11.jpg', 'Formula Pro on triple screens'],
['Formula-Sim-3_83372f53-f1bd-4d7d-88e2-729edd6b32ec.jpg', 'Formula Pro at home'],
['Formula-5.jpg', 'Formula Pro, single-screen install'],
['Corporate---Sim-_1.jpg', 'Formula Pro in a corporate space'],
['Formula-Pro-With-Motion-Side-View.jpg', 'Formula Pro with motion, side view']
],
'gt-pro': [
['GT-Pro-garage-W-1536.jpg?v=1769055204', 'GT Pro in a private collection'],
['GT-6.jpg', 'GT Pro in a home studio'],
['GT-5.jpg', 'GT Pro on triple screens'],
['GT-4.jpg', 'GT Pro in use'],
['Lando_GT_Install_53dadd52-700b-4274-abe7-e00c785930b6.jpg', 'Lando Norris\'s GT Pro install'],
['GT-1.jpg', 'Custom GT Pro build']
],
'formula-sport': [
['Formula-Sport-Garage-H1024.jpg?v=1769058150', 'Formula Sport in a private collection'],
['Formula-Sport_2.jpg', 'Formula Sport in Papaya'],
['Formula-Sport-F1-Simulator-Cool-Performance-Racing-Simulators-4_dc0c314d.jpg', 'Formula Sport, rear three-quarter'],
['WEB-Formula-Sport-2.jpg', 'Formula Sport cockpit and wheel'],
['WEB-Formula-Sport-3.jpg', 'Formula Sport driving position'],
['Formula-Sport-Thumbnail.jpg', 'Formula Sport on triple screens']
],
'gt-sport': [
['GT-Sport-garage-H1024.jpg?v=1769054921', 'GT Sport in a private collection'],
['GT-Sport-Final.jpg', 'GT Sport among the collection'],
['GT-Sport---Main---HQ-Web_907737e6-fc96-4354-bd39-0581ab841f47.jpg', 'GT Sport on triple screens'],
['GT-Sport_391897bb-4abc-476d-a17a-386947a70a80.jpg', 'GT Sport cockpit and wheel'],
['GT-Sport-Frame.jpg', 'GT Sport chassis'],
['GT-Sport-Thumbnail.jpg', 'GT Sport, three-quarter view']
],
'karting': [
['Kart-Sim-Thumnail-Final.jpg', 'Karting Simulator Pro on projection'],
['Karting-Simulator-Rear.jpg', 'Karting Simulator Pro, rear view'],
['Karting-Simulator-Top_66be3ba0-69ab-4d46-86be-8acc0d0f564a.jpg', 'Custom kart simulator build']
],
'half-f1': [
['Half-F1-Silver-Web.jpg?v=1765295453', 'Half F1 Car']
]
};
function examples(k) {
return (EXAMPLES[k] || []).map(function(x) { return { src: sized(F + x[0], 1200), caption: x[1] }; });
}

var PROD = 'https://cdn.shopify.com/s/files/1/0435/4631/2853/products/';
var PART_IMAGES = {
'r12':           F + 'CP-Config-MOZA-R12-Wheel-Base.jpg?v=1790036940',
'ddr':           F + 'DDU.jpg?v=1741948993',
'pc-std':        F + 'Computer-Close-Up.jpg?v=1741706601',
'pc-5080':       F + 'PC.jpg?v=1767856009',
'pc-5090':       F + 'PC.jpg?v=1767856009',
'ddx':           F + 'DDU.jpg?v=1741948993',
'moza':          F + 'CP-Config-MOZA-R12-Wheel-Base.jpg?v=1790036940',
'crp2':          F + 'CP-Config-MOZA-CRP2-Pedals.jpg?v=1790036940',
'ks':            F + 'CP-Config-MOZA-KS-Steering-Wheel.jpg?v=1790036967',
'sprint':        F + 'CP-Config-Heusinkveld-Sprint-Pedals.jpg?v=1790036941',
'gsv2p':         F + 'Moza-GS.jpg?v=1745832532',
'cps-formula':   F + 'CP-S-Simulator-Steering-Wheel-Cool-Performance-Racing-Simulators_d33521c7.jpg?v=1750064863',
'cps-gt':        CDN + 'CP-S-GT-Wheel.jpg?v=1768381280',
'csx3':          PROD + 'Cube-Formula-CSX3-Steering-Wheel-Cool-Performance-Racing-Simulators.webp?v=1750064837',
'gpx':           PROD + 'GPX-Steering-Wheel-Cool-Performance-Racing-Simulators.png?v=1750064801',
'lm-pro':        PROD + 'LM-PRO-GT3-Steering-Wheel-Cool-Performance-Racing-Simulators.png?v=1750064800',
'cube-gt':       F + 'Cube-GT-Sport-Steering-Wheel-Cool-Performance-Racing-Simulators.jpg?v=1785204222',
'bodnar':        F + 'Sim_photography_42__Page_19_077f2e4f-29a6-40fa-a8c6-b7f0cf17f746.jpg?v=1750849634',
'sc-ultimate':   PROD + 'Simucube-2-Ultimate-Direct-Drive-Wheel-Base-Cool-Performance-Racing-Simulators.png?v=1750064816',
'sc-sport':      PROD + 'Simucube-2-Sport-Direct-Drive-Wheel-Base-Cool-Performance-Racing-Simulators.png?v=1750064810',
'sc-pro':        PROD + 'Simucube-2-Ultimate-Direct-Drive-Wheel-Base-Cool-Performance-Racing-Simulators.png?v=1750064816',
'cps-hydraulic': F + 'Pedals-Front-View.jpg?v=1767858021',
'cps-custom':    F + 'CP-S-Bespoke-Hydraulic-Pedals-Cool-Performance-Racing-Simulators_21c137af.jpg?v=1750064829'
};
var COMPARABLE = ['formula-pro', 'gt-pro', 'formula-sport', 'gt-sport', 'karting', 'half-f1', 'half-gt', 'full-f1'];
var SIM_ORDER = ['formula-pro', 'gt-pro', 'formula-sport', 'gt-sport', 'karting', 'half-f1', 'half-gt', 'full-f1'];

var CURRENCY = String(cfg.currency || 'GBP').toUpperCase();
var PRICE_MAP = (cfg.prices && typeof cfg.prices === 'object') ? cfg.prices : {};
var PRICE_EXTRA = {
'formula-sport': {
s2: { GBP: 16950, EUR: 20050, USD: 23050, CAD: 31350, AUD: 34100 },
s3: { GBP: 21950, EUR: 25950, USD: 29800, CAD: 40600, AUD: 44150 }
},
'gt-sport': {
s2: { GBP: 14950, EUR: 17700, USD: 19950, CAD: 27650, AUD: 30100 },
s3: { GBP: 19950, EUR: 23600, USD: 26650, CAD: 36900, AUD: 40150 }
}
};
function money(n, cur) {
var d = String(Math.round(n)), out = '', i, left;
for (i = 0; i < d.length; i++) {
out += d.charAt(i);
left = d.length - 1 - i;
if (left > 0 && left % 3 === 0) out += ',';
}
if (cur === 'GBP') return '£' + out;
if (cur === 'EUR') return '€' + out;
if (cur === 'USD') return '$' + out;
if (cur === 'AUD' || cur === 'CAD') return '$' + out;
return out + ' ' + cur;
}
function priceLiteral(simId, pkgId) {
var s = SIMS[simId], ps = (s && s.packages) || [], i;
for (i = 0; i < ps.length; i++) if (ps[i].id === pkgId) return ps[i].price;
return '';
}
function priceFor(simId, pkgId) {
var n = null, ex = PRICE_EXTRA[simId];
if (PRICE_MAP[simId] && PRICE_MAP[simId][pkgId] != null) n = PRICE_MAP[simId][pkgId];
else if (ex && ex[pkgId] && ex[pkgId][CURRENCY] != null) n = ex[pkgId][CURRENCY];
n = Number(n);
if (n === 0 || !isFinite(n)) return priceLiteral(simId, pkgId);
return money(n, CURRENCY);
}

var state, currentStep = 0, currentRef = null;
var compareSel = {};   // which simulators are ticked for comparison
function resetState(simKey) {
var sim = SIMS[simKey];
state = { compare: compareSel, sim: simKey, pkg: sim.packages[0].id, base: sim.packages[0].id, choices: {}, comp: {}, colour: sim.colourRequired ? 'custom' : 'standard', carbon: false,
customHex: CUSTOM_START, customFinish: 'gloss',
seatColour: 'black', stitching: 'black', tricolour: 'none', seatFinish: {}, seatType: 'standard', carbonCustom: false, stitchCustom: false, display: null, motion: 'none', audio: 'none', headset: false, extras: {}, lastPart: null, customTarget: 'outer', innerHex: INNER_START, innerFinish: '' };
applyPreset(sim.packages[0]);
(sim.choices || []).forEach(function(c) { state.choices[c.id] = c.options[0][0]; });
state.display = startDisplay();
currentRef = null;
}
function sim() { return SIMS[state.sim]; }
function pkg() { var p = sim().packages; for (var i = 0; i < p.length; i++) if (p[i].id === state.pkg) return p[i]; return p[0]; }
function stdDisplay() { return pkg().display || sim().stdDisplay || null; }
function includedAt(k) {
var s = sim();
if (s.packages.length > 1) {
var inc = s.packages.filter(function(x) { return !x.custom && x.display === k; })
.map(function(x) { return x.name.replace('Stage ', ''); });
return inc.length ? 'Stage ' + inc.join(' & ') : '';
}
return k === stdDisplay() ? 'Included' : '';
}
function startDisplay() { return stdDisplay() || sim().displays[0]; }
function applyPreset(p) {
if (p.custom) return;
state.comp = {};
Object.keys(p.preset || {}).forEach(function(k) { state.comp[k] = p.preset[k]; });
}
function isCustom() { return !!pkg().custom; }
function customPkgId() { var ps = sim().packages; for (var i = 0; i < ps.length; i++) if (ps[i].custom) return ps[i].id; return null; }
function basePkg() { var ps = sim().packages; for (var i = 0; i < ps.length; i++) if (ps[i].id === state.base) return ps[i]; return ps[0]; }
function offPreset() {
var pr = basePkg().preset; if (!pr) return false;
return Object.keys(pr).some(function(k) { return state.comp[k] !== pr[k]; });
}
function syncCustom() {
var cid = customPkgId();
if (!cid) return;
if (offPreset()) state.pkg = cid;
else state.pkg = state.base;
}
function isMixed() { return isCustom() || offPreset(); }
function compLabel(c, v) { for (var i = 0; i < c.options.length; i++) if (c.options[i][0] === v) return c.options[i]; return null; }
function nearestStage() {
var s = sim(), best = 0;
(s.components || []).forEach(function(c) {
var o = compLabel(c, state.comp[c.id]);
if (o) { var n = parseInt((o[2] || '').replace(/\D/g, ''), 10) || 0; if (n > best) best = n; }
});
return best;
}

function root() { return document.getElementById('cpc-' + SID); }
function $$(id) { return document.getElementById(id + '-' + SID); }
function esc(s) { return String(s).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function fn(name) { return "window['cpc" + name + '_' + SID + "']"; }
function sized(url, w) {
var base = String(url).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
return base + (base.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
}
function thumb(url) {
return '<img src="' + sized(url, 228) + '" srcset="' + [114, 168, 228, 342].map(function(w) { return sized(url, w) + ' ' + w + 'w'; }).join(', ')
+ '" sizes="(max-width: 700px) 72px, 114px" width="114" height="88" alt="" decoding="async" fetchpriority="low">';
}

var CARBON_IMG = F + 'LH-Carbon.jpg?v=1741349496';
var CARBON_BACKPLATE = F + 'Carbon-Backplate.jpg?v=1790173592';
var CARBON_GTPRO = { tray: F + 'Carbon-Floor-Tray-GT-Pro.jpg?v=1790224977',
inplace: F + 'GT-Pro-Carbon-Tray-Surrounds.jpg?v=1790225275' };
function carbonPart(k, fallback) {
return (state.sim === 'gt-pro' && CARBON_GTPRO[k]) || fallback;
}
var CARBON_PARTS = [
['Floor Tray',  'Carbon fibre floor tray',   null,                                        'tray'],
['Back Plate',  'Carbon fibre back plate',   CARBON_BACKPLATE,                            null],
['Surrounds',   'Carbon fibre surrounds',    F + 'Carbon-Surrounds-FP.jpg?v=1790174491',   null],
['In Place',    'Surrounds and floor tray',  F + 'Carbon-Front.jpg?v=1790176494',          'inplace']
];
var PC_IMG = F + 'Computer-Close-Up.jpg?v=1741706601';
var SEAT_IMG = {
'formula-pro': F + 'CP-S-Formula-Seat-Cutout.png?v=1790247741', 'gt-pro': F + 'GT-Pro-Seat.jpg?v=1741610174',
'formula-sport': F + 'CP-S-Formula-Seat-Cutout.png?v=1790247741', 'gt-sport': F + 'GT-Sport-Seat.jpg?v=1741709466',
'karting': F + 'Karting-simulator-Seat.jpg?v=1762155705', 'half-f1': F + 'CP-S-Formula-Seat-Cutout.png?v=1790247741',
'full-f1': F + 'CP-S-Formula-Seat-Cutout.png?v=1790247741', 'half-gt': F + 'GT-Pro-Seat.jpg?v=1741610174'
};
var FRAME_IMG = { 'formula-sport': F + 'Formula-Sport-Studio-Web.jpg?v=1790060182', 'gt-pro': F + 'GT-Pro-Frame.jpg?v=1768879046', 'karting': F + 'Kart_Sim_Product.png?v=1761882162' };
function softwareImg() { return state.sim === 'karting' ? F + 'Kart_Sim_Software.webp?v=1761883590' : F + 'CP-S-Software-Suite-2.jpg?v=1790230730'; }
function simImg(k) {
var kk = k || state.sim, x = SIMS[kk];
var ex = examples(kk)[0];                       // the garage shot, not the studio cut-out
return (ex && ex.src) || FRAME_IMG[kk] || (x.images && x.images[0]) || null;
}
var PART_IMAGES_BY_SIM = {
'gt-pro': {
'cps-hydraulic': F + 'Carbon-Floor-Tray-GT-Pro.jpg?v=1790224977',
'cps-gt':        F + 'GT-Pro-Wheel-2.jpg?v=1768879576'
}
};
function partImg(v) {
var m = PART_IMAGES_BY_SIM[state.sim];
return (m && m[v]) || PART_IMAGES[v] || null;
}
function imgFor(label) {
var s = sim(), l = String(label).toLowerCase();
var c = (s.components || []).filter(function(x) { return x.title.toLowerCase() === l; })[0];
if (c) return partImg(state.comp[c.id]);
if (/^(frame|chassis|cockpit|simulator)$/.test(l)) return simImg();
if (l === 'seat') return SEAT_IMG[state.sim] || null;
if (l === 'computing') return PC_IMG;
if (l === 'warranty' || /shipping|delivery/.test(l)) return null;
if (l === 'hardware') return F + 'Sport-Hardware-Stages.jpg?v=1790242903';
if (l === 'seating & pedals') return F + 'Sport-Seating-Pedals.jpg?v=1790242903';
if (state.sim === 'karting' && l === 'pedals') return F + 'Karting-Simulator-Pedals.jpg?v=1762155563';
if (state.sim === 'karting' && l === 'steering') return F + 'Karting-Simulator-Wheels-DDU.jpg?v=1762156090';
if (l === 'pedal actuation') return F + 'Pedal-Actuator-Square.jpg?v=1790174491';
if (l === 'software') return softwareImg();
if (l === 'carbon fibre') return CARBON_IMG;
if (l === 'display' && DISPLAYS[state.display]) return displayImg(state.display);
if (l === 'motion' && MOTION[state.motion]) return motionImg(state.motion);
if (l === 'audio' && AUDIO[state.audio]) return AUDIO[state.audio].img || null;
if (l === AUDIO.headset.name.toLowerCase()) return AUDIO.headset.img || null;
var ex = Object.keys(EXTRAS).filter(function(k) { return EXTRAS[k].name.toLowerCase() === l; })[0];
if (ex) return extraImg(ex) || null;
var sf = Object.keys(SEAT_FINISHES).filter(function(k) { return SEAT_FINISHES[k].name.toLowerCase() === l; })[0];
if (sf) return SEAT_FINISHES[sf].img || null;
if (state.sim !== 'karting') {
if (l === 'wheel base') return PART_IMAGES.bodnar;
if (l === 'pedals') return partImg('cps-hydraulic');
if (l === 'steering wheel') return partImg(state.sim.indexOf('gt') === 0 ? 'cps-gt' : 'cps-formula');
}
return null;
}
function swatchFor(label) {
var l = String(label).toLowerCase();
if (l === 'frame colour') { var cw = COLOURWAYS.filter(function(c) { return c[0] === state.colour; })[0]; return cw ? cw[2] : null; }
if (l === 'seat colour') return SEAT_SWATCH[state.seatColour] || null;
if (l === 'stitching') return STITCH_SWATCH[state.stitching] || null;
if (l === 'tricolour') return TRICOLOURS[state.tricolour] ? TRICOLOURS[state.tricolour][1] : null;
return null;
}
var PART_ICON = { 'comp:wheel': 'Steering Wheel', 'comp:base': 'Wheel Base', 'comp:pedals': 'Pedals', 'comp:ddu': 'Display' };
(function() {
document.addEventListener('keydown', function(e) {
if (e.key !== 'Enter' && e.key !== ' ') return;
var t = e.target;
if (!t || !t.classList) return;
var kc = t.classList;
if (!(kc.contains('toggle-card') || kc.contains('radio-card') || kc.contains('colour-card') || kc.contains('sim-card') || kc.contains('review-group-head'))) return;
var r = root(); if (!r || !r.contains(t)) return;
e.preventDefault(); t.click();
});
})();
function radio(group, value, selected, name, desc, price, image, who, badge) {
var shot = image || PART_IMAGES[value];
return '<div class="radio-card' + (selected ? ' selected' : '') + '" data-g="' + group + '" data-v="' + value + '" role="button" tabindex="0" aria-pressed="' + (selected ? 'true' : 'false') + '" onclick="' + fn('Pick') + "('" + group + "','" + value + '\')">'
+ '<div class="radio-dot"></div>'
+ (shot ? '<div class="radio-thumb">' + thumb(shot) + '</div>'
: (PART_ICON[group] && value !== 'none') ? '<div class="radio-thumb radio-thumb-icon">' + icon(PART_ICON[group], 22) + '</div>' : '')
+ '<div class="radio-info"><div class="radio-name">' + esc(name) + '</div>'
+ (who ? '<div class="radio-who">' + esc(who) + '</div>' : '')
+ (desc ? '<div class="radio-desc">' + esc(desc) + '</div>' : '')
+ (badge ? '<span class="radio-badge">' + esc(badge) + '</span>' : '')
+ '</div><div class="radio-price">' + esc(price || '') + '</div></div>';
}
function toggle(group, value, on, name, desc, image) {
var shot = image || PART_IMAGES[value];
return '<div class="toggle-card' + (on ? ' selected' : '') + '" data-g="' + group + '" data-v="' + value + '"'
+ ' role="switch" tabindex="0" aria-checked="' + (on ? 'true' : 'false') + '"'
+ ' onclick="' + fn('Pick') + "('" + group + "','" + value + '\')">'
+ '<div class="toggle-sw"><div class="toggle-knob"></div></div>'
+ (shot ? '<div class="radio-thumb">' + thumb(shot) + '</div>' : '')
+ '<div class="toggle-info"><div class="toggle-name">' + esc(name) + '</div>'
+ '<div class="toggle-desc">' + esc(desc) + '</div></div></div>';
}

function swatch(group, value, selected, name, bg, std) {
return '<div class="colour-card' + (selected ? ' selected' : '') + '" data-g="' + group + '" data-v="' + value + '" role="button" tabindex="0" aria-pressed="' + (selected ? 'true' : 'false') + '" onclick="' + fn('Pick') + "('" + group + "','" + value + '\')">'
+ '<div class="colour-swatch" style="background:' + bg + '">' + (std ? '<div class="colour-tag">Included</div>' : '') + '</div>'
+ '<div class="colour-name">' + esc(name) + '</div></div>';
}
function head(step, eyebrow, title, desc) {
return '<div class="section-eyebrow text-3xs">' + eyebrow + '</div><h2 class="section-title">' + esc(title) + '</h2>'
+ '<p class="section-desc text-sm">' + esc(desc) + '</p>';
}
var LIVE_ICONS = {
frame:    'https://cdn.shopify.com/s/files/1/0435/4631/2853/files/Formula_Pro_icon_8c6fa0a9-f510-42e6-a9df-4fbc1318c76c.png?v=1774877442',
chassis:  'https://cdn.shopify.com/s/files/1/0435/4631/2853/files/Formula_Pro_icon_8c6fa0a9-f510-42e6-a9df-4fbc1318c76c.png?v=1774877442',
cockpit:  'https://cdn.shopify.com/s/files/1/0435/4631/2853/files/Formula_Pro_icon_8c6fa0a9-f510-42e6-a9df-4fbc1318c76c.png?v=1774877442',
base:     'https://cdn.shopify.com/s/files/1/0435/4631/2853/files/FFB_Icon_97cf4615-9cef-41ab-85a4-9a166f3eda57.png?v=1774877563',
pedals:   'https://cdn.shopify.com/s/files/1/0435/4631/2853/files/Pedals_SVG.png?v=1774878932',
wheel:    'https://static.thenounproject.com/png/4957636-200.png',
display:  'https://static.thenounproject.com/png/4271626-200.png',
warranty: 'https://static.thenounproject.com/png/64108-200.png'
};
var LIVE_ICON_FILTER = 'invert(40%) sepia(90%) saturate(500%) hue-rotate(165deg)';
var ICONS = {
wheel:    '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/><path d="M12 3v6M4.6 17l5.2-3M19.4 17l-5.2-3"/>',
base:     '<rect x="3" y="8" width="11" height="8" rx="2"/><path d="M14 12h4M18 9v6"/><circle cx="20.5" cy="12" r="1.5"/>',
pedals:   '<path d="M5 19V9l4-3v10z"/><path d="M13 19v-7l5-3v7z"/><path d="M3 21h18"/>',
display:  '<rect x="2" y="5" width="20" height="11" rx="2"/><path d="M8 20h8M12 16v4"/>',
ddu:      '<rect x="3" y="7" width="18" height="10" rx="2"/><path d="M7 11h4M7 14h8M15 11h2"/>',
seat:     '<path d="M7 4h6a2 2 0 0 1 2 2v7H7z"/><path d="M7 13h10a2 2 0 0 1 2 2v1H9a2 2 0 0 1-2-2z"/><path d="M9 16v4"/>',
frame:    '<path d="M3 17V9a2 2 0 0 1 2-2h5l4 4h5a2 2 0 0 1 2 2v4"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
chassis:  '<circle cx="6" cy="17" r="2.5"/><circle cx="18" cy="17" r="2.5"/><path d="M4 12h16M6 12V8h12v4M9 17h6"/>',
cockpit:  '<path d="M3 16c2-7 6-10 9-10s7 3 9 10z"/><path d="M8 16v3M16 16v3"/>',
computing:'<rect x="6" y="3" width="12" height="18" rx="2"/><path d="M9 7h6M9 11h6M11 16h2"/>',
software: '<rect x="2" y="4" width="20" height="14" rx="2"/><path d="M2 9h20M6 6.5h.01M9 6.5h.01"/>',
warranty: '<path d="M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6z"/><path d="M9 12l2 2 4-4"/>',
shipping: '<path d="M1 7h12v9H1z"/><path d="M13 10h4l3 3v3h-7z"/><circle cx="5.5" cy="18" r="1.8"/><circle cx="16.5" cy="18" r="1.8"/>',
colour:   '<path d="M12 3s6 6 6 10a6 6 0 0 1-12 0c0-4 6-10 6-10z"/>',
motion:   '<path d="M12 3v18M8 7l4-4 4 4M8 17l4 4 4-4"/>',
audio:    '<path d="M4 9v6h4l5 4V5L8 9z"/><path d="M17 8a5 5 0 0 1 0 8"/>',
shifter:  '<circle cx="12" cy="5" r="2"/><path d="M12 7v10"/><path d="M6 20h12"/>',
extras:   '<path d="M12 4v16M4 12h16"/>',
steering: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/><path d="M12 3v6M4.6 17l5.2-3M19.4 17l-5.2-3"/>',
install:  '<path d="M3 13l9-8 9 8"/><path d="M6 12v8h12v-8"/><path d="M10 20v-5h4v5"/>',
default:  '<circle cx="12" cy="12" r="9"/><path d="M12 8v4l3 2"/>'
};
var ICON_MATCH = [
[/steering|wheel base|^base$/i, null],
[/wheel base/i, 'base'], [/steering/i, 'wheel'], [/pedal/i, 'pedals'], [/ddu|digital display/i, 'ddu'],
[/display|screen|visual/i, 'display'], [/seat/i, 'seat'], [/chassis|kart/i, 'chassis'], [/cockpit/i, 'cockpit'],
[/frame|colour|color|finish|carbon/i, 'frame'], [/comput|pc/i, 'computing'], [/software/i, 'software'],
[/warrant/i, 'warranty'], [/motion|haptic/i, 'motion'], [/audio|sound/i, 'audio'], [/shift|gear/i, 'shifter'],
[/shipping|delivery/i, 'shipping'], [/install/i, 'install'], [/package|stage|option|extra/i, 'extras']
];
function iconKey(label) {
var l = String(label || '');
if (/wheel base/i.test(l)) return 'base';
if (/steering|^wheel$/i.test(l)) return 'wheel';
for (var i = 1; i < ICON_MATCH.length; i++) if (ICON_MATCH[i][0].test(l)) return ICON_MATCH[i][1];
return 'default';
}
function icon(label, size) {
var k = iconKey(label);
if (LIVE_ICONS[k]) {
return '<img class="spec-icon cpc-icon-img" src="' + LIVE_ICONS[k] + '" alt="" width="' + size + '" height="' + size + '"'
+ ' loading="lazy" decoding="async" style="width:' + size + 'px;height:' + size + 'px;object-fit:contain;filter:' + LIVE_ICON_FILTER + '">';
}
return '<svg class="cpc-icon" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" '
+ 'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS[k] + '</svg>';
}

function group(title, html) {
return '<div class="option-group"><div class="og-header"><div class="og-title">' + esc(title) + '</div></div>' + html + '</div>';
}

var SEAT_IMAGES = {
black:  F + 'Black-Formula-Seat.jpg?v=1774944539',
tan:    F + 'Tan-Formula-Seat.jpg?v=1774944537',
cognac: F + 'Cognac-Formula-Seat.jpg?v=1774944645',
custom: F + 'Seat-Samples.jpg?v=1774946384'
};
var STITCH_IMAGES = {
black:  F + 'Black-Stitching.jpg?v=1774945021',
red:    F + 'Red-Stitching.jpg?v=1774945022',
blue:   F + 'Blue-Stitching.jpg?v=1774945027',
orange: F + 'Stitching-Orange.jpg?v=1774945022',
white:  F + 'White-stitching.jpg?v=1774945485',
custom: F + 'Custom-stitching-colours.jpg?v=1776081722'
};
var TRICOLOURS = {
none:   ['Without',              '#1a1a1a', null],
wbb:    ['White, Black & Blue',  'linear-gradient(120deg,#FFFFFF 33%,#111111 33%,#111111 66%,#003087 66%)', F + 'BMW-Tricolour-Stitching.jpg?v=1774945027'],
gwr:    ['Green, White & Red',   'linear-gradient(120deg,#006B3F 33%,#FFFFFF 33%,#FFFFFF 66%,#CC0000 66%)', F + 'Tricolour-Stitching.jpg?v=1774945022'],
custom: ['Custom Colour',        'linear-gradient(135deg,#ff4060,#f0d040,#40c870,#38a0e0,#e040a0)',         F + 'Custom-stitching-colours.jpg?v=1776081722']
};
var SEAT_FINISHES = {
alcantara:  { name: 'Alcantara Seat Back', desc: 'Custom seat back finish', img: F + 'Alcantara-Seat_57d2efa5-7dac-44a5-bda5-942fe7645197.jpg?v=1774945865' },
embroidery: { name: 'Your Custom Embroidery',          desc: 'Custom logos or text', img: F + 'CP-Logo-Embroidery.jpg?v=1774945841' }
};
function hasSeatPhotos() { return state.sim === 'formula-pro' || state.sim === 'formula-sport'; }   // same formula seat, same photography

function ctaVerb(s) { return (s && s.discover) ? 'Discover' : 'Configure'; }
function steps() {
var s = sim(), out = [];
out.push({ key: 'sim',    title: 'Choose Simulator', next: ctaVerb(s) + ' ' + s.name + ' →', render: renderSimStep });
if (s.enquireOnly) {
out.push({ key: 'review', title: 'Enquire', next: null, render: renderEnquireStep });
out[0].next = 'Get in touch \u2192';
return out;
}
var hasHardware = !!s.components || s.packages.length > 1;
var staged = s.packages.length > 1;
out.push({ key: 'standard', title: 'Signature Specification', next: staged ? 'Next: Hardware →' : 'Next: Colour →', render: renderStandardStep });
if (staged) out.push({ key: 'spec', title: 'Hardware', next: 'Next: Colour →', render: renderSpecStep });
out.push({ key: 'colour',   title: 'Colour',                  next: hasHardware ? 'Next: Hardware →' : 'Next: Seat →', render: renderColourStep });
if (!s.noSeatStep) out.push({ key: 'seat', title: 'Seat', next: 'Next: Display →', render: renderSeatStep });
if (hasHardware && !staged) out.push({ key: 'spec', title: 'Hardware',   next: 'Next: Seat →',     render: renderSpecStep });
out.push({ key: 'display',   title: 'Display',   next: 'Next: Immersion →', render: renderDisplayStep });
out.push({ key: 'immersion', title: 'Immersion', next: 'Next: Extras →',    render: renderImmersionStep });
out.push({ key: 'extras',    title: 'Extras',    next: 'Review Your Build →', render: renderExtrasStep });
out.push({ key: 'review',    title: 'Review',    next: null, render: renderReviewStep });
for (var ni = 1; ni < out.length - 1; ni++) out[ni].next = out[ni + 1].key === 'review' ? 'Review Your Build →' : 'Next: ' + out[ni + 1].title + ' →';
return out;
}
var STEPS = [];
function stepIndex(key) { for (var i = 0; i < STEPS.length; i++) if (STEPS[i].key === key) return i; return 1; }
function stepNum(i) { return i; }

var dirty = {};
function buildPanels() {
STEPS = steps();
var wrap = $$('cpc-panels');
wrap.innerHTML = STEPS.map(function(st, i) {
return '<div class="step-panel' + (st.key === 'review' ? ' cpc-review' : '') + '" id="cpc-step-' + i + '-' + SID + '">'
+ '<div class="step-content" id="cpc-body-' + i + '-' + SID + '"></div></div>';
}).join('');
dirty = {};
STEPS.forEach(function(_, i) { dirty[i] = true; });
}
function markDirty(except) {
STEPS.forEach(function(_, i) { if (i !== except) dirty[i] = true; });
}
var warmed = {};
function warmPanel(i) {
var p = $$('cpc-step-' + i);
if (!p) return;
p.querySelectorAll('img').forEach(function(im) {
var src = im.getAttribute('src');
if (!src || warmed[src]) return;
warmed[src] = true;
var pre = new Image();
pre.decoding = 'async';
var ss = im.getAttribute('srcset');
if (ss) { pre.sizes = im.getAttribute('sizes') || ''; pre.srcset = ss; }
pre.src = src;
});
}
function renderPanel(i, animate) {
if (!dirty[i] || !STEPS[i]) return;
var body = $$('cpc-body-' + i);
if (!body) return;
body.innerHTML = STEPS[i].render();
body.classList.remove('cpc-entering');
if (STEPS[i] && STEPS[i].key === 'colour') bindWheel();
if (animate) {
void body.offsetWidth;
body.classList.add('cpc-entering');
clearTimeout(body._cpcEnterT);
body._cpcEnterT = setTimeout(function() { body.classList.remove('cpc-entering'); }, 500);
}
dirty[i] = false;
}

var simPicked = false;
function simUnpicked() { return !simPicked; }
function simNextLabel(st) { return st.key === 'sim' && simUnpicked() ? 'Choose a simulator' : st.next; }
function renderSimStep() {
var _un = simUnpicked();
return '<div class="cpc-step-top">'
+ '<div class="cpc-step-top-text">'
+ '<h1 class="section-eyebrow">' + esc(EYEBROW) + '</h1>'
+ '<h2 class="section-title title-sm tracking-heading">Choose Your Simulator</h2>'
+ '</div>'
+ '</div>'
+ '<p class="section-desc text-sm">Pick a simulator to see real builds we have delivered. Use the arrows on the photo to browse them, then start configuring yours.</p>'
+ '<div class="cpc-compare-bar"><button type="button" class="cpc-compare-btn" id="cpc-comparebtn-' + SID + '"'
+   ' onclick="' + fn('Compare') + '()"><span>Compare simulators</span>'
+   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button></div>'
+ '<div class="sim-grid">' + SIM_ORDER.map(function(k) {
var x = SIMS[k], ex = examples(k);
var on = state.sim === k && !_un;
return '<div class="sim-card' + (on ? ' selected' : '') + '" role="button" tabindex="0" aria-pressed="' + (on ? 'true' : 'false') + '" onclick="' + fn('Preview') + "('" + k + '\')">'
+ '<div class="sim-shot"><img src="' + sized(ex[0] ? ex[0].src : x.images[0], 240) + '" srcset="' + [240, 480, 720, 1080, 1440].map(function(w) { return sized(ex[0] ? ex[0].src : x.images[0], w) + ' ' + w + 'w'; }).join(', ') + '" sizes="(max-width: 700px) 100vw, 120px" alt="' + esc(x.name) + '" width="120" height="90" loading="lazy" decoding="async">'
+ '</div>'
+ '<div class="sim-card-body">'
+ '<div class="sim-card-head">'
+ '<div class="sim-card-name">' + esc(x.name) + '</div>'
+ (COMPARABLE.indexOf(k) > -1
? '<label class="sim-compare" onclick="event.stopPropagation()">'
+ '<input type="checkbox"' + (compareSel[k] ? ' checked' : '') + ' onchange="' + fn('CompareTick') + "('" + k + '\',this.checked)"><span>Compare</span></label>'
: '')
+ '</div>'
+ (x.proof ? '<ul class="sim-proof">' + x.proof.map(function(line) {
return '<li>' + esc(line) + '</li>';
}).join('') + '</ul>' : '')
+ '<div class="sim-card-price">From ' + priceFor(k, x.packages[0].id) + '</div>'
+ '</div></div>';
}).join('') + '</div>';
}
window['cpcPreview_' + SID] = function(k) {
if (!SIMS[k]) return;
if (state.sim === k) {
if (simPicked) return;
simPicked = true;
root().querySelectorAll('.sim-card').forEach(function(c) {
var on = c.getAttribute('onclick').indexOf("'" + k + "'") > -1;
c.classList.toggle('selected', on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
});
syncNav();
return;
}
simPicked = true;
var before = $$('cpc-step-' + currentStep);
var y = before ? before.querySelector('.step-content').scrollTop : 0;
resetState(k);
buildPanels();
renderPanel(currentStep);
root().querySelectorAll('.step-panel').forEach(function(panel, i) { panel.classList.toggle('active', i === currentStep); });
var after = $$('cpc-step-' + currentStep);
if (after) after.querySelector('.step-content').scrollTop = y;
renderSlideshow();
syncNav();   // "Configure X", the bottom-bar label and Learn more follow the card you clicked
try { var u = new URL(location.href); u.searchParams.set('sim', k); history.replaceState(null, '', u); } catch (e) {}
};
function syncNav() {
var st = STEPS[currentStep]; if (!st) return;
var next = $$('cpc-next'); if (next && st.next) next.textContent = simNextLabel(st);
var vc = $$('cpc-viewer-cta'); if (vc) vc.textContent = st.key === 'sim' ? simUnpicked() ? 'Choose a simulator' : ctaVerb(sim()) + ' ' + sim().name + ' \u2192' : 'Submit Your Build \u2192';
placeForm(st.key === 'review');
var ln = $$('cpc-learn'); if (ln) { ln.setAttribute('aria-label', 'Compare the simulators'); }
}
function refShown() { return !helpMode && !!currentRef && currentRef.indexOf('HELP') !== 0 && !sim().enquireOnly; }
window['cpcCopyRef_' + SID] = function(btn) {
var v = refShown() ? currentRef : '', lbl = btn && btn.querySelector('.rv-spec-lbl');
if (!v || !btn) return;
track('cfg_copy_spec');
function done() {
btn.classList.add('copied'); if (lbl) lbl.textContent = 'Copied';
clearTimeout(btn._cpcT); btn._cpcT = setTimeout(function() { btn.classList.remove('copied'); if (lbl) lbl.textContent = 'Copy'; }, 1800);
}
var ok = false, ta = document.createElement('textarea');
ta.value = v; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.top = '0'; ta.style.opacity = '0';
document.body.appendChild(ta); ta.select();
try { ok = document.execCommand('copy'); } catch (e) {}
document.body.removeChild(ta);
if (ok) done();
else if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(done, function() {});
};
function msgMode() {
var card = document.getElementById('cpc-modal-card-' + SID);
if (!card) return;
var mc = card.querySelector('.globo-form-control[data-element-id="textarea-2"]'), tg = card.querySelector('.cpc-msg-toggle');
if (!mc || !tg) return;
var ta = mc.querySelector('textarea'), cb = tg.querySelector('input');
var open = helpMode || !!sim().enquireOnly;
tg.style.display = open ? 'none' : '';
if (open) { mc.classList.remove('cpc-msg-hidden'); if (ta) ta.setAttribute('placeholder', ''); return; }
if (ta && ta.value && !cb.checked) cb.checked = true;
mc.classList.toggle('cpc-msg-hidden', !cb.checked);
if (ta) ta.setAttribute('placeholder', 'Add any additional message, your build is already attached');
}
function showRef() {
var on = refShown();
labelSubmit();
msgMode();
root().querySelectorAll('.rv-spec').forEach(function(b) {
b.hidden = !on;
var c = b.querySelector('.rv-spec-code'); if (c && on) c.textContent = currentRef;
});
var w = $$('cpc-rf-spec');
if (!w) return;
var pane = $$('cpc-reviewform'), msg = pane && !pane.hidden ? pane.querySelector('.globo-form-control[data-element-id="textarea-2"]') : null;
if (msg) { if (msg.nextSibling !== w) msg.parentNode.insertBefore(w, msg.nextSibling); }
else {
var head = pane && pane.querySelector('.rf-head');
if (head && w.parentNode !== head) head.appendChild(w);
if (on && pane && !pane.hidden && (showRef._n = (showRef._n || 0) + 1) < 30) setTimeout(showRef, 250);
on = false;
}
w.hidden = !on;
}
function setFormHead() {
showRef();
var e = $$('cpc-rf-eyebrow'), t = $$('cpc-rf-title'), u = $$('cpc-rf-sub');
if (!t) return;
if (!helpMode && sim().enquireOnly) {
if (e) e.textContent = 'Start your project';
t.textContent = 'Get In Touch';
if (u) u.textContent = 'A specialist replies within 24 hours to talk through the build, the timings and your price.';
return;
}
if (helpMode) {
if (e) e.textContent = 'Find your simulator';
t.textContent = 'Tell us what you need';
if (u) u.textContent = 'Tell us how you will use it and a specialist replies within 24 hours with the right simulator and your price.';
} else {
if (e) e.textContent = 'Get your quote';
t.textContent = 'Get A Quote';
if (u) u.textContent = 'Add your details and a specialist will reply within 24 hours with your price for this build.';
}
}
window['cpcHelp_' + SID] = function() {
helpMode = true; currentRef = null;
track('cfg_help');
setFormHead();
window['cpcOpenEnquiry_' + SID]();
};
window['cpcViewerCta_' + SID] = function() {
if (STEPS[currentStep] && STEPS[currentStep].key === 'sim') window['cpcNext_' + SID]();
else window['cpcOpenEnquiry_' + SID]();
};
window['cpcStart_' + SID] = function(k) {
helpMode = false; currentRef = null;
simPicked = true;
if (state.sim !== k) { resetState(k); buildPanels(); }
track('cfg_start');
setFormHead();
try { var u = new URL(location.href); u.searchParams.set('sim', k); history.replaceState(null, '', u); } catch (e) {}
showStep(1);
};

function renderStandardStep() {
var s = sim(), p = pkg();
var h = '<div class="section-eyebrow">' + esc(s.name) + '</div>'
+ '<h2 class="section-title title-sm tracking-heading">Signature Specification</h2>'
+ '<div class="cpc-price">From ' + priceFor(state.sim, s.packages[0].id) + '</div>'
+ '<p class="section-desc text-sm">Every ' + esc(s.name) + ' ships fully assembled and race-ready, built to this specification.</p>';
var basePreset = (s.packages.length > 1 && s.packages[0].preset) ? s.packages[0].preset : null, stdImg = {};
var hw = (!p.spec && s.components) ? s.components.map(function(c) {
var v = basePreset ? basePreset[c.id] : state.comp[c.id], o = compLabel(c, v);
if (o) stdImg[c.title.toLowerCase()] = partImg(v);
return o && o[1] !== 'None' ? [c.title, o[1]] : null; }).filter(Boolean) : [];
var DROP = /^(display|warranty|shipping|international shipping|delivery)$/i;
var stagedSim = s.packages.length > 1;
var standard = stagedSim
? [['Frame', 'Powder-coated aluminium, handbuilt in the UK to ISO 9001'],
['Seat', s.seat || ''],
['Hardware', 'Choose from Stage 1, 2 and 3'],
['Computing', 'Full PC included'],
['Seating & Pedals', 'Adjustable seating and pedals']].filter(function(r) { return r[1]; })
: hw.concat((p.spec || []).filter(function(r) { return !DROP.test(r[0]); }))
.concat((s.common || []).filter(function(r) { return !DROP.test(r[0]); }));
var ORDER = ['frame', 'chassis', 'seat', 'wheel base', 'steering wheel', 'pedals',
'pedal actuation', 'computing', 'software'];
standard.sort(function(a, b) {
var ia = ORDER.indexOf(String(a[0]).toLowerCase()), ib = ORDER.indexOf(String(b[0]).toLowerCase());
if (ia === -1) ia = 99; if (ib === -1) ib = 99;
return ia - ib;
});
if (standard.length) h += '<div class="spec-grid">' + standard.map(function(r) {
var k = r[0].toLowerCase(), im = (k in stdImg) ? stdImg[k] : imgFor(r[0]);
return '<div class="spec-card spec-card-locked' + (im ? ' has-photo' : '') + '">'
+ (im ? '<div class="spec-photo' + photoFit(im, r[0]) + '"><img src="' + sized(im, 300) + '" srcset="' + [300, 450, 600, 800].map(function(w) { return sized(im, w) + ' ' + w + 'w'; }).join(', ') + '" sizes="(max-width: 700px) 45vw, 22vw" alt="" decoding="async"></div>' : icon(r[0], 26))
+ '<div class="spec-label">' + esc(r[0]) + '</div><div class="spec-name">' + esc(r[1]) + '</div></div>';
}).join('') + '</div>';
return h;
}

var COMP_STATS = {
'cps-formula':   'Our flagship formula wheel. The best we offer, fitted to every Formula Pro',
'cps-gt':        'Our flagship GT wheel, in carbon. The best we offer, fitted to every GT Pro',
'csx3':          '4″ touch display, carbon fibre face, magnetic shifters',
'lm-pro':        'Replica GT3 wheel with the look and feel of a modern GT car',
'cube-gt':       'Cube Controls GT wheel',
'gpx':           'F1-style formula wheel',
'gsv2p':         'MOZA formula wheel, entry level',
'bodnar':        '26Nm direct drive, CP-S tuned. The strongest and most detailed feedback we fit',
'sc-ultimate':   '32Nm direct drive',
'sc-sport':      '15Nm direct drive',
'sc-pro':        '25Nm direct drive',
'r12':           '12Nm direct drive, entry level',
'moza':          '12Nm direct drive, entry level',
'ks':            'MOZA GT wheel, entry level',
'crp2':          'Load cell brake, entry level',
'sprint':        'Load cell brake, adjustable stiffness',
'cps-hydraulic': 'True hydraulic braking, AP Racing master cylinder, 200kg of feel. What our professional drivers use',
'cps-custom':    'True hydraulic braking, AP Racing master cylinder, 200kg of feel. What our professional drivers use'
};
function renderSpecStep() {
var s = sim(), p = pkg(), mixed = isMixed(), multi = s.packages.length > 1, i = stepIndex('spec');
var h = head(i, 'Hardware', multi ? 'Choose Your Package' : 'Change Your Hardware',
multi ? 'Start from a stage, then swap any component.' : 'Everything above is included. Swap any component below if you want something different.');
if (multi) {
h += group('Package', '<div class="radio-group">' + s.packages.map(function(x) {
var st = STAGE_COPY[x.id] || {};
var desc = x.custom ? 'Choose every component yourself' : (st.desc || '');
return radio('pkg', x.id, x.custom ? isCustom() : (x.id === state.pkg && !mixed), x.name, desc, x.custom ? priceFor(state.sim, x.id) : 'From ' + priceFor(state.sim, x.id), null, st.who, st.badge);
}).join('') + '</div>');
}
if (s.components) {
s.components.forEach(function(c) {
if (c.id === 'ddu' && ddueBuiltIn()) {
h += group(c.title, '<p class="cpc-note">The CP-S wheel has its display built in, so no separate DDU is needed.</p>');
return;
}
h += group(c.title, '<div class="radio-group">' + c.options.map(function(o) {
return radio('comp:' + c.id, o[0], state.comp[c.id] === o[0], o[1], COMP_STATS[o[0]] || '', o[2] || '');
}).join('') + '</div>');
});
if (mixed && multi) h += '<p class="cpc-note">Changing a component makes this a Custom Hardware Spec. <a href="#" onclick="' + fn('Pick') + "('pkg','" + basePkg().id + "');return false\">Reset to " + esc(basePkg().name) + '</a></p>';
}
if (s.displays && s.displays.length > 1) {
h += group('Display', '<div class="radio-group">' + s.displays.map(function(k) {
return radio('display', k, state.display === k, DISPLAYS[k].name, DISPLAYS[k].desc,
includedAt(k), displayImg(k), DISPLAY_FOR[k]);
}).join('') + '</div>');
}
if (!s.components) {
h += '<p class="cpc-note">The hardware on this model is fixed. Anything bespoke is handled by our Bespoke Projects team, which you can add under Extras.</p>';
}
return h;
}

function renderColourStep() {
var s = sim(), i = stepIndex('colour');
var h = head(i, 'Frame Colour', s.colourRequired ? 'Choose Your Colour' : 'Finish Your Frame',
s.colourRequired ? 'The ' + s.name + ' is finished in a colour of your choosing.'
: 'Every frame is powder coated to order. Pick a colourway, or go fully custom.');
h += group('Colour Options', '<div class="colour-grid">'
+ swatch('colour', 'standard', state.colour === 'standard', colourName('standard'), COLOURWAYS[0][2], true)
+ COLOURWAYS.slice(1).filter(function(c) { return !s.colours || s.colours.indexOf(c[0]) > -1; }).map(function(c) {
return swatch('colour', c[0], state.colour === c[0], c[1], c[2], false);
}).join('') + '</div>');
if (state.colour === 'custom') {
if (!customHex()) state.customHex = CUSTOM_START;
var twoTone = state.sim === 'formula-pro';
var hx = (twoTone && state.customTarget === 'inner' ? innerCustomHex() : customHex()) || CUSTOM_START;
var live = !!RECOLOUR_BASE[state.sim];
if (twoTone) {
h += group('Frame Areas', '<div class="cpc-target">'
+ [['outer', 'Outer frame', customHex() || CUSTOM_START],
['inner', 'Centre panel', innerCustomHex() || INNER_START]].map(function(t) {
return '<button type="button" class="cpc-target-btn' + (state.customTarget === t[0] ? ' on' : '') + '"'
+ ' onclick="' + fn('CustomTarget') + "('" + t[0] + '\')">'
+ '<span class="cpc-target-chip" style="background:' + esc(t[2]) + '"></span>'
+ '<span class="cpc-target-name">' + esc(t[1]) + '</span>'
+ '<span class="cpc-target-hex">' + esc(t[2].toUpperCase()) + '</span></button>';
}).join('') + '</div>');
}
h += group(twoTone ? (state.customTarget === 'inner' ? 'Centre Panel Colour' : 'Outer Frame Colour') : 'Your Colour', '<div class="cpc-wheelwrap">'
+ '<canvas class="cpc-wheel" id="cpc-wheel-' + SID + '" width="220" height="220" role="slider"'
+   ' aria-label="Frame colour wheel" tabindex="0"></canvas>'
+ '<div class="cpc-wheelside">'
+   '<div class="cpc-pick-row">'
+     '<span class="cpc-pick-chip" id="cpc-pickchip-' + SID + '" style="background:' + esc(hx) + '"></span>'
+     '<label class="cpc-hexfield"><span class="cpc-field-label">Colour</span>'
+       '<input type="text" class="cpc-pick-hex" id="cpc-pickhex-' + SID + '" value="' + esc(hx.toUpperCase()) + '" maxlength="7" spellcheck="false" aria-label="Frame colour hex code"'
+       ' oninput="' + fn('CustomColour') + '(this.value, false)">'
+     '</label>'
+   '</div>'
+   '<label class="cpc-lightness"><span class="cpc-field-label">Shade</span>'
+     '<input type="range" id="cpc-light-' + SID + '" min="8" max="92" value="50" aria-label="Lightness" style="--c:' + esc(hx) + '">'
+   '</label>'
+ '</div></div>'
+ (!SHOW_FINISHES ? '' : '<div class="cpc-finishes">' + FINISH_OPTS.map(function(f) {
return '<button type="button" class="cpc-finish' + (targetFinish() === f[0] ? ' on' : '') + '"'
+ ' data-f="' + f[0] + '" title="' + esc(f[2]) + '" onclick="' + fn('CustomFinish') + '(\'' + f[0] + '\')">'
+ '<span class="cpc-finish-dot fin-' + f[0] + '" style="--c:' + esc(hx) + '"></span>' + esc(f[1]) + '</button>';
}).join('') + '</div>')
+ '<p class="cpc-note">' + (live
? 'Drag around the wheel to preview the colour on your ' + esc(s.name) + '.'
: 'Pick the colour you have in mind. Paint is matched to any code or sample you send us.') + '</p>');
}
if (!s.noCarbon) h += group('Carbon Fibre', toggle('carbon', '1', state.carbon, FINISHES.carbon.name, FINISHES.carbon.desc, CARBON_BACKPLATE)
+ (state.carbon ? '<p class="cpc-note">Carbon spacers included. Carbon frame panels on request.</p>' : ''));
return h;
}

function drawWheel(cv) {
var w = cv.width, h = cv.height, r = w / 2, x = cv.getContext('2d');
var img = x.createImageData(w, h), d = img.data;
for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
var dx = xx - r + .5, dy = yy - r + .5, dist = Math.sqrt(dx*dx + dy*dy), i = (yy*w + xx) * 4;
if (dist > r) { d[i+3] = 0; continue; }
var ang = Math.atan2(dy, dx) * 180 / Math.PI; if (ang < 0) ang += 360;
var rgb = hslRgb(ang, Math.min(1, dist / (r - 1)), 0.5);
d[i] = rgb[0]*255; d[i+1] = rgb[1]*255; d[i+2] = rgb[2]*255;
d[i+3] = dist > r - 1.2 ? Math.round(255 * (r - dist) / 1.2) : 255;   // soft rim
}
x.putImageData(img, 0, 0);
}
function markWheel(cv, hex) {
var hs = hexHsl(hex), r = cv.width / 2, x = cv.getContext('2d');
drawWheel(cv);
var a = hs[0] * Math.PI / 180, rad = Math.min(1, hs[1]) * (r - 2);
var px = r + Math.cos(a) * rad, py = r + Math.sin(a) * rad;
x.beginPath(); x.arc(px, py, 8, 0, Math.PI*2);
x.strokeStyle = 'rgba(0,0,0,.55)'; x.lineWidth = 4; x.stroke();
x.strokeStyle = '#fff'; x.lineWidth = 2; x.stroke();
}
function wheelPick(cv, ev) {
var b = cv.getBoundingClientRect(), r = cv.width / 2;
var cx = (ev.clientX - b.left) * (cv.width / b.width) - r;
var cy = (ev.clientY - b.top) * (cv.height / b.height) - r;
var dist = Math.sqrt(cx*cx + cy*cy);
var ang = Math.atan2(cy, cx) * 180 / Math.PI; if (ang < 0) ang += 360;
var sat = Math.min(1, dist / (r - 2));
var l = document.getElementById('cpc-light-' + SID);
var lig = l ? parseInt(l.value, 10) / 100 : 0.5;
var rgb = hslRgb(ang, sat, lig);
return '#' + [0,1,2].map(function(k) {
var v = Math.round(rgb[k] * 255).toString(16); return v.length < 2 ? '0' + v : v;
}).join('');
}
function targetHex() {
return (state.sim === 'formula-pro' && state.customTarget === 'inner')
? (innerCustomHex() || INNER_START) : (customHex() || CUSTOM_START);
}
function bindWheel() {
var cv = document.getElementById('cpc-wheel-' + SID);
if (!cv || cv._bound) return;
cv._bound = true;
markWheel(cv, targetHex());
var light = document.getElementById('cpc-light-' + SID);
if (light) {
var hs0 = hexHsl(targetHex());
light.value = String(Math.round(hs0[2] * 100));
light.addEventListener('input', function() {
var cur = hexHsl(targetHex());
var rgb = hslRgb(cur[0], cur[1], parseInt(light.value, 10) / 100);
window['cpcCustomColour_' + SID]('#' + [0,1,2].map(function(k) {
var v = Math.round(rgb[k] * 255).toString(16); return v.length < 2 ? '0' + v : v;
}).join(''), true);
});
}
var down = false;
cv.addEventListener('pointerdown', function(e) { down = true; cv.setPointerCapture(e.pointerId); window['cpcCustomColour_' + SID](wheelPick(cv, e), true); });
cv.addEventListener('pointermove', function(e) { if (down) window['cpcCustomColour_' + SID](wheelPick(cv, e), true); });
cv.addEventListener('pointerup', function() { down = false; });
cv.addEventListener('pointercancel', function() { down = false; });
cv.addEventListener('keydown', function(e) {
var step = e.key === 'ArrowRight' ? 6 : e.key === 'ArrowLeft' ? -6 : 0;
if (!step) return;
e.preventDefault();
var cur = hexHsl(targetHex());
var rgb = hslRgb((cur[0] + step + 360) % 360, cur[1], cur[2]);
window['cpcCustomColour_' + SID]('#' + [0,1,2].map(function(k) {
var v = Math.round(rgb[k] * 255).toString(16); return v.length < 2 ? '0' + v : v;
}).join(''), true);
});
}

window['cpcCustomFinish_' + SID] = function(f) {
if (state.sim === 'formula-pro' && state.customTarget === 'inner') state.innerFinish = f;
else state.customFinish = f;
var wrap = root().querySelector('.cpc-finishes');
if (wrap) [].forEach.call(wrap.children, function(b) { b.classList.toggle('on', b.getAttribute('data-f') === f); });
state.lastPick = { step: 'colour', g: 'colour', v: 'custom' };
markDirty(currentStep);
renderSlideshow(); renderSummary();
};
var pickTimer = null;
window['cpcCustomTarget_' + SID] = function(which) {
if (state.customTarget === which) return;
state.customTarget = which;
if (which === 'inner' && !innerCustomHex()) state.innerHex = INNER_START;
markDirty(-1);
dirty[currentStep] = true;
renderPanel(currentStep);
renderSlideshow();
};
window['cpcCustomColour_' + SID] = function(v, fromPicker) {
v = String(v || '').trim();
if (v && v.charAt(0) !== '#') v = '#' + v;
if (state.sim === 'formula-pro' && state.customTarget === 'inner') state.innerHex = v;
else state.customHex = v;
var ok = /^#([0-9a-f]{6})$/i.test(v);
var chip = document.getElementById('cpc-pickchip-' + SID);
if (chip && ok) chip.style.background = v;
if (ok) {
var tb = root().querySelector('.cpc-target-btn.on');
if (tb) {
tb.querySelector('.cpc-target-chip').style.background = v;
tb.querySelector('.cpc-target-hex').textContent = v.toUpperCase();
}
}
var cv = document.getElementById('cpc-wheel-' + SID);
if (cv && ok) markWheel(cv, v);
if (fromPicker) {
var t = document.getElementById('cpc-pickhex-' + SID);
if (t && document.activeElement !== t) t.value = v.toUpperCase();
} else if (ok) {
var l2 = document.getElementById('cpc-light-' + SID);
if (l2 && document.activeElement !== l2) l2.value = String(Math.round(hexHsl(v)[2] * 100));
}
state.lastPick = { step: 'colour', g: 'colour', v: 'custom' };
clearTimeout(pickTimer);
pickTimer = setTimeout(function() { if (customHex()) { markDirty(currentStep); renderSlideshow(); renderSummary(); } }, 260);
};

function isGTSeat() { return state.sim === 'gt-pro' || state.sim === 'gt-sport'; }
var GT_CARBON_SEAT = F + 'Carbon-Seat-Colours.jpg?v=1790141602';
var GT_CARBON_SHELL = F + 'Carbon-Seat-Shell.jpg?v=1790142625';
var OWN_SEAT_IMG = F + 'GT3RS-Seat.jpg?v=1790245795';
function isCarbonSeat() { return state.seatType === 'carbon' || state.seatType === 'shell'; }
function isOwnSeat() { return state.seatType === 'own'; }
function carbonSeatImg() { return state.seatType === 'shell' ? GT_CARBON_SHELL : GT_CARBON_SEAT; }
function carbonSeatName() { return state.seatType === 'shell' ? 'Carbon Shell Seat' : 'Carbon Fibre Bucket Seat'; }
function seatTypeName() { return isOwnSeat() ? 'Your Own Seat' : carbonSeatName(); }
function renderSeatStep() {
var s = sim(), i = stepIndex('seat');
if (!s.seatCustom) {
return head(i, 'Seat', 'Your Seat',
'Every ' + esc(s.name) + ' is fitted with the ' + esc(s.seat) + '.')
+ group('Included', '<div class="spec-grid"><div class="spec-card spec-card-locked' + (SEAT_IMG[state.sim] ? ' has-photo' : '') + '">'
+ (SEAT_IMG[state.sim] ? '<div class="spec-photo' + photoFit(SEAT_IMG[state.sim], 'Seat') + '"><img src="' + sized(SEAT_IMG[state.sim], 300) + '" srcset="' + [300, 450, 600, 800].map(function(w) { return sized(SEAT_IMG[state.sim], w) + ' ' + w + 'w'; }).join(', ') + '" sizes="(max-width: 700px) 45vw, 22vw" alt="" decoding="async"></div>' : icon('Seat', 26)) + '<div class="spec-label">Seat</div><div class="spec-name">' + esc(s.seat) + '</div></div></div>')
+ '<p class="cpc-note">Upholstery, stitching and materials on this model are handled by our Bespoke Projects team. Add it under Extras and we will talk it through with you.</p>';
}
if (isGTSeat()) {
var carbon = isCarbonSeat();
var g = head(i, 'Seat', 'Choose Your Seat',
'Every ' + esc(s.name) + ' comes with the ' + esc(s.seat) + '. Upgrade to a carbon fibre seat, with your choice of stitching.');
g += group('Seat', '<div class="radio-group">'
+ radio('seatType', 'standard', state.seatType === 'standard', s.seat, 'Fitted to every ' + s.name, 'Included', SEAT_IMG[state.sim])
+ radio('seatType', 'shell', state.seatType === 'shell', 'Carbon Shell Seat', 'Full carbon fibre shell, suede inserts', 'Upgrade', GT_CARBON_SHELL)
+ radio('seatType', 'own', state.seatType === 'own', 'Your Own Seat', 'We have fitted genuine seats from McLaren and Ferrari. Send us yours and we engineer the mounts around it', 'POA', OWN_SEAT_IMG)
+ '</div>');
if (isOwnSeat()) {
g += '<p class="cpc-note">The seat in the photograph is a genuine Porsche GT3 RS seat, fitted to a customer\'s simulator. We have done the same with McLaren and Ferrari seats. Tell us what you would like to use and we will engineer the mounting around it.</p>';
}
if (carbon) {
g += group('Custom Stitching', toggle('stitchCustom', '1', state.stitchCustom,
'Custom Stitching', 'Stitching in a colour of your choosing, matched on your quote', STITCH_IMAGES.red || null));
}
return g;
}
var h = head(i, 'Seat Customisation', 'Customise Your Seat',
'Every ' + esc(s.name) + ' is fitted with the ' + esc(s.seat) + '. Choose an upholstery colour and stitching finish, or keep the signature black.');
h += group('Seat Colour', '<div class="colour-grid">' + Object.keys(SEAT_COLOURS).map(function(k) {
return swatch('seatColour', k, state.seatColour === k, SEAT_COLOURS[k], SEAT_SWATCH[k], k === 'black');
}).join('') + '</div>');
h += group('Stitching', '<div class="colour-grid">' + Object.keys(STITCH_COLOURS).map(function(k) {
return swatch('stitching', k, state.stitching === k, STITCH_COLOURS[k], STITCH_SWATCH[k], k === 'black');
}).join('') + '</div>');
h += group('Tricolour Stitching', '<div class="colour-grid">' + Object.keys(TRICOLOURS).map(function(k) {
return swatch('tricolour', k, state.tricolour === k, TRICOLOURS[k][0], TRICOLOURS[k][1], k === 'none');
}).join('') + '</div>');
h += group('Seat Finishes', '<div class="toggle-grid">' + Object.keys(SEAT_FINISHES).map(function(k) {
return toggle('seatFinish', k, !!state.seatFinish[k], SEAT_FINISHES[k].name, SEAT_FINISHES[k].desc, SEAT_FINISHES[k].img);
}).join('') + '</div>');
return h;
}

var DISPLAY_PHOTOS = {};
function displayImg(k) { var m = DISPLAY_PHOTOS[state.sim]; return (m && m[k]) || (DISPLAYS[k] && DISPLAYS[k].img) || null; }
function renderDisplayStep() {
var s = sim(), std = stdDisplay(), staged = s.packages.length > 1;
function stagesWith(k) {
var n = s.packages.filter(function(x) { return !x.custom && x.display === k; }).map(function(x) { return x.name.replace('Stage ', ''); });
return n.length ? 'Included in Stage ' + (n.length > 1 ? n.slice(0, -1).join(', ') + ' & ' + n[n.length - 1] : n[0]) : '';
}
var p = pkg(), intro = 'Select the screen setup that suits your space and the immersion you want.';
if (staged && !p.custom && p.display && DISPLAYS[p.display]) intro = 'Your ' + p.name + ' includes the ' + DISPLAYS[p.display].name + '. Upgrade below if you want more.';
return head(stepIndex('display'), 'Visual Enhancements', 'Choose Your Display', intro)
+ group('Display Setup', '<div class="radio-group">' + s.displays.map(function(k) {
var tag = includedAt(k);
return radio('display', k, state.display === k, DISPLAYS[k].name, DISPLAYS[k].desc, tag, displayImg(k), DISPLAY_FOR[k]);
}).join('') + '</div>');
}

function renderImmersionStep() {
return head(stepIndex('immersion'), 'Immersive Enhancements', 'Motion, Haptics & Audio', 'Upgrades that bring you closer to being in a real car.')
+ group('Motion & Haptics', '<div class="radio-group">' + Object.keys(MOTION).map(function(k) {
return radio('motion', k, state.motion === k, MOTION[k].name, MOTION[k].desc, '', motionImg(k));
}).join('') + '</div>')
+ group('Audio', '<div class="radio-group">' + Object.keys(AUDIO).filter(function(k) { return k !== 'headset'; }).map(function(k) {
return radio('audio', k, state.audio === k, AUDIO[k].name, AUDIO[k].desc, '', AUDIO[k].img);
}).join('') + '</div>')
+ group('Headset', toggle('headset', '1', state.headset, AUDIO.headset.name, AUDIO.headset.desc, AUDIO.headset.img));
}

var KEYED_BASE = { 'formula-sport': F + 'Formula-Sport-Keyed-Base.png?v=1790227647' };
var RECOLOUR_BASE = {
'gt-pro':        { src: F + 'GT-Pro-Flipped-Web.jpg?v=1745490978', native: 'standard' },
'formula-sport': { src: F + 'Formula-Sport-Studio-Web.jpg?v=1790060182', native: 'papaya' },
'gt-sport':      { src: F + 'GT-Sport-Racing-Simulator-Cool-Performance-Racing-Simulators-2_f59f2b25.jpg?v=1750064741', native: 'standard' }
};
var FRAME_HEX = { standard: '#b3121b', stealth: '#1c1d20', navy: '#0b2f7a', brg: '#0c4a2c', white: '#d6d8dc',
yellow: '#d8ef1c', purple: '#4b1a86', cobalt: '#1d5fc4', papaya: '#ff7a1a' };
var recolourCache = {};
function hexHsl(h) { var r = parseInt(h.substr(1,2),16)/255, g = parseInt(h.substr(3,2),16)/255, b = parseInt(h.substr(5,2),16)/255; return rgbHsl(r,g,b); }
function rgbHsl(r, g, b) {
var mx = Math.max(r,g,b), mn = Math.min(r,g,b), l = (mx+mn)/2, d = mx-mn, h = 0, s = 0;
if (d) { s = l > .5 ? d/(2-mx-mn) : d/(mx+mn); h = mx === r ? (g-b)/d + (g < b ? 6 : 0) : mx === g ? (b-r)/d + 2 : (r-g)/d + 4; h *= 60; }
return [h, s, l];
}
function hslRgb(h, s, l) {
function f(n) { var k = (n + h/30) % 12, a = s * Math.min(l, 1-l); return l - a * Math.max(-1, Math.min(k-3, 9-k, 1)); }
return [f(0), f(8), f(4)];
}
var SHOW_FINISHES = location.search.indexOf('finishes=1') > -1;
var FINISH_OPTS = [
['gloss',    'Gloss',    'Deep shine, sharpest reflections'],
['satin',    'Satin',    'Soft sheen between gloss and matt'],
['matt',     'Matt',     'Flat, no reflection'],
['metallic', 'Metallic', 'Fine metallic flake that sparkles in the light']
];
if (location.search.indexOf('grade=1') > -1) FINISH_OPTS.push(['raw', 'Raw', 'No finish curve: shading straight from the photograph']);
function finishOf() { return state.customFinish || 'gloss'; }
function innerFinishOf() { return state.innerFinish || finishOf(); }
function targetFinish() {
return (state.sim === 'formula-pro' && state.customTarget === 'inner') ? innerFinishOf() : finishOf();
}
function finishName() { var f = FINISH_OPTS.filter(function(x) { return x[0] === finishOf(); })[0]; return f ? f[1] : 'Gloss'; }
var CUSTOM_START = '#17B5B4';   // jb 24 Sep: the picker opens on this teal
var INNER_START  = '#1C1D20';   // the centre panel on the signature black
function customHex() {
var v = String(state.customHex || '').trim();
return /^#([0-9a-f]{6})$/i.test(v) ? v : null;
}
function innerCustomHex() {
var v = String(state.innerHex || '').trim();
return /^#([0-9a-f]{6})$/i.test(v) ? v : null;
}
function recoloured(simKey, colour) {
var base = RECOLOUR_BASE[simKey];
var hex = colour === 'custom' ? customHex() : FRAME_HEX[colour];
if (!base || !hex || colour === base.native) return null;
return repaint(base.src, FRAME_HEX[base.native], hex, simKey + '|' + colour, colour === 'custom' ? finishOf() : 'gloss');
}
var FS_SEATS_KEY = { black: F + 'FS-Seat-Black-Keyed2.png?v=1790239660', tan: F + 'FS-Seat-Tan-Keyed2.png?v=1790239660', cognac: F + 'FS-Seat-Cognac-Keyed2.png?v=1790239660' };
var FS_SEATS_MAP = { black: F + 'Formula-Sport-Black-Seat-Web.jpg?v=1790082763', tan: F + 'Formula-Sport-Tan-Seat-Web.jpg?v=1790084626', cognac: F + 'Formula-Sport-Cognac-Seat-Web.jpg?v=1790085623' };
var FP_OUTER = { papaya: '#1c1d20', yellow: '#1c1d20' };
var FP_INNER = {
standard: '#1c1d20', stealth: '#bbbbbb', navy: '#1c1d20', cobalt: '#5aa9e0',
brg: '#0c4a2c', white: '#e9eaec', purple: '#1c1d20', papaya: '#ff7a1a', yellow: '#d8ef1c'
};
function innerHexFor() {
if (state.sim !== 'formula-pro') return null;
if (state.colour === 'custom') return state.innerHex && /^#[0-9a-f]{6}$/i.test(state.innerHex) ? state.innerHex : null;
return FP_INNER[state.colour] || null;
}
function outerHex() {
var h = state.colour === 'custom' ? customHex() : FRAME_HEX[state.colour];
if (state.sim === 'formula-pro' && FP_OUTER[state.colour]) h = FP_OUTER[state.colour];
return h;
}
var SEAT_TUNE = {
'formula-sport': { sat: 0.82 },
'formula-pro':   { sat: 0.26, hueIn: 4, hueOut: 11 }
};
var SEAT_NATIVE = {
'formula-pro': 'standard', 'gt-pro': 'standard', 'gt-sport': 'standard',
'formula-sport': 'papaya'
};
function recolouredSeat(src) {
var nat = SEAT_NATIVE[state.sim];
if (!nat || !src) return null;
if (String(src).indexOf('Seat-Samples') > -1) return null;
if (String(src).indexOf('Formula-Seat-Cutout') > -1 && state.sim !== 'formula-sport') return null;
var hex = outerHex();
if (!hex || state.colour === nat) return null;
var tune = SEAT_TUNE[state.sim] || {};
return repaint(src, FRAME_HEX[nat], hex, 'seat|' + src + '|' + state.colour,
state.colour === 'custom' ? finishOf() : 'gloss', tune.sat, tune.hueIn, tune.hueOut,
(String(src).indexOf('Keyed') > -1 ? innerHexFor() : null));
}
var NO_PAINT = {
'Formula-Sport-Studio-Web': [[0.40, 0.02, 0.80, 0.295]],   // the curved monitor, stopping clear of the frame bar beneath it
'Formula-Sport-Single-49-Inch-Screen-Web':   [[0.03, 0.03, 0.93, 0.36]],
'Formula-Sport-34-inch-screen-Web':          [[0.12, 0.11, 0.95, 0.40]],
'Formula-Sport-Triple-32-inch-screens-Web':  [[0.02, 0.03, 0.99, 0.42]],
'Formula-Sport-Triple-49-Web':               [[0.00, 0.07, 0.97, 0.45]],
'27-Inch-Screen-Web':      [[0.175, 0.285, 0.815, 0.520]],
'32-Inch-Screen-Web':      [[0.155, 0.280, 0.840, 0.520]],
'39-Inch-Screen-Web':      [[0.295, 0.300, 0.705, 0.500]],
'49-Inch-Screen-Web':      [[0.240, 0.265, 0.760, 0.500]],
'55-Inch-Ark-Screen-Web':  [[0.008, 0.220, 0.985, 0.530]]
};
function keepOut(srcUrl) {
var u = String(srcUrl || '');
for (var k in NO_PAINT) if (u.indexOf(k) > -1) return NO_PAINT[k];
return null;
}
var TONE_LUT = {};
function toneLUT(f) {
if (TONE_LUT[f]) return TONE_LUT[f];
var L = new Float32Array(1025);
for (var k = 0; k <= 1024; k++) {
var u = k / 1024;
if (f === 'raw') { L[k] = u; continue; }
if (f === 'matt') u = (0.5 + (u - 0.5) * 0.66) * 0.90 + 0.09;
else if (f === 'satin') u = (0.5 + (u - 0.5) * 0.88) * 0.97;
else {
u = u < 0.5 ? 0.5 * Math.pow(u * 2, 1.45)
: 1 - 0.5 * Math.pow((1 - u) * 2, 1.45);
u = u * 0.94 + 0.06;
}
L[k] = u;
}
return (TONE_LUT[f] = L);
}
var keyedCache = {};
var GRADE = { pop: 0.00, sh: 0.00, hl: 0.00, gain: 1.00,
vBright: 1.00, vContrast: 1.00, vSat: 1.00 };
var maskCache = {};
var maskGeom = {};   // photo+mask -> per-pixel region and luma histograms, colour independent
var pixCache = {};   // photo+mask -> the pristine photograph pixels, so a colour change skips decoding
function maskedRender(photoUrl, maskUrl, oHex, iHex) {
var k = 'M|' + photoUrl + '|' + oHex + '|' + (iHex || '-');
if (maskCache[k] && maskCache[k] !== 'pending') return maskCache[k];
if (maskCache[k] === 'pending') return null;
var ks = Object.keys(maskCache).filter(function(z) { return maskCache[z] !== 'pending'; });
if (ks.length > 14) for (var kd = 0; kd < ks.length - 12; kd++) delete maskCache[ks[kd]];
maskCache[k] = 'pending';
function cc(hex) {
var h = String(hex).replace('#', '');
var r = parseInt(h.slice(0,2),16)/255, g = parseInt(h.slice(2,4),16)/255, b = parseInt(h.slice(4,6),16)/255;
return { y: 0.299*r + 0.587*g + 0.114*b,
cb: -0.168736*r - 0.331264*g + 0.5*b, cr: 0.5*r - 0.418688*g - 0.081312*b };
}
var oC = cc(oHex), iC = iHex ? cc(iHex) : null;
var photo = new Image(); photo.crossOrigin = 'anonymous';
var mask = new Image(); mask.crossOrigin = 'anonymous';
var got = 0;
function ready() {
if (++got < 2) return;
try {
var ck = photoUrl + '|' + maskUrl + '|' + (iC ? 'two' : 'one');
var W, H, NP, c, x, d, p, md, cached = pixCache[ck];
if (cached) {
W = cached.W; H = cached.H; NP = W * H;
c = document.createElement('canvas'); c.width = W; c.height = H;
x = c.getContext('2d', { willReadFrequently: true });
d = x.createImageData(W, H); p = d.data;
p.set(cached.px);                       // fresh copy of the untouched photograph
md = null;
} else {
W = photo.naturalWidth; H = photo.naturalHeight; NP = W * H;
c = document.createElement('canvas'); c.width = W; c.height = H;
x = c.getContext('2d', { willReadFrequently: true });
x.drawImage(photo, 0, 0);
d = x.getImageData(0, 0, W, H); p = d.data;
var mc = document.createElement('canvas'); mc.width = W; mc.height = H;
var mx = mc.getContext('2d', { willReadFrequently: true });
mx.drawImage(mask, 0, 0, W, H);
md = mx.getImageData(0, 0, W, H).data;
}
var gk = photoUrl + '|' + maskUrl + '|' + (iC ? 'two' : 'one');
var q, i, mv, r, g, b, Y, reg;
var geom = cached ? cached.geom : maskGeom[gk];
if (!geom) {
var hY = [new Float32Array(1024), new Float32Array(1024)], nY = [0, 0];
var rg = new Uint8Array(NP);
for (q = 0; q < NP; q++) {
mv = md[q * 4];
if (mv < 64) { rg[q] = 255; continue; }
reg = (mv > 190 || !iC) ? 0 : 1;
rg[q] = reg;
i = q * 4;
Y = 0.299*(p[i]/255) + 0.587*(p[i+1]/255) + 0.114*(p[i+2]/255);
hY[reg][(Y * 1023) | 0]++; nY[reg]++;
}
geom = { rg: rg, hY: hY, nY: nY };
maskGeom = {};          // one photo is in play at a time; do not hoard 4MB per entry
maskGeom[gk] = geom;
pixCache = {};
pixCache[ck] = { W: W, H: H, px: new Uint8ClampedArray(p), geom: geom };
}
var rg = geom.rg, hY = geom.hY, nY = geom.nY;
function med(h, n) { var want = n / 2, acc = 0, z;
for (z = 0; z < 1024; z++) { acc += h[z]; if (acc >= want) return z / 1023; } return 0.5; }
var gain = [1, 1];
for (reg = 0; reg < 2; reg++) {
if (!nY[reg]) continue;
var m0 = med(hY[reg], nY[reg]); if (m0 < 0.02) m0 = 0.02;
var tg = (reg === 0 ? oC : iC).y / m0;
gain[reg] = tg < 0.55 ? 0.55 : tg > 1.9 ? 1.9 : tg;
}
for (q = 0; q < NP; q++) {
reg = rg[q];
if (reg === 255) continue;
var t = reg === 0 ? oC : iC;
i = q * 4; r = p[i]/255; g = p[i+1]/255; b = p[i+2]/255;
Y = (0.299*r + 0.587*g + 0.114*b) * gain[reg];
var nr = Y + 1.402*t.cr, ng = Y - 0.344136*t.cb - 0.714136*t.cr, nb = Y + 1.772*t.cb;
p[i]   = nr < 0 ? 0 : nr > 1 ? 255 : nr * 255;
p[i+1] = ng < 0 ? 0 : ng > 1 ? 255 : ng * 255;
p[i+2] = nb < 0 ? 0 : nb > 1 ? 255 : nb * 255;
}
x.putImageData(d, 0, 0);
maskCache[k] = c.toDataURL('image/png');
} catch (e) { maskCache[k] = photoUrl; }
slideKey = ''; refreshViewerNow();
}
photo.onload = ready; mask.onload = ready;
photo.onerror = function() { maskCache[k] = photoUrl; slideKey = ''; refreshViewerNow(); };
mask.onerror = photo.onerror;
photo.src = photoUrl; mask.src = maskUrl;
return null;
}
function keyedRender(srcUrl, oHex, iHex, oFin, iFin, strict) {
var k = 'K|' + srcUrl + '|' + oHex + '|' + (iHex || '-') + '|' + oFin + '|' + (iFin || '-');
if (keyedCache[k] && keyedCache[k] !== 'pending') return keyedCache[k];
if (keyedCache[k] === 'pending') return null;
var ks = Object.keys(keyedCache).filter(function(z) { return keyedCache[z] !== 'pending'; });
if (ks.length > 6) for (var kd = 0; kd < ks.length - 4; kd++) delete keyedCache[ks[kd]];
keyedCache[k] = 'pending';
var img = new Image(); img.crossOrigin = 'anonymous';
img.onload = function() {
try {
var W = img.naturalWidth, H = img.naturalHeight, NP = W * H;
var c = document.createElement('canvas'); c.width = W; c.height = H;
var x = c.getContext('2d', { willReadFrequently: true });
x.drawImage(img, 0, 0);
var d = x.getImageData(0, 0, W, H), p = d.data, i, q;
var aO = new Float32Array(NP), aI = new Float32Array(NP), L = new Float32Array(NP);
var hO = new Int32Array(1024), hI = new Int32Array(1024), nO = 0, nI = 0;
for (q = 0; q < NP; q++) {
i = q * 4;
var r = p[i] / 255, g = p[i+1] / 255, b = p[i+2] / 255;
var mx = r > g ? (r > b ? r : b) : (g > b ? g : b);
var mn = r < g ? (r < b ? r : b) : (g < b ? g : b);
L[q] = (mx + mn) / 2;
var red = r - (g > b ? g : b), grn = g - (r > b ? r : b);
var ao = red / 0.13, ai = grn / 0.13;
ao = ao < 0 ? 0 : ao > 1 ? 1 : ao;
ai = ai < 0 ? 0 : ai > 1 ? 1 : ai;
if (strict) {
var dd = mx - mn;
var sg = (dd === 0 ? 0 : (L[q] > 0.5 ? dd / (2 - mx - mn) : dd / (mx + mn)) - 0.70) / 0.20;
sg = sg < 0 ? 0 : sg > 1 ? 1 : sg;
ao *= sg; ai *= sg;
}
aO[q] = ao; aI[q] = ai;
if (ao > 0.9) { hO[(L[q] * 1023) | 0]++; nO++; }
if (ai > 0.9) { hI[(L[q] * 1023) | 0]++; nI++; }
}
if (!nO) { keyedCache[k] = srcUrl; refreshViewer(); return; }
function pct(h, n, f) { var want = f * n, acc = 0, z;
for (z = 0; z < 1024; z++) { acc += h[z]; if (acc >= want) return z / 1023; } return 1; }
function band(t, fin) {
if (fin === 'raw' || fin === 'gloss') { var lo0 = t.h[2] - (t.p95 - t.p5) / 2, hi0 = t.h[2] + (t.p95 - t.p5) / 2;
if (hi0 > 0.985) { lo0 -= hi0 - 0.985; hi0 = 0.985; }
if (lo0 < 0.015) { hi0 = Math.min(0.985, hi0 + (0.015 - lo0)); lo0 = 0.015; }
return { lo: lo0, rng: hi0 - lo0, sp: Math.max(.001, t.p95 - t.p5) }; }
var sp = Math.max(fin === 'matt' ? 0.26 : 0.30, (t.p95 - t.p5) * (fin === 'matt' ? 0.82 : fin === 'satin' ? 0.90 : 0.95));
var lo = t.h[2] - sp / 2, hi = t.h[2] + sp / 2;
if (hi > 0.97) { lo -= hi - 0.97; hi = 0.97; }
if (lo < 0.02) { hi = Math.min(0.97, hi + (0.02 - lo)); lo = 0.02; }
return { lo: lo, rng: hi - lo, sp: Math.max(.001, t.p95 - t.p5) };
}
if (oFin === 'gloss') oFin = 'raw';
if (iFin === 'gloss') iFin = 'raw';
var O = { h: hexHsl(oHex), p5: pct(hO, nO, .05), p95: pct(hO, nO, .95) };
var I = iHex && nI ? { h: hexHsl(iHex), p5: pct(hI, nI, .05), p95: pct(hI, nI, .95) } : null;
var oB = band(O, oFin), iB = I ? band(I, iFin || oFin) : null;
var oT = toneLUT(oFin), iT2 = toneLUT(iFin || oFin);
function gainOf(t, h, n) { var m = pct(h, n, .5); m = m > 0.02 ? m : 0.02;
var g = t.h[2] / m; return g < 0.72 ? 0.72 : g > 1.40 ? 1.40 : g; }
var oG = gainOf(O, hO, nO), iG = I ? gainOf(I, hI, nI) : 1;
for (q = 0; q < NP; q++) {
var wo = aO[q], wi = I ? aI[q] : 0;
if (wo < 0.004 && wi < 0.004) continue;
var tgt = wi > wo ? I : O, bd = wi > wo ? iB : oB;
var fn = wi > wo ? (iFin || oFin) : oFin, lut = wi > wo ? iT2 : oT;
var a = wi > wo ? wi : wo;
var nl, sat = tgt.h[1], u;
if (fn === 'raw') {
nl = L[q] * (wi > wo ? iG : oG);
} else {
u = (L[q] - tgt.p5) / bd.sp;
u = u < 0 ? 0 : u > 1 ? 1 : u;
u = lut[(u * 1024) | 0];
nl = bd.lo + u * bd.rng;
if (fn === 'matt') sat *= 0.78;
else if (fn === 'satin' && u > 0.88) {
var hot = (u - 0.88) / 0.12;
var amt = 0.08 * hot * hot;
nl = nl + (1 - nl) * amt; sat *= 1 - amt * 0.85;
}
if (fn === 'metallic') {
var nz = Math.sin(q * 12.9898 + 78.233) * 43758.5453, sp = nz - Math.floor(nz);
if (sp > 0.62) { nl += (sp - 0.62) / 0.38 * 0.115 * (0.4 + nl); sat *= 0.84; }
}
}
nl = nl < .02 ? .02 : nl > .985 ? .985 : nl;
var o = hslRgb(tgt.h[0], tgt.h[1] === 0 ? 0 : sat, nl);
i = q * 4;
p[i]   = p[i]   + (o[0] * 255 - p[i])   * a;
p[i+1] = p[i+1] + (o[1] * 255 - p[i+1]) * a;
p[i+2] = p[i+2] + (o[2] * 255 - p[i+2]) * a;
}
if (I) {
var st = hexHsl(iHex), sq, si, sr, sg, sb, sl2, so;
for (sq = 0; sq < NP; sq++) {
si = sq * 4; sr = p[si]; sg = p[si+1]; sb = p[si+2];
if (!(sg > sr * 1.18 && sg > sb * 1.18 && sg - (sr > sb ? sr : sb) > 14)) continue;
sl2 = (Math.max(sr, sg, sb) + Math.min(sr, sg, sb)) / 510;
so = hslRgb(st[0], st[1], sl2);
p[si] = so[0] * 255; p[si+1] = so[1] * 255; p[si+2] = so[2] * 255;
}
}
if (GRADE.pop || GRADE.sh || GRADE.hl || GRADE.gain !== 1) {
var lut = new Float32Array(256), yv, sm;
for (yv = 0; yv < 256; yv++) {
var y0 = yv / 255, sc = y0 * y0 * (3 - 2 * y0);
sm = y0 + (sc - y0) * GRADE.pop;                  // midtone contrast
sm = sm + GRADE.sh * (1 - sm) * (1 - sm) * (1 - sm);   // shadows: + lifts, - crushes
sm = sm + GRADE.hl * sm * sm * sm;                // highlights: + opens, - rolls off
sm = sm * GRADE.gain;
if (sm < 0) sm = 0;
if (sm > 0.94) sm = 0.94 + (sm - 0.94) * 0.55;    // shoulder: keeps white white
if (sm > 1) sm = 1;
lut[yv] = sm <= 0 ? 0 : sm / (y0 <= 0 ? 1 : y0);  // store the RATIO, not the value
}
for (q = 0; q < NP; q++) {
i = q * 4;
var Y = (p[i] * 0.2126 + p[i+1] * 0.7152 + p[i+2] * 0.0722) / 255;
if (Y <= 0.002) continue;
var f = lut[(Y * 255) | 0];
var rr = p[i] * f, gg = p[i+1] * f, bb = p[i+2] * f;
p[i]   = rr > 255 ? 255 : rr;
p[i+1] = gg > 255 ? 255 : gg;
p[i+2] = bb > 255 ? 255 : bb;
}
}
x.putImageData(d, 0, 0);
keyedCache[k] = c.toDataURL('image/png');
} catch (e) { keyedCache[k] = srcUrl; }
slideKey = '';            // the slide set is keyed by src, so clear it or the rebuild is skipped
refreshViewerNow();
};
img.onerror = function() { keyedCache[k] = srcUrl; slideKey = ''; refreshViewerNow(); };
queueRepaint(function() { img.src = srcUrl; });
return null;
}

function repaint(srcUrl, nativeHex, hex, tag, finish, satFloor, hueIn, hueOut, innerHex, innerFinish, maxW, keyHue) {
maxW = maxW || 1200;
finish = finish || 'gloss';
var sMin = satFloor || 0.14, sBand = satFloor ? 0.10 : 0.22;
var hIn = hueIn || 14, hOut = hueOut || 34;
var base = { src: srcUrl, native: null };
var key = tag + '|' + hex + '|' + finish + '|' + sMin + '|' + hOut + '|' + (innerHex || '-') + '|' + (innerFinish || '-') + '|' + maxW;
if (recolourCache[key] && recolourCache[key] !== 'pending') {
var hitV = recolourCache[key]; delete recolourCache[key]; recolourCache[key] = hitV;
return hitV;
}
if (recolourCache[key] === 'pending') return null;
var keys = Object.keys(recolourCache).filter(function(k2) { return recolourCache[k2] !== 'pending'; });
if (keys.length > 48) {
for (var ki = 0; ki < keys.length - 40; ki++) delete recolourCache[keys[ki]];
}
recolourCache[key] = 'pending';
var img = new Image(); img.crossOrigin = 'anonymous'; img.decoding = 'async';
img.onload = function() {
try {
var srcEl = srcImgs[sized(base.src, maxW)] || img;
var W = srcEl.naturalWidth, H = srcEl.naturalHeight, c = document.createElement('canvas'); c.width = W; c.height = H;
var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(srcEl, 0, 0);
var d = x.getImageData(0, 0, W, H), p = d.data, n = p.length, i, hs, px, NP = W * H;
var seed = nativeHex ? hexHsl(nativeHex)[0] : -1;
function gap(a, b) { var dd = Math.abs(a - b) % 360; return dd > 180 ? 360 - dd : dd; }
var hist = new Array(72).fill(0);
for (i = 0; i < n; i += 16) {
hs = rgbHsl(p[i]/255, p[i+1]/255, p[i+2]/255);
if (hs[1] > Math.max(.35, sMin) && hs[2] > .12 && hs[2] < .85 && (seed < 0 || gap(hs[0], seed) < 40)) hist[Math.floor(hs[0]/5) % 72]++;
}
var peak = hist.indexOf(Math.max.apply(null, hist)), fh = Math.max.apply(null, hist) ? peak * 5 + 2.5 : (seed < 0 ? 0 : seed);
function ramp(v) { v = v < 0 ? 0 : v > 1 ? 1 : v; return v * v * (3 - 2 * v); }

var HUE_IN = hIn, HUE_OUT = hOut, wmap = new Float32Array(NP);
for (px = 0; px < NP; px++) {
i = px * 4; hs = rgbHsl(p[i]/255, p[i+1]/255, p[i+2]/255);
var dh = gap(hs[0], fh);
if (dh > HUE_OUT || hs[1] < sMin || hs[2] < .04) continue;
var chroma = hs[1] * (1 - Math.abs(2 * hs[2] - 1));
wmap[px] = ramp((HUE_OUT - dh) / (HUE_OUT - HUE_IN))
* ramp((hs[1] - sMin) / sBand)
* ramp((chroma - .085) / .085)
* (hs[2] > .82 ? ramp((.97 - hs[2]) / .15) : 1)     // keep chrome and hotspots
* (hs[2] < .14 ? ramp(hs[2] / .12) : 1);            // keep deep shadow
}
(function screenGuard() {
if (/-Formula-Seat|Seat-Samples/i.test(String(srcUrl))) return;
var CS = 8, GW = Math.ceil(W / CS), GH = Math.ceil(H / CS), NC = GW * GH;
var div = new Float32Array(NC), lit = new Float32Array(NC), sat = new Float32Array(NC), frameCell = new Uint8Array(NC);
var gx, gy, xx, yy, i2, hs2;
for (gy = 0; gy < GH; gy++) for (gx = 0; gx < GW; gx++) {
var offHue = 0, count = 0, lSum = 0, lN = 0, frameish = 0, sSum = 0;
for (yy = gy * CS; yy < Math.min(H, gy * CS + CS); yy += 2)
for (xx = gx * CS; xx < Math.min(W, gx * CS + CS); xx += 2) {
i2 = (yy * W + xx) * 4;
hs2 = rgbHsl(p[i2]/255, p[i2+1]/255, p[i2+2]/255);
lSum += hs2[2]; sSum += hs2[1]; lN++;
if (hs2[1] < 0.22 || hs2[2] < 0.10 || hs2[2] > 0.94) continue;
if (gap(hs2[0], fh) < HUE_OUT) frameish++;
else offHue |= (1 << (Math.floor(hs2[0] / 30) % 12));
count++;
}
var bits = 0, m2 = offHue;
while (m2) { bits += m2 & 1; m2 >>= 1; }
lit[gy * GW + gx] = lN ? lSum / lN : 0;
sat[gy * GW + gx] = lN ? sSum / lN : 0;
var isFrame = count > 0 && (frameish / count) > 0.30;
frameCell[gy * GW + gx] = isFrame ? 1 : 0;
div[gy * GW + gx] = (!isFrame && bits >= 3 && count > 5 && lit[gy * GW + gx] > 0.30) ? 1 : 0;
}

var isScreen = new Uint8Array(NC), stack2 = [], q2, cx3, cy3, i3, seeds = 0;
for (i3 = 0; i3 < NC; i3++) if (div[i3]) { isScreen[i3] = 1; stack2.push(i3); seeds++; }
if (seeds) {
while (stack2.length) {
q2 = stack2.pop();
cx3 = q2 % GW; cy3 = (q2 - cx3) / GW;
var nbs = [cx3 > 0 ? q2 - 1 : -1, cx3 < GW - 1 ? q2 + 1 : -1,
cy3 > 0 ? q2 - GW : -1, cy3 < GH - 1 ? q2 + GW : -1];
for (var n3 = 0; n3 < 4; n3++) {
var nb2 = nbs[n3];
if (nb2 < 0 || isScreen[nb2] || frameCell[nb2]) continue;
if (lit[nb2] < 0.22 || lit[nb2] > 0.86 || sat[nb2] < 0.06) continue;
isScreen[nb2] = 1; stack2.push(nb2);
}
}
(function fillHoles() {
var outside = new Uint8Array(NC), st = [], c5, cx5, cy5;
for (c5 = 0; c5 < GW; c5++) { if (!isScreen[c5]) { outside[c5] = 1; st.push(c5); }
var bot5 = (GH - 1) * GW + c5; if (!isScreen[bot5]) { outside[bot5] = 1; st.push(bot5); } }
for (c5 = 0; c5 < GH; c5++) { var l5 = c5 * GW, r5 = c5 * GW + GW - 1;
if (!isScreen[l5]) { outside[l5] = 1; st.push(l5); }
if (!isScreen[r5]) { outside[r5] = 1; st.push(r5); } }
while (st.length) {
c5 = st.pop(); cx5 = c5 % GW; cy5 = (c5 - cx5) / GW;
var nb5 = [cx5 > 0 ? c5 - 1 : -1, cx5 < GW - 1 ? c5 + 1 : -1,
cy5 > 0 ? c5 - GW : -1, cy5 < GH - 1 ? c5 + GW : -1];
for (var k5 = 0; k5 < 4; k5++) {
var n5 = nb5[k5];
if (n5 < 0 || outside[n5] || isScreen[n5]) continue;
outside[n5] = 1; st.push(n5);
}
}
for (c5 = 0; c5 < NC; c5++) if (!outside[c5]) isScreen[c5] = 1;
})();

(function absorbEdges() {
for (var pass2 = 0; pass2 < 3; pass2++) {
var add = [];
for (var c6 = 0; c6 < NC; c6++) {
if (isScreen[c6] || !frameCell[c6]) continue;
var cx6 = c6 % GW, cy6 = (c6 - cx6) / GW, ring = 0, tot6 = 0;
for (var dy6 = -1; dy6 <= 1; dy6++) for (var dx6 = -1; dx6 <= 1; dx6++) {
if (!dx6 && !dy6) continue;
var x6 = cx6 + dx6, y6 = cy6 + dy6;
if (x6 < 0 || x6 >= GW || y6 < 0 || y6 >= GH) continue;
tot6++; if (isScreen[y6 * GW + x6]) ring++;
}
if (tot6 && ring / tot6 >= 0.5) add.push(c6);
}
if (!add.length) break;
for (var a6 = 0; a6 < add.length; a6++) isScreen[add[a6]] = 1;
}
})();

var area = 0;
for (i3 = 0; i3 < NC; i3++) area += isScreen[i3];
if (area >= 60) {
for (px = 0; px < NP; px++) {
if (wmap[px] <= 0) continue;
var cx4 = (px % W) / CS | 0, cy4 = ((px / W) | 0) / CS | 0;
if (isScreen[cy4 * GW + cx4]) wmap[px] = 0;
}
}
}
})();

(function blurMask() {
var tmp = new Float32Array(NP), passes = 1, q, y, xx, k, sum, cnt;
for (q = 0; q < passes; q++) {
for (y = 0; y < H; y++) for (xx = 0; xx < W; xx++) {
sum = 0; cnt = 0;
for (k = -1; k <= 1; k++) { var x2 = xx + k; if (x2 < 0 || x2 >= W) continue; sum += wmap[y*W + x2]; cnt++; }
tmp[y*W + xx] = sum / cnt;
}
for (y = 0; y < H; y++) for (xx = 0; xx < W; xx++) {
sum = 0; cnt = 0;
for (k = -1; k <= 1; k++) { var y2 = y + k; if (y2 < 0 || y2 >= H) continue; sum += tmp[y2*W + xx]; cnt++; }
wmap[y*W + xx] = sum / cnt;
}
}
})();
for (px = 0; px < NP; px++) if (wmap[px] > 0) wmap[px] = ramp((wmap[px] - 0.22) / 0.46);

var innerMask = null, origL = null;
if (innerHex) (function keyed() {
var cand = new Uint8Array(NP), q9, hs9, hit = 0;
origL = new Float32Array(NP);
for (q9 = 0; q9 < NP; q9++) {
var j9 = q9 * 4;
hs9 = rgbHsl(p[j9]/255, p[j9+1]/255, p[j9+2]/255);
origL[q9] = hs9[2];
var d9 = hs9[0];   // rgbHsl already returns degrees
if (d9 > 75 && d9 < 170 && hs9[1] > 0.18 && hs9[2] > 0.07 && hs9[2] < 0.96) { cand[q9] = 1; hit++; }
}
if (hit < NP * 0.003) { origL = null; return; }
var seen9 = new Uint8Array(NP), stk9 = new Int32Array(NP);
innerMask = new Uint8Array(NP);
for (var st9 = 0; st9 < NP; st9++) {
if (!cand[st9] || seen9[st9]) continue;
var sp9 = 0, piece9 = []; stk9[sp9++] = st9; seen9[st9] = 1;
while (sp9 > 0) {
var c9 = stk9[--sp9]; piece9.push(c9);
var cx9 = c9 % W, cy9 = (c9 - cx9) / W;
var nb9 = [cx9 > 0 ? c9-1 : -1, cx9 < W-1 ? c9+1 : -1, cy9 > 0 ? c9-W : -1, cy9 < H-1 ? c9+W : -1];
for (var z9 = 0; z9 < 4; z9++) {
var m9 = nb9[z9];
if (m9 < 0 || !cand[m9] || seen9[m9]) continue;
seen9[m9] = 1; stk9[sp9++] = m9;
}
}
if (piece9.length < 24) continue;
for (var b9 = 0; b9 < piece9.length; b9++) innerMask[piece9[b9]] = 1;
}
for (var pass9 = 0; pass9 < 2; pass9++) {
var grow9 = new Uint8Array(innerMask), gx9, gy9, g9;
for (g9 = 0; g9 < NP; g9++) {
if (innerMask[g9]) continue;
gx9 = g9 % W; gy9 = (g9 - gx9) / W;
if ((gx9 > 0 && innerMask[g9-1]) || (gx9 < W-1 && innerMask[g9+1]) ||
(gy9 > 0 && innerMask[g9-W]) || (gy9 < H-1 && innerMask[g9+W])) grow9[g9] = 1;
}
innerMask = grow9;
}
})();
if (innerHex && !innerMask) (function findBox() {
var cand = new Uint8Array(NP), q3, hs3;
origL = new Float32Array(NP);
for (q3 = 0; q3 < NP; q3++) {
i = q3 * 4; hs3 = rgbHsl(p[i]/255, p[i+1]/255, p[i+2]/255);
origL[q3] = hs3[2];
if (hs3[1] < 0.30 && hs3[2] > 0.05 && hs3[2] < 0.62) cand[q3] = 1;
}
var seen3 = new Uint8Array(NP), stack3 = new Int32Array(NP), sp3, comp3 = [], best = null, bestScore = 0;
for (var st3 = 0; st3 < NP; st3++) {
if (!cand[st3] || seen3[st3]) continue;
sp3 = 0; stack3[sp3++] = st3; seen3[st3] = 1; comp3 = [];
var touching = 0;
while (sp3 > 0) {
q3 = stack3[--sp3]; comp3.push(q3);
var qx3 = q3 % W, qy3 = (q3 - qx3) / W;
var nb3 = [qx3 > 0 ? q3-1 : -1, qx3 < W-1 ? q3+1 : -1, qy3 > 0 ? q3-W : -1, qy3 < H-1 ? q3+W : -1];
for (var k4 = 0; k4 < 4; k4++) {
var n4 = nb3[k4];
if (n4 < 0) continue;
if (wmap[n4] > 0.45) { touching++; continue; }
if (!cand[n4] || seen3[n4]) continue;
seen3[n4] = 1; stack3[sp3++] = n4;
}
}
if (comp3.length < NP * 0.004) continue;
var score = touching / Math.sqrt(comp3.length);
if (score > bestScore) { bestScore = score; best = comp3.slice(); }
}
if (best && bestScore > 1.2) {
var mL = [], b3;
for (b3 = 0; b3 < best.length; b3++) mL.push(origL[best[b3]]);
mL.sort(function(a, b) { return a - b; });
var med = mL[Math.floor(mL.length * .5)];
var keep = new Uint8Array(NP), nKeep = 0;
for (b3 = 0; b3 < best.length; b3++) {
var dl = origL[best[b3]] - med;
if (dl < 0.26 && dl > -0.42) { keep[best[b3]] = 1; nKeep++; }
}
var seen4 = new Uint8Array(NP), stk4 = new Int32Array(nKeep + 8), big = null;
for (b3 = 0; b3 < best.length; b3++) {
var s4 = best[b3];
if (!keep[s4] || seen4[s4]) continue;
var sp4 = 0, piece = []; stk4[sp4++] = s4; seen4[s4] = 1;
while (sp4 > 0) {
var c4 = stk4[--sp4]; piece.push(c4);
var cx4 = c4 % W, cy4 = (c4 - cx4) / W;
var nn4 = [cx4 > 0 ? c4-1 : -1, cx4 < W-1 ? c4+1 : -1, cy4 > 0 ? c4-W : -1, cy4 < H-1 ? c4+W : -1];
for (var z4 = 0; z4 < 4; z4++) {
var m4 = nn4[z4];
if (m4 < 0 || !keep[m4] || seen4[m4]) continue;
seen4[m4] = 1; stk4[sp4++] = m4;
}
}
if (!big || piece.length > big.length) big = piece;
}
if (big && big.length > NP * 0.003) {
innerMask = new Uint8Array(NP);
for (b3 = 0; b3 < big.length; b3++) innerMask[big[b3]] = 1;
var outside = new Uint8Array(NP), stk5 = new Int32Array(NP), sp5 = 0, e5;
for (e5 = 0; e5 < W; e5++) {
if (!innerMask[e5] && !outside[e5]) { outside[e5] = 1; stk5[sp5++] = e5; }
var bt = (H - 1) * W + e5;
if (!innerMask[bt] && !outside[bt]) { outside[bt] = 1; stk5[sp5++] = bt; }
}
for (e5 = 0; e5 < H; e5++) {
var l5 = e5 * W, r5 = l5 + W - 1;
if (!innerMask[l5] && !outside[l5]) { outside[l5] = 1; stk5[sp5++] = l5; }
if (!innerMask[r5] && !outside[r5]) { outside[r5] = 1; stk5[sp5++] = r5; }
}
while (sp5 > 0) {
var c5 = stk5[--sp5], cx5 = c5 % W, cy5 = (c5 - cx5) / W;
var nn5 = [cx5 > 0 ? c5-1 : -1, cx5 < W-1 ? c5+1 : -1, cy5 > 0 ? c5-W : -1, cy5 < H-1 ? c5+W : -1];
for (var z5 = 0; z5 < 4; z5++) {
var m5 = nn5[z5];
if (m5 < 0 || innerMask[m5] || outside[m5]) continue;
outside[m5] = 1; stk5[sp5++] = m5;
}
}
for (e5 = 0; e5 < NP; e5++) if (!innerMask[e5] && !outside[e5]) innerMask[e5] = 1;
var rowF = new Uint8Array(NP), a6, b6, x6, y6;
for (y6 = 0; y6 < H; y6++) {
a6 = -1; b6 = -1;
for (x6 = 0; x6 < W; x6++) if (innerMask[y6 * W + x6]) { if (a6 < 0) a6 = x6; b6 = x6; }
if (a6 >= 0) for (x6 = a6; x6 <= b6; x6++) rowF[y6 * W + x6] = 1;
}
for (e5 = 0; e5 < NP; e5++) if (rowF[e5]) innerMask[e5] = 1;
}
}
})();

var boxes = keepOut(srcUrl);
if (boxes) {
for (var kb = 0; kb < boxes.length; kb++) {
var bx1 = Math.floor(boxes[kb][0] * W), by1 = Math.floor(boxes[kb][1] * H),
bx2 = Math.ceil(boxes[kb][2] * W),  by2 = Math.ceil(boxes[kb][3] * H);
for (var by = by1; by < by2; by++) {
if (by < 0 || by >= H) continue;
for (var bx = bx1; bx < bx2; bx++) {
if (bx < 0 || bx >= W) continue;
var bi = by * W + bx;
wmap[bi] = 0;
if (innerMask) innerMask[bi] = 0;
}
}
}
}

var t = hexHsl(hex), lHist = new Int32Array(1024), sumS = 0, cntS = 0;
for (px = 0; px < NP; px++) {
if (wmap[px] <= .05) continue;
i = px * 4; hs = rgbHsl(p[i]/255, p[i+1]/255, p[i+2]/255);
var lb = (hs[2] * 1023) | 0; lHist[lb < 0 ? 0 : lb > 1023 ? 1023 : lb]++;
sumS += hs[1]; cntS++;
}
if (!cntS) { recolourCache[key] = base.src; refreshViewer(); return; }
function pct(f) {
var want = f * cntS, acc = 0;
for (var bIdx = 0; bIdx < 1024; bIdx++) { acc += lHist[bIdx]; if (acc >= want) return bIdx / 1023; }
return 1;
}
var p5 = pct(.05), p95 = pct(.95), mS = sumS / cntS;
var spanMul = finish === 'matt' ? 0.82 : finish === 'satin' ? 0.90 : 0.95;
var TC_OUT = toneLUT(finish);
var span = Math.max(finish === 'matt' ? 0.26 : 0.30, (p95 - p5) * spanMul);
var loL = t[2] - span / 2, hiL = t[2] + span / 2;
if (hiL > 0.97) { loL -= hiL - 0.97; hiL = 0.97; }
if (loL < 0.02) { hiL = Math.min(0.97, hiL + (0.02 - loL)); loL = 0.02; }
for (var fitN = 0; fitN < 24; fitN++) {
var probe = hslRgb(t[0], t[1], hiL);
if (Math.max(probe[0], probe[1], probe[2]) <= 0.985) break;
hiL -= (hiL - loL) * 0.06;
}
var lSpan = Math.max(.001, p95 - p5), lRange = hiL - loL;

for (px = 0; px < NP; px++) {
var w = wmap[px];
if (w <= .004) continue;
i = px * 4;
hs = rgbHsl(p[i]/255, p[i+1]/255, p[i+2]/255);
var u = (hs[2] - p5) / lSpan;
u = u < 0 ? 0 : u > 1 ? 1 : u;
u = TC_OUT[(u * 1024) | 0];
var nl = loL + u * lRange;
nl = nl < .02 ? .02 : nl > .97 ? .97 : nl;
var ns = t[1] * Math.min(1, hs[1] / mS);
var nh = hs[0], sW = w;
if (t[1] < 0.18) {
nh = t[0];
sW = Math.min(1, w * 3.2);
} else {
var dHue = t[0] - hs[0]; if (dHue > 180) dHue -= 360; if (dHue < -180) dHue += 360;
nh = hs[0] + dHue * w; if (nh < 0) nh += 360; if (nh >= 360) nh -= 360;
}
var outL = hs[2] + (nl - hs[2]) * w;
var outS = hs[1] + (ns - hs[1]) * sW;
if (finish === 'matt') {
outS *= 1 - 0.22 * w;                                 // flat paint reads duller
} else if (finish !== 'metallic' && u > 0.88) {
var hot = (u - 0.88) / 0.12;
var amt = (finish === 'satin' ? 0.08 : 0.20) * hot * hot * w;
outL = outL + (1 - outL) * amt;
outS *= 1 - amt * 0.85;
}
if (finish === 'metallic' && w > 0.25) {
var n1 = Math.sin(px * 12.9898 + 78.233) * 43758.5453;
var spark = n1 - Math.floor(n1);
if (spark > 0.62) {
var lift = (spark - 0.62) / 0.38 * 0.115 * w * (0.4 + outL);
outL += lift;
outS *= 1 - 0.16 * w;
outL = outL > .985 ? .985 : outL;
}
}
var o = hslRgb(nh, outS, outL);
p[i] = o[0] * 255; p[i+1] = o[1] * 255; p[i+2] = o[2] * 255;
}
if (innerMask && innerHex) {
var iT = hexHsl(innerHex), iLs = [], q5;
for (q5 = 0; q5 < NP; q5++) if (innerMask[q5]) iLs.push(origL[q5]);
iLs.sort(function(a, b) { return a - b; });
var iP5 = iLs[Math.floor(iLs.length * .10)],
iP95 = iLs[Math.floor(iLs.length * .90)];
var iSpan = Math.min(0.42, Math.max(0.18, (iP95 - iP5) * 0.70));
var iLo = iT[2] - iSpan / 2, iHi = iT[2] + iSpan / 2;
if (iHi > 0.97) { iLo -= iHi - 0.97; iHi = 0.97; }
if (iLo < 0.02) { iHi = Math.min(0.97, iHi + (0.02 - iLo)); iLo = 0.02; }
var iRange = iHi - iLo, iSpread = Math.max(.001, iP95 - iP5);
var iFin = innerFinish || finish;
var TC_IN = toneLUT(iFin);
for (q5 = 0; q5 < NP; q5++) {
if (!innerMask[q5]) continue;
var iu = (origL[q5] - iP5) / iSpread;
iu = iu < 0 ? 0 : iu > 1 ? 1 : iu;
iu = TC_IN[(iu * 1024) | 0];
var iNl = iLo + iu * iRange;
var iSat = iT[1];
if (iFin === 'matt') iSat *= 0.78;
else if (iFin !== 'metallic' && iu > 0.88) {
var iHot = (iu - 0.88) / 0.12;
var iAmt = (iFin === 'satin' ? 0.08 : 0.20) * iHot * iHot;
iNl = iNl + (1 - iNl) * iAmt;
iSat *= 1 - iAmt * 0.85;
}
if (iFin === 'metallic') {
var n5 = Math.sin(q5 * 12.9898 + 78.233) * 43758.5453, sp5 = n5 - Math.floor(n5);
if (sp5 > 0.62) { iNl += (sp5 - 0.62) / 0.38 * 0.115 * (0.4 + iNl); iSat *= 0.84; }
}
iNl = iNl < .02 ? .02 : iNl > .985 ? .985 : iNl;
var io = hslRgb(iT[0], iT[1] === 0 ? 0 : iSat, iNl), j5 = q5 * 4;
p[j5] = io[0] * 255; p[j5+1] = io[1] * 255; p[j5+2] = io[2] * 255;
}
}

x.putImageData(d, 0, 0);
recolourCache[key] = c.toDataURL('image/jpeg', .92);
} catch (e) { recolourCache[key] = base.src; }
refreshViewer();
};
img.onerror = function() { recolourCache[key] = base.src; refreshViewer(); };
loadSource(sized(base.src, maxW), img);
return null;
}

var srcImgs = {}, srcWait = {};
function loadSource(url, target) {
var have = srcImgs[url];
if (have) { queueRepaint(function() { target.onload(); }); return; }
if (srcWait[url]) { srcWait[url].push(target); return; }
srcWait[url] = [target];
var probe = new Image(); probe.crossOrigin = 'anonymous'; probe.decoding = 'async';
probe.onload = function() {
srcImgs[url] = probe;
var waiting = srcWait[url] || []; delete srcWait[url];
waiting.forEach(function(t) {
t.naturalWidth = probe.naturalWidth; t.naturalHeight = probe.naturalHeight;
queueRepaint(function() { t.onload(); });
});
};
probe.onerror = function() {
var waiting = srcWait[url] || []; delete srcWait[url];
waiting.forEach(function(t) { t.onerror(); });
};
probe.src = url;
}

var rq = [], rqBusy = false;
function queueRepaint(job) { rq.push(job); if (!rqBusy) pumpRepaint(); }
function pumpRepaint() {
var job = rq.shift();
if (!job) { rqBusy = false; return; }
rqBusy = true;
var later = window.requestIdleCallback || function(f) { return setTimeout(f, 0); };
later(function() { try { job(); } catch (e) {} pumpRepaint(); }, { timeout: 300 });
}

function stageParts(x) {
var s = sim(), out = [];
[['wheel', 'Steering wheel'], ['base', 'Wheel base'], ['pedals', 'Pedals']].forEach(function(p) {
var c = (s.components || []).filter(function(cc) { return cc.id === p[0]; })[0], v = x.preset && x.preset[p[0]], o = c && compLabel(c, v);
if (o && partImg(v)) out.push({ label: p[1], name: o[1], src: partImg(v) });
});
if (x.display && DISPLAYS[x.display] && displayImg(x.display)) out.push({ label: 'Screen', name: DISPLAYS[x.display].name, src: displayImg(x.display) });
return out;
}
function buildParts() {
var s = sim(), out = [];
[['wheel', 'Steering wheel'], ['base', 'Wheel base'], ['pedals', 'Pedals']].forEach(function(p) {
var c = (s.components || []).filter(function(cc) { return cc.id === p[0]; })[0];
if (!c) return;
var v = state.comp[c.id], o = compLabel(c, v);
if (o && partImg(v)) out.push({ label: p[1], name: o[1], src: partImg(v) });
});
if (!out.length && simImg()) out.push({ label: 'Simulator', name: s.name, src: simImg() });
var seatSrc = isGTSeat() && isOwnSeat() ? OWN_SEAT_IMG : (isGTSeat() && isCarbonSeat() ? carbonSeatImg() : (SEAT_IMG[state.sim] || null));
var seatName = isGTSeat() && (isCarbonSeat() || isOwnSeat()) ? seatTypeName() : s.seat;
if (displayImg(state.display) && out.length < 4) out.push({ label: 'Screen', name: DISPLAYS[state.display].name, src: displayImg(state.display) });
if (seatSrc && out.length < 4) out.push({ label: 'Seat', name: seatName, src: seatSrc });
return out.slice(0, 4);
}
function buildShot() {
var s = sim(), parts = buildParts();
if (parts.length < 2) return null;
return { src: parts[0].src, grid: parts, caption: s.name + ' \u00b7 your build' };
}
function stageShot(id) {
var s = sim(), x = s.packages.filter(function(p) { return p.id === id; })[0];
if (!x || x.custom || !x.preset) return null;
var parts = stageParts(x); if (parts.length < 2) return null;
return { src: parts[0].src, grid: parts, caption: x.name + ' \u00b7 ' + parts.map(function(p) { return p.name; }).join(' \u00b7 ') };
}
function renderStageGrid(f) {
var wrap = $$('cpc-slideshow'); if (!wrap) return;
var el = wrap.querySelector('.cpc-stagegrid');
if (!f || !f.grid) { if (el) el.remove(); wrap.classList.remove('has-grid'); return; }
var cards = f.grid.map(function(p) {
return { src: paintedSrc(p.src) || p.src, label: p.label, name: p.name };
});
function isPartShot(src) { return /MOZA|Simucube|Wheel-Base|Steering-Wheel|Pedals/i.test(String(src)); }
function media(src) {
var pc = isPartShot(src) ? ' class="is-part"' : '';
return isData(src) ? '<img' + pc + ' src="' + src + '" alt="" decoding="async">'
: '<img' + pc + ' src="' + sized(src, 400) + '" srcset="'
+ [400, 600, 800].map(function(w) { return sized(src, w) + ' ' + w + 'w'; }).join(', ')
+ '" sizes="(max-width: 700px) 45vw, 24vw" alt="" decoding="async">';
}
if (!el) { el = document.createElement('div'); el.className = 'cpc-stagegrid'; wrap.appendChild(el); }
var have = el.querySelectorAll('.sg-card');
if (have.length === cards.length) {
cards.forEach(function(c, i) {
var card = have[i];
if (card.getAttribute('data-src') !== c.src) {
card.setAttribute('data-src', c.src);
card.querySelector('.sg-img').innerHTML = media(c.src);
}
var cap = card.querySelector('figcaption');
var want = '<span>' + esc(c.label) + '</span><b>' + esc(c.name) + '</b>';
if (cap.innerHTML !== want) cap.innerHTML = want;
});
} else {
el.innerHTML = cards.map(function(c) {
return '<figure class="sg-card" data-src="' + esc(c.src) + '"><div class="sg-img">' + media(c.src) + '</div>'
+ '<figcaption><span>' + esc(c.label) + '</span><b>' + esc(c.name) + '</b></figcaption></figure>';
}).join('');
}
wrap.classList.add('has-grid');
}
function extraImg(k) {
if (k === 'bespoke' && state.sim === 'gt-pro') return CDN + 'Custom_Racing_Simulator_Colour_matched_to_car.jpg?v=1768369467';
if (k === 'bespoke' && state.sim === 'gt-sport') return F + 'Kitkat-branding.jpg?v=1782803975';
if (k === 'bespoke' && state.sim.indexOf('gt') === 0) return F + 'Aston-Half-Car_799f2876-28b9-480a-b8ca-7d286ef456f3.jpg?v=1750329006';
return EXTRAS[k].img;
}
function sportClutch() { var s = sim(); return s.packages.length > 1 && !!s.components && s.extras.indexOf('clutch') > -1; }
window['cpcShowSoftware_' + SID] = function() { state.lastPick = { step: 'extras', g: 'software', v: 'suite' }; renderSlideshow(); };
function ddueBuiltIn() { return state.comp && state.comp.wheel === 'cps-gt' && (sim().components || []).some(function(c) { return c.id === 'ddu'; }); }
var STAGE_COPY = {
s1: { who: 'Entry level',
desc: 'Built for fun. The full-size frame and real driving position, set up for entertainment: racing friends and family, laps on a Friday night, and learning the craft without a big commitment.' },
s2: { who: 'Enthusiast',
desc: 'The best middle ground, and the one most people land on. A serious step up in feel with direct drive force feedback and load-cell braking, without going all the way to professional hardware.' },
s3: { who: 'Serious enthusiast', badge: 'Pro grade hardware',
desc: 'The same hardware we build for professional drivers, on the same lifetime frame. Real motorsport training value when you want it, and still the best seat in the house when friends and family are over.' }
};
var SHIFTER_RIVAL = { hpattern: 'sequential', sequential: 'hpattern' };
function renderExtrasStep() {
var s = sim();
return head(stepIndex('extras'), 'Final Touches', 'Extras', 'Set your ' + esc(s.name) + ' up exactly the way you want it.')
+ group('Software', '<div class="toggle-card selected is-fixed" data-g="software" data-v="suite" style="cursor:pointer" onclick="' + fn('ShowSoftware') + '()"'
+ ' title="CP-S Software Suite is required on every build">' + '<div class="radio-thumb">' + thumb(softwareImg()) + '</div>' + '<div class="toggle-info"><div class="toggle-name">CP-S Software Suite</div><div class="toggle-desc">'
+ (state.sim === 'karting' ? 'Built on the rFactor platform and tuned by us. KartSim installed and configured, with our own force feedback tuning, live telemetry and graphics optimisation.' : 'Built on the rFactor platform and tuned by us: iRacing, Assetto Corsa, ACC, F1 25, Dirt Rally 2.0, rFactor 2, Automobilista 2 and more, each configured for your rig. thousands of cars and hundreds of tracks, live MoTeC-compatible telemetry across 50+ channels, our own force feedback tuning and motion and tactile profiles.') + '</div></div><div class="toggle-price">Required</div></div>')
+ group('Options', '<div class="toggle-grid">' + s.extras.filter(function(k) { return !(k === 'clutch' && sportClutch()); }).map(function(k) {
var rival = SHIFTER_RIVAL[k], blocked = rival && state.extras[rival] && !state.extras[k];
var byClassic = (rival || k === 'clutch') && state.extras.classic;
var byRally = (k === 'handbrake' || k === 'hpattern' || k === 'sequential') && state.extras.rally;
var byDrift = (k === 'handbrake' || k === 'sequential' || k === 'hpattern') && state.extras.drift;
var html = toggle('extra', k, !!state.extras[k], EXTRAS[k].name,
byClassic ? 'Included in the Classic Car Pack. Choosing this removes the pack.'
: byRally ? 'Included in the Rally Pack. Choosing this removes the pack.'
: byDrift ? 'Included in the Drift Pack. Choosing this removes the pack.'
: blocked ? 'Swaps out your ' + EXTRAS[rival].name + '. One shifter per simulator.' : EXTRAS[k].desc, extraImg(k));
blocked = blocked || byClassic || byRally || byDrift;
return blocked ? html.replace('class="toggle-card', 'class="toggle-card is-swap') : html;
}).join('') + '</div>'
+ (state.extras.rally && !state.extras.drift && state.motion !== 'motion'
? '<p class="cpc-note">Rally stages are where motion earns its keep: add the D-BOX platform under <a href="#" onclick="' + fn('Go') + '(\'immersion\');return false;">Immersion</a> to feel the crests and camber.</p>'
: ''));
}

function renderEnquireStep() {
var s = sim(), hero = simImg();
var spec = (s.packages[0].spec || []).concat(s.common || []).filter(function(r) {
return !/^(warranty|donor car|international shipping)$/i.test(String(r[0]).trim());
});
return '<div class="section-eyebrow">' + esc(s.name) + '</div>'
+ '<h2 class="section-title title-sm tracking-heading">Configured with our team</h2>'
+ '<p class="section-desc text-sm">Every ' + esc(s.name) + ' is specified with you directly: sizing, screens, livery and install. Send an enquiry and a specialist will take you through it. <a href="' + s.url + '" target="_blank" rel="noopener">View full details</a></p>'
+ '<div class="rv-build">'
+   (hero ? '<div class="rv-build-photo"><img src="' + sized(hero, 240) + '" srcset="' + [240, 360].map(function(w) { return sized(hero, w) + ' ' + w + 'w'; }).join(', ') + '" sizes="120px" alt="" decoding="async"></div>' : '')
+   '<div class="rv-build-info"><div class="rv-build-name">' + esc(s.name) + '</div>'
+   '<div class="rv-build-price">From ' + esc(priceFor(state.sim, s.packages[0].id)) + '</div>'
+   ((s.proof && s.proof[0]) ? '<div class="rv-build-proof"><span>+</span>' + esc(s.proof[0]) + '</div>' : '') + '</div>'
+ '</div>'
+ (spec.length ? '<div class="rv-label rv-label-spec">Included as standard</div><div class="spec-grid">' + spec.map(function(r) {
var im = imgFor(r[0]);
return '<div class="spec-card spec-card-locked' + (im ? ' has-photo' : '') + '">'
+ (im ? '<div class="spec-photo' + photoFit(im, r[0]) + '"><img src="' + sized(im, 300) + '" srcset="' + [300, 450, 600, 800].map(function(w) { return sized(im, w) + ' ' + w + 'w'; }).join(', ') + '" sizes="(max-width: 700px) 45vw, 22vw" alt="" decoding="async"></div>' : icon(r[0], 26))
+ '<div class="spec-label">' + esc(r[0]) + '</div><div class="spec-name">' + esc(r[1]) + '</div></div>';
}).join('') + '</div>' : '')
+ '<div class="review-contact"><span class="rv-contact-lead">Rather send a message?</span>'
+ '<a href="https://api.whatsapp.com/send?phone=447418611054">WhatsApp</a></div>';
}

function renderReviewStep() {
var s = sim(), p = pkg(), mixed = isMixed(), groups = summaryGroups();
var title = s.name + (mixed ? ' Custom Hardware Spec' : (s.packages.length > 1 ? ' ' + p.name : ''));
var price = mixed ? 'POA' : 'From ' + priceFor(state.sim, p.id);
var hero = heroImg();
var cta = function(extra) {
return '<button class="cta-primary enquire-btn rv-cta' + (extra || '') + '" onclick="' + fn('OpenEnquiry') + '()">Submit Your Build<span aria-hidden="true">→</span></button>';
};
var h = '<h2 class="section-title title-sm tracking-heading">Review Your Build</h2>'
+ '<div class="rv-build">'
+   (hero ? '<div class="rv-build-photo"><img src="' + (isData(hero) ? hero : sized(hero, 240)) + '"'
+ (isData(hero) ? '' : ' srcset="' + [240, 360].map(function(w) { return sized(hero, w) + ' ' + w + 'w'; }).join(', ') + '" sizes="120px"')
+ ' alt="" decoding="async"></div>' : '')
+   '<div class="rv-build-info"><div class="rv-build-name">' + esc(title) + '</div>'
+   '<div class="rv-build-price">' + esc(price) + '</div>'
+   '</div>'
+   '<button type="button" class="rv-spec" onclick="' + fn('CopyRef') + '(this)" aria-label="Copy your spec number"' + (refShown() ? '' : ' hidden') + '>'
+   '<span class="rv-spec-label">Spec number</span>'
+   '<span class="rv-spec-code">' + esc(refShown() ? currentRef : '') + '</span>'
+   '<span class="rv-spec-act"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg><span class="rv-spec-lbl">Copy</span></span>'
+   '</button>'
+ '</div>'
+ reviewGallery()
+ '<div class="rv-label rv-label-spec">Your specification</div>'
+ '<div class="review-card">' + groups.map(function(g) {
var shut = !!rvShut[g.title];
return '<div class="review-group' + (shut ? ' is-shut' : '') + '">'
+ '<div class="review-group-head" role="button" tabindex="0" onclick="' + fn('RvFold') + "('" + esc(g.title) + '\')">'
+ icon(g.title, 14) + '<span>' + esc(g.title) + '</span>'
+ '<button type="button" class="review-edit" onclick="event.stopPropagation();' + fn('Go') + "('" + g.step + '\')">Edit</button>'
+ '<span class="review-fold" aria-hidden="true"></span></div>'
+ '<div class="review-group-rows">'
+ g.rows.map(function(r) {
var im = imgFor(r[0]), sw = im ? null : swatchFor(r[0]);
var media = im ? '<span class="rv-thumb">' + thumb(im) + '</span>'
: sw ? '<span class="rv-thumb rv-swatch" style="background:' + sw + '"></span>'
: '<span class="rv-thumb rv-thumb-empty"></span>';
return '<div class="review-row">' + media + '<span class="review-row-name">' + esc(r[0]) + '</span><span class="review-row-value">' + esc(r[1]) + '</span></div>';
}).join('') + '</div></div>';
}).join('') + '</div>'
+ '<div class="review-contact"><span class="rv-contact-lead">Rather send a message?</span>'
+ '<a href="https://api.whatsapp.com/send?phone=447418611054">WhatsApp</a>'
+ '<a href="' + esc(phoneHref()) + '">' + esc(phoneLabel()) + '</a>'
+ '</div>';
return h;
}

var rvShut = {};
window['cpcRvFold_' + SID] = function(title) {
rvShut[title] = !rvShut[title];
dirty[currentStep] = true;
renderPanel(currentStep);
};
function galleryShots() {
var shots = [], seen = {};
function add(src, title, note) {
if (!src || seen[src]) return;
seen[src] = 1; shots.push({ src: src, title: title, note: note || '' });
}
if (sim().enquireOnly) {
add(simImg(), sim().name, '');
((pkg().spec || []).concat(sim().common || [])).forEach(function(r) { add(imgFor(r[0]), r[0], r[1]); });
return shots;
}
add(heroImg(), sim().name, state.colour === 'custom' && customHex()
? customHex().toUpperCase() + (SHOW_FINISHES ? ' \u00b7 ' + finishName() : '') : colourName(state.colour));
var seatShot = isGTSeat() ? gtSeatShot(null, null) : seatColourShot();
if (seatShot) add(seatShot.src, 'Seat', seatShot.caption);
summaryGroups().forEach(function(g) {
if (g.title === 'Colour') return;                 // already the lead photo
g.rows.forEach(function(r) {
if (!r[1] || r[1] === 'None' || r[1] === 'No') return;
if (r[0] === 'Simulator') return;               // the lead photo is already the rig
var src = imgFor(r[0]);
if (!src) {
var ek = Object.keys(EXTRAS).filter(function(k) { return EXTRAS[k].name === r[0]; })[0];
if (ek) src = extraImg(ek);
}
add(src, r[0], r[1] === 'Yes' ? '' : r[1]);
});
});
return shots;
}
function reviewGallery() {
var shots = galleryShots();
if (shots.length < 2) return '';
return '<div class="rv-gallery"><div class="rv-gallery-label">Your build in pictures</div>'
+ '<div class="spec-grid">' + shots.map(function(sh) {
var rvSrc = isData(sh.src) ? sh.src : sized(sh.src, 640);
return '<div class="spec-card spec-card-locked has-photo">'
+ '<div class="spec-photo' + photoFit(sh.src, sh.title) + '"><img src="' + rvSrc + '"'
+ ' loading="lazy" decoding="async" alt="' + esc(sh.title) + '"></div>'
+ '<div class="spec-label">' + esc(sh.title) + '</div>'
+ '<div class="spec-name">' + esc(sh.note) + '</div></div>';
}).join('') + '</div></div>';
}

var BROCHURE_URL = 'https://coolperformance.app.n8n.cloud/webhook/cp-brochure-7367e570bc412679094359e6';
var detailsSent = {};
function sheetData() {
var s = sim(), p = pkg(), mixed = isMixed(), hero = s.enquireOnly ? simImg() : heroImg(1600);
var big = function(u, key) { return !u ? '' : isData(u) ? 'paint:' + (key || 'hero') : sized(u, 1400); };
function stops(css) {
var out = [];
(String(css || '').match(/#[0-9a-f]{6}\b|#[0-9a-f]{3}\b/gi) || []).forEach(function(h) {
if (h.length === 4) h = '#' + h[1] + h[1] + h[2] + h[2] + h[3] + h[3];
if (out[out.length - 1] !== h) out.push(h);
});
return out;
}
var who = '';
try {
var card = document.getElementById('cpc-modal-card-' + SID);
(card ? card.querySelectorAll('input') : []).forEach(function(el) {
var hint = (el.name + ' ' + el.id + ' ' + el.placeholder + ' ' + (el.getAttribute('autocomplete') || '')).toLowerCase();
if (!who && /name/.test(hint) && !/email|last|company|business/.test(hint) && el.value.trim()) who = el.value.trim().split(/\s+/)[0];
});
} catch (e) {}
var groups = summaryGroups(), spec = [], colours = [], features = [], seen = {};
groups.forEach(function(g) {
g.rows.forEach(function(r) {
if (/^(Simulator|From)/.test(r[0]) || (g.title === 'Extras' && r[1] === 'None')) return;
var sw = swatchFor(r[0]);
if (r[0] === 'Frame Colour' && state.colour === 'custom' && customHex()) sw = customHex();
var row = { label: r[0], value: r[1], stops: stops(sw), mark: r[1] === 'Yes' || r[1] === 'Included' ? 'yes' : r[1] === 'No' ? 'no' : '' };
if (row.mark === 'yes') row.value = 'Included';
if (row.mark === 'no') row.value = 'Not selected';
spec.push(row);
if (row.stops.length) colours.push({ label: r[0], value: r[1], stops: row.stops, stripes: r[0] === 'Tricolour' });
});
});
if (!s.enquireOnly) (s.extras || []).forEach(function(k) {
if (!state.extras[k] && EXTRAS[k]) spec.push({ label: EXTRAS[k].name, value: 'Not selected', stops: [], mark: 'no' });
});
function feature(eyebrow, title, desc, img, key) {
if (!img || seen[img]) return;
seen[img] = 1;
var u = big(img, key);
if (u === 'paint:hero' && key !== 'hero' && key) return;
features.push({ eyebrow: eyebrow, title: title, desc: desc || '', img: u });
}
var colourLine = s.enquireOnly ? '' : (state.colour === 'custom' && customHex() ? customHex().toUpperCase() : colourName(state.colour));
seen[hero] = 1;                                     // the cover already carries the lead photo
var specified = 'Specified as part of your ' + s.name + ' configuration.';
(groups[0] ? groups[0].rows : []).forEach(function(r) {
if (/^(Simulator|From)/.test(r[0])) return;
feature(r[0], r[1], specified, imgFor(r[0]));
});
if (!s.enquireOnly) {
var seatShot = isGTSeat() ? gtSeatShot(null, null) : seatColourShot();
if (seatShot) feature('Seating', isGTSeat() && (isCarbonSeat() || isOwnSeat()) ? seatTypeName() : (s.seat || 'Seat'), seatShot.caption, seatShot.src, 'seat');
Object.keys(SEAT_FINISHES).forEach(function(k) { if (state.seatFinish[k]) feature('Seating', SEAT_FINISHES[k].name, SEAT_FINISHES[k].desc, SEAT_FINISHES[k].img); });
if (state.carbon && FINISHES.carbon) feature('Exterior Detailing', FINISHES.carbon.name, FINISHES.carbon.desc, FINISHES.carbon.img);
var dsp = DISPLAYS[state.display]; if (dsp) feature('Display', dsp.name, dsp.desc, dsp.img);
if (state.motion !== 'none' && MOTION[state.motion]) feature('Motion & Haptics', MOTION[state.motion].name, MOTION[state.motion].desc, motionImg(state.motion));
if (state.audio !== 'none' && AUDIO[state.audio]) feature('Audio', AUDIO[state.audio].name, AUDIO[state.audio].desc, AUDIO[state.audio].img);
if (state.headset) feature('Audio', AUDIO.headset.name, AUDIO.headset.desc, AUDIO.headset.img);
s.extras.forEach(function(k) { if (state.extras[k] && EXTRAS[k]) feature('Your Configuration', EXTRAS[k].name, EXTRAS[k].desc, extraImg(k)); });
}
return {
sim: s.name,
title: s.name + (mixed ? ' Custom Hardware Spec' : (s.packages.length > 1 ? ' ' + p.name : '')),
price: mixed ? 'Price on quote' : 'From ' + priceFor(state.sim, p.id),
currency: CURRENCY,
ref: (currentRef && currentRef.indexOf('HELP') !== 0) ? currentRef : '',
who: who,
lead: leadLine(),
simId: state.sim,
state: JSON.parse(JSON.stringify(state)),
cover: big(hero, 'hero'),
colourLine: colourLine,
cps: /CP-S/.test((groups[0] ? groups[0].rows : []).map(function(r) { return r[1]; }).join(' ')),
bespoke: !s.enquireOnly && !!state.extras.bespoke,
model: { name: s.name, tag: s.tag, body: s.blurb, img: big(simImg()) },
spec: spec,
colours: s.enquireOnly ? [] : colours,
also: s.enquireOnly ? [] : s.extras.filter(function(k) { return state.extras[k] && EXTRAS[k]; }).map(function(k) { return EXTRAS[k].name; }),
features: features
};
}
function sendDetails() {
if (helpMode || !currentRef || currentRef.indexOf('HELP') === 0) return;
var data;
try { data = sheetData(); } catch (e) { return; }
var body = JSON.stringify(data);
if (detailsSent[currentRef] === body) return;     // same build already sent
detailsSent[currentRef] = body;
try { fetch(BROCHURE_URL, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body })['catch'](function() {}); }
catch (e) { try { navigator.sendBeacon(BROCHURE_URL, new Blob([body], { type: 'text/plain' })); } catch (e2) {} }
}

function summaryGroups(gbp) {
var s = sim(), p = pkg(), mixed = isMixed(), g = [];
var money2 = gbp ? priceLiteral : priceFor;
var spec = [['Simulator', s.name + (mixed ? ' Custom Hardware Spec' : (s.packages.length > 1 ? ' ' + p.name : ''))],
[mixed && s.packages.length > 1 ? 'From (' + basePkg().name + ')' : 'From', mixed ? money2(state.sim, basePkg().id) + ' · price on quote' : money2(state.sim, p.id)]];
(s.components || []).forEach(function(c) {
if (c.id === 'ddu' && ddueBuiltIn()) { spec.push([c.title, 'Built into the CP-S wheel']); return; }
var o = compLabel(c, state.comp[c.id]); if (o) spec.push([c.title, o[1]]); });
if (!s.components && p.spec) p.spec.forEach(function(r) { if (!/^(warranty|display|frame|seat|shipping|delivery)$/i.test(r[0])) spec.push([r[0], r[1]]); });
g.push({ title: 'Specification', step: (s.components || s.packages.length > 1) ? 'spec' : 'standard', rows: spec });
if (s.enquireOnly) return g;
var fin = [['Frame Colour', state.colour === 'custom' && customHex() ? customHex().toUpperCase() : colourName(state.colour)]];
if (state.colour === 'custom' && SHOW_FINISHES) fin.push(['Finish', finishName()]);
if (state.carbon) fin.push(['Carbon Fibre', 'Included']);
g.push({ title: 'Colour', step: 'colour', rows: fin });
if (!s.seatCustom) {
g.push({ title: 'Seat', step: 'seat', rows: [['Seat', s.seat]] });
} else if (isGTSeat()) {
var gs = [['Seat', (isCarbonSeat() || isOwnSeat()) ? seatTypeName() : s.seat]];
if (isCarbonSeat()) { gs.push(['Custom Stitching', state.stitchCustom ? 'Yes' : 'No']); if (state.seatType === 'carbon') gs.push(['Custom Colour Carbon', state.carbonCustom ? 'Yes' : 'No']); }
g.push({ title: 'Seat', step: 'seat', rows: gs });
} else {
var seat = [['Seat Colour', SEAT_COLOURS[state.seatColour]], ['Stitching', STITCH_COLOURS[state.stitching]]];
if (state.tricolour && state.tricolour !== 'none') seat.push(['Tricolour', TRICOLOURS[state.tricolour][0]]);
Object.keys(SEAT_FINISHES).forEach(function(k) { if (state.seatFinish[k]) seat.push([SEAT_FINISHES[k].name, 'Yes']); });
g.push({ title: 'Seat', step: 'seat', rows: seat });
}
g.push({ title: 'Display', step: 'display', rows: [['Display', DISPLAYS[state.display].name]] });
var imm = [['Motion', MOTION[state.motion].name], ['Audio', AUDIO[state.audio].name]];
if (state.headset) imm.push([AUDIO.headset.name, 'Yes']);
g.push({ title: 'Immersion', step: 'immersion', rows: imm });
var ex = s.extras.filter(function(k) { return state.extras[k]; }).map(function(k) { return [EXTRAS[k].name, 'Yes']; });
g.push({ title: 'Extras', step: 'extras', rows: ex.length ? ex : [['Extras', 'None']] });
return g;
}
function summaryRows(gbp) {
var out = [];
summaryGroups(gbp).forEach(function(g) { g.rows.forEach(function(r) { out.push(r); }); });
return out;
}
function renderSummary() {
var tabs = $$('cpc-tabs');
if (tabs) tabs.innerHTML = '<button type="button" class="cpc-tab cpc-tab-sim" onclick="' + fn('Go') + '(\'sim\')">'
+ '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>'
+ 'Select sim</button>'
+ STEPS.map(function(st, i) {
if (st.key === 'sim') return '';
return '<button type="button" class="cpc-tab' + (i === currentStep ? ' is-on' : '') + (i < currentStep ? ' is-done' : '') + '" onclick="' + fn('Go') + "('" + st.key + "')\">" + esc(st.title === 'Signature Specification' ? 'Specification' : st.title) + '</button>';
}).join('');
var on = tabs && tabs.querySelector('.is-on'); if (on) { if (on.offsetLeft + on.offsetWidth > tabs.scrollLeft + tabs.clientWidth || on.offsetLeft < tabs.scrollLeft) tabs.scrollLeft = on.offsetLeft - 24; }
var price = $$('cpc-nav-price');
if (price) {
var s = sim(), p = pkg(), mixed = isMixed();
price.innerHTML = '<span class="cpc-nav-name">' + esc(s.name + (mixed ? ' Custom Hardware Spec' : (s.packages.length > 1 ? ' ' + p.name : ''))) + '</span>'
+ '<span class="cpc-nav-from">' + (mixed ? 'Price on quote' : 'From ' + esc(priceFor(state.sim, p.id))) + '</span>';
}
}

var slides = [], slideIdx = 0, slidePool = {}, slideKey = '';
var _slideTok = 0;   // guards a late-arriving frame from overwriting a newer choice
var WHOLE_SHOT = /(?!)/;   // the GT Pro hero is framed with margins now, so nothing needs the contain fallback
function lastPickShot(k) {
var lp = state.lastPick, s = sim();
if (!lp || lp.step !== k) return null;
var g = lp.g, v = lp.v;
if (g === 'colour') return colourShot();
if (g === 'carbon') {
if (!state.carbon) return null;
var cg = CARBON_PARTS.map(function(r) {
return { src: carbonPart(r[3], r[2] || CARBON_IMG), label: r[0], name: r[1] };
}).filter(function(r) { return r.src; });
return { src: cg[0].src, grid: cg, caption: FINISHES.carbon.name };
}
if (g === 'software') return { src: softwareImg(), caption: 'CP-S Software Suite' };
if (g === 'pkg') return stageShot(v);
if (isGTSeat() && k === 'seat') return gtSeatShot(g, v);
if (!hasSeatPhotos()) return null;
if (g === 'seatColour') return seatColourShot();
if (g === 'stitching' && STITCH_IMAGES[v]) return { src: STITCH_IMAGES[v], caption: STITCH_COLOURS[v] + ' stitching' };
if (g === 'tricolour' && v !== 'none' && TRICOLOURS[v] && TRICOLOURS[v][2]) return { src: TRICOLOURS[v][2], caption: TRICOLOURS[v][0] + ' tricolour stitching' };
if (g === 'seatFinish' && state.seatFinish[v] && SEAT_FINISHES[v].img) return { src: SEAT_FINISHES[v].img, caption: SEAT_FINISHES[v].name };
return null;
}
function notPictured(k) {
var lp = state.lastPick, s = sim();
if (!lp || lp.step !== k) return null;
var g = lp.g, v = lp.v, label = null;
if (g === 'colour') label = colourName(v);
else if (g === 'seatColour') label = SEAT_COLOURS[v] + ' seat';
else if (g === 'stitching') label = STITCH_COLOURS[v] + ' stitching';
else if (g === 'tricolour' && v !== 'none' && TRICOLOURS[v]) label = TRICOLOURS[v][0] + ' tricolour stitching';
else if (g === 'seatFinish' && state.seatFinish[v]) label = SEAT_FINISHES[v].name;
if (!label) return null;
var base = (k === 'seat' && SEAT_IMG[state.sim]) ? SEAT_IMG[state.sim] : simImg();
return base ? { src: base, caption: s.name + ' \u00b7 ' + label + ' (not pictured)' } : null;
}
function gtSeatShot(g, v) {
var s = sim();
if (isOwnSeat()) return { src: OWN_SEAT_IMG, caption: 'Your own seat \u00b7 Porsche GT3 RS seat shown' };
if (!isCarbonSeat()) {
if (!SEAT_IMG[state.sim]) return null;
var sr = recolouredSeat(SEAT_IMG[state.sim]);
return { src: sr || SEAT_IMG[state.sim], caption: s.seat };
}
var label = carbonSeatName();
if (g === 'stitching' && v !== 'black') label += ' \u00b7 ' + STITCH_COLOURS[v] + ' stitching (not pictured)';
if (g === 'carbonCustom' && state.carbonCustom) label += ' \u00b7 custom colour carbon';
if (g === 'stitchCustom' && state.stitchCustom) label += ' \u00b7 custom stitching';
return { src: carbonSeatImg(), caption: label };
}
function colourShot() {
var s = sim();
if (state.sim === 'formula-pro') {
if (state.colour === 'custom' && customHex()) {
var fpc = maskedRender(FP_PHOTO, FP_MASK, customHex(), innerCustomHex());
if (fpc) return { src: fpc, caption: s.name + ' \u00b7 ' + customHex().toUpperCase() + ' (colour preview)' };
var cur0 = slides && slides[slideIdx];
if (cur0 && cur0.src) return { src: cur0.src, caption: cur0.caption };
return { src: FP_COLOUR_IMAGES.standard, caption: s.name + ' \u00b7 ' + colourName(state.colour) };
}
if (FP_COLOUR_IMAGES[state.colour]) return { src: FP_COLOUR_IMAGES[state.colour], caption: s.name + ' \u00b7 ' + colourName(state.colour) };
}
var rb = RECOLOUR_BASE[state.sim];
if (rb) {
if (state.colour === rb.native) return { src: rb.src, caption: s.name + ' \u00b7 ' + colourName(state.colour) };
if (state.colour === 'custom' && !customHex()) return { src: rb.src, caption: s.name + ' \u00b7 your colour, matched on order' };
if (state.colour !== 'custom' && !FRAME_HEX[state.colour]) return { src: rb.src, caption: s.name + ' \u00b7 your colour, matched on order' };
if (KEYED_BASE[state.sim]) {
var kh = state.colour === 'custom' ? customHex() : FRAME_HEX[state.colour];
var kr = kh && keyedRender(KEYED_BASE[state.sim], kh, null,
state.colour === 'custom' ? finishOf() : 'gloss', null);
if (kr) return { src: kr, caption: s.name + ' \u00b7 ' + (state.colour === 'custom' ? kh.toUpperCase() : colourName(state.colour)) + ' (colour preview)' };
var cur1 = slides && slides[slideIdx];
if (cur1 && cur1.src) return { src: cur1.src, caption: cur1.caption };
return { src: rb.src, caption: s.name + ' \u00b7 ' + colourName(state.colour) };
}
var rc = recoloured(state.sim, state.colour);
if (rc) return { src: rc, caption: s.name + ' \u00b7 ' + (state.colour === 'custom' ? customHex().toUpperCase() : colourName(state.colour)) + ' (colour preview)' };
var cur = slides && slides[slideIdx];
if (cur && cur.src) return { src: cur.src, caption: cur.caption };
return { src: rb.src, caption: s.name + ' \u00b7 ' + colourName(state.colour) };
}
return null;
}
function seatColourShot() {
var FS_SEATS = FS_SEATS_MAP;
var src = null;
if (state.sim === 'formula-sport' && FS_SEATS[state.seatColour]) src = FS_SEATS[state.seatColour];
else if (SEAT_IMAGES[state.seatColour]) src = SEAT_IMAGES[state.seatColour];
if (!src) return null;
if (state.sim === 'formula-sport' && FS_SEATS_KEY[state.seatColour]
&& state.colour !== NATIVE_SHOT['formula-sport']) {
var sh = state.colour === 'custom' ? customHex() : FRAME_HEX[state.colour];
var sk = sh && keyedRender(FS_SEATS_KEY[state.seatColour], sh, null,
state.colour === 'custom' ? finishOf() : 'gloss', null, 1);
if (sk) return { src: sk, caption: SEAT_COLOURS[state.seatColour] + ' seat' };
}
var rc = recolouredSeat(src);
return { src: rc || src, caption: SEAT_COLOURS[state.seatColour] + ' seat' };
}
var NATIVE_SHOT = { 'formula-pro': 'standard', 'gt-pro': 'standard', 'formula-sport': 'papaya', 'gt-sport': 'standard' };
function isCutout(src) { return !!src && /Cutout/i.test(String(src)); }
function sitsWhole(src) { return !!src && /Formula-Pro-Seat\.jpg/i.test(String(src)); }
function photoFit(src, label) { return ((isCutout(src) || sitsWhole(src)) ? ' is-cutout' : '') + (/warranty/i.test(label || '') ? ' is-part' : ''); }
function phoneHref() { return PHONE_HREF; }
function phoneLabel() { return PHONE_LABEL; }
function warmFrameColours() {
var s = sim(); if (!s || !NATIVE_SHOT[state.sim]) return;
var list = [], i;
for (i = 0; i < COLOURWAYS.length; i++) {
var k = COLOURWAYS[i][0];
if (k === state.colour) continue;
if (s.colours && i > 0 && s.colours.indexOf(k) === -1) continue;
list.push(k);
}
var n = 0, prev = state.colour;
function step() {
if (n >= list.length) return;
if (!idleEnough()) { setTimeout(step, 300); return; }   // the page is moving, wait
try { state.colour = list[n]; focusImage(); } catch (e) {}
state.colour = prev;
n++;
if (window.requestIdleCallback) requestIdleCallback(step, { timeout: 1500 });
else setTimeout(step, 250);
}
if (window.requestIdleCallback) requestIdleCallback(step, { timeout: 1200 });
else setTimeout(step, 600);
}
var _lastScrollAt = 0;
window.addEventListener('scroll', function() { _lastScrollAt = Date.now(); }, { passive: true });
function idleEnough() { return Date.now() - _lastScrollAt > 400; }
function canWarm() {
if (window.innerWidth <= 700) return false;
if (navigator.deviceMemory && navigator.deviceMemory < 4) return false;
return true;
}
function warmNextStep(n) {
var nxt = STEPS[n + 1];
if (!nxt) return;
if (!canWarm()) return;
if (nxt.key === 'colour') warmFrameColours();
else if (nxt.key === 'seat') warmSeatColours();
}
function warmSeatColours() {
if (!SEAT_NATIVE[state.sim]) return;
var srcs = [], k;
for (k in SEAT_IMAGES) if (k !== 'custom') srcs.push(SEAT_IMAGES[k]);
if (state.sim === 'formula-sport') for (k in FS_SEATS_MAP) srcs.push(FS_SEATS_MAP[k]);
var i = 0;
function step() {
if (i >= srcs.length) return;
if (!idleEnough()) { setTimeout(step, 300); return; }   // the page is moving, wait
try { recolouredSeat(srcs[i]); } catch (e) {}
i++;
if (window.requestIdleCallback) requestIdleCallback(step, { timeout: 600 });
else setTimeout(step, 120);
}
if (window.requestIdleCallback) requestIdleCallback(step, { timeout: 900 });
else setTimeout(step, 400);
}
function seatPhoto(src) {
if (!src) return false;
if (src === OWN_SEAT_IMG) return false;
if (src === GT_CARBON_SEAT || src === GT_CARBON_SHELL) return false;
if (SEAT_IMAGES.custom && src === SEAT_IMAGES.custom) return false;
if (src === SEAT_IMG[state.sim]) return true;
var sets = [SEAT_IMAGES, FS_SEATS_MAP];
for (var i = 0; i < sets.length; i++) for (var k in sets[i]) if (sets[i][k] === src) return true;
return false;
}
function framePhoto(src) {
if (!src || String(src).indexOf('data:') === 0) return false;
var s2 = sim();
if (s2.images && s2.images.indexOf(src.replace(/[?&]width=\d+/, '')) > -1) return true;
for (var i = 0; i < (s2.images || []).length; i++) if (src.indexOf(s2.images[i].split('?')[0]) > -1) return true;
if (FRAME_IMG[state.sim] && src.indexOf(FRAME_IMG[state.sim].split('?')[0]) > -1) return true;
var dp = DISPLAY_PHOTOS[state.sim] || {};
for (var k in dp) if (src.indexOf(dp[k].split('?')[0]) > -1) return true;
if (RECOLOUR_BASE[state.sim] && src.indexOf(RECOLOUR_BASE[state.sim].src.split('?')[0]) > -1) return true;
return seatPhoto(src);
}
function isData(u) { return String(u).indexOf('data:') === 0; }
function heroImg(maxW) {
if (state.sim === 'formula-pro' && state.colour !== 'custom' && FP_COLOUR_IMAGES[state.colour]) {
return FP_COLOUR_IMAGES[state.colour];
}
if (state.colour !== NATIVE_SHOT[state.sim]) {
var cs = colourShot();
if (cs && cs.src) return cs.src;
}
var raw = simImg();
var painted = paintedSrc(raw, maxW);
if (painted) return painted;
var base = RECOLOUR_BASE[state.sim];
if (base && base.src && state.colour !== NATIVE_SHOT[state.sim]) {
return paintedSrc(base.src, maxW) || base.src;
}
return raw;
}
function placeForm(onReview) {
var form = document.getElementById('cpc-modal-card-' + SID);
var slot = $$('cpc-reviewform-slot'), pane = $$('cpc-reviewform'), show = $$('cpc-slideshow');
if (!form || !slot || !pane || !show) return;
if (onReview) {
if (form.parentNode !== slot) slot.appendChild(form);
pane.hidden = false; show.style.display = 'none';
prepareQuote();
labelSubmit();
markRequired();
showRef._n = 0; setFormHead();
} else {
var home = document.querySelector('#cpq-' + SID + ' .cpq-form');
if (home && form.parentNode !== home) home.insertBefore(form, home.firstChild);
pane.hidden = true; show.style.display = '';
showRef();
}
}
function markRequired() {
var form = document.getElementById('cpc-modal-card-' + SID);
if (!form) return;
var tries = 0;
(function look() {
var req = form.querySelectorAll('[required]');
if (req.length) {
req.forEach(function(f) {
var ctl = f.closest('.globo-form-control') || f.parentNode;
var lab = ctl && (ctl.querySelector('label, .label-content'));
if (lab && lab.querySelector('.cpc-req')) return;
if (lab) { var st = document.createElement('span'); st.className = 'cpc-req'; st.textContent = ' *'; lab.appendChild(st); }
if (!f.placeholder || /\*$/.test(f.placeholder)) return;
f.placeholder = f.placeholder + ' *';
});
return;
}
if (++tries < 40) setTimeout(look, 150);
})();
}
(function() {
document.addEventListener('click', function(e) {
var b = e.target && e.target.closest ? e.target.closest('.form-contactblock__copy') : null;
if (!b || !root() || !root().contains(b)) return;
var addr = b.getAttribute('data-copy-email'), lab = b.querySelector('[data-copy-label]');
if (!addr || !lab || !navigator.clipboard) return;
navigator.clipboard.writeText(addr).then(function() {
var was = lab.textContent; lab.textContent = 'Copied';
setTimeout(function() { lab.textContent = was; }, 1600);
}).catch(function() {});
});
})();
function labelSubmit() {
var form = document.getElementById('cpc-modal-card-' + SID);
if (!form) return;
var tries = 0;
(function look() {
var b = form.querySelector('button[type=submit], input[type=submit], .globo-form-submit button, .globo-button-submit');
if (b) {
var bl = refShown() ? 'Submit Build' : (!helpMode && sim().enquireOnly) ? 'Send Message' : 'Get Quote';
if (b.tagName === 'INPUT') b.value = bl;
else b.textContent = bl;
return;
}
if (++tries < 40) setTimeout(look, 150);
})();
}
function seedPick(key) {
var g = null, v = null;
if (key === 'colour')    { g = 'colour';  v = state.colour; }
else if (key === 'display')   { g = 'display'; v = state.display; }
else if (key === 'immersion') { g = state.motion !== 'none' ? 'motion' : (state.audio !== 'none' ? 'audio' : null);
v = g === 'motion' ? state.motion : state.audio; }
else if (key === 'seat')      { g = 'seatColour'; v = state.seatColour; }
if (g && v) state.lastPick = { step: key, g: g, v: v };
else if (key !== 'spec') state.lastPick = null;
}
var rvQueued = false;
function refreshViewer() {
if (rvQueued) return;
rvQueued = true;
requestAnimationFrame(function() { rvQueued = false; refreshViewerNow(); });
}
function refreshViewerNow() {
renderSlideshow();
var st = STEPS[currentStep];
if (st && (st.key === 'review' || st.key === 'enquire')) {
var sc = $$('cpc-step-' + currentStep), pane = sc && sc.querySelector('.step-content');
var keepTop = pane ? pane.scrollTop : 0;
dirty[currentStep] = true;
renderPanel(currentStep);
if (pane) { var p2 = $$('cpc-step-' + currentStep); p2 = p2 && p2.querySelector('.step-content'); if (p2) p2.scrollTop = keepTop; }
}
if (slides && slides.length) { slides.forEach(function(sl) { sl.painted = false; }); updateSlideUI(); }
}
function paintedSrc(src, maxW) {
var nat = NATIVE_SHOT[state.sim];
if (!nat || !src) return null;
var hex = outerHex();
if (!hex || state.colour === nat) return null;
if (!framePhoto(src)) return null;
if (state.sim === 'formula-pro' && !seatPhoto(src)
&& String(src).indexOf('Keyed') === -1) return null;
var tune = (seatPhoto(src) || state.sim === 'formula-pro') ? (SEAT_TUNE[state.sim] || {}) : {};
var clean = String(src).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
return repaint(clean, FRAME_HEX[nat], hex, 'any|' + clean + '|' + state.colour,
state.colour === 'custom' ? finishOf() : 'gloss', tune.sat, tune.hueIn, tune.hueOut,
(clean.indexOf('Keyed') > -1 ? innerHexFor() : null), null, maxW);
}
function focusImage() {
var f = focusImageRaw();
if (f && f.src && !f.video) {
var pp = paintedSrc(f.src);
if (pp) f = { src: pp, caption: f.caption, grid: f.grid };
}
return f;
}
function focusImageRaw() {
var s = sim(), k = STEPS[currentStep] ? STEPS[currentStep].key : '';
var lps = (k === 'spec' ? null : lastPickShot(k)) || (k === 'colour' || k === 'seat' ? notPictured(k) : null); if (lps) return lps;
if (k === 'spec') {   // parts only on the hardware step; 'standard' shows the whole simulator
var pick = state.lastPart;
var bs = buildShot();
if (bs) { if (pick) bs.caption = pick.label; return bs; }
if (!pick && !isMixed()) { var sg = stageShot(state.pkg); if (sg) return sg; }
if (pick && partImg(pick.value)) return { src: partImg(pick.value), caption: pick.label };
var comps = s.components || [];
for (var ci = comps.length - 1; ci >= 0; ci--) {
var sel = state.comp[comps[ci].id], opt = compLabel(comps[ci], sel);
if (sel && partImg(sel) && opt) return { src: partImg(sel), caption: opt[1] };
}
}
if (k === 'display' && displayImg(state.display)) return { src: displayImg(state.display), caption: DISPLAYS[state.display].name };
if (k === 'immersion') {
var mo = MOTION[state.motion], au = AUDIO[state.audio];
if (mo) mo = { name: mo.name, img: motionImg(state.motion) };
var hs = state.headset ? AUDIO.headset : null;
if (state.motion === 'motion' && MOTION.motion.video && state.lastImmersion !== 'audio' && state.lastImmersion !== 'headset') {
return { src: MOTION.motion.img, video: MOTION.motion.video, caption: MOTION.motion.name };
}
var order = state.lastImmersion === 'headset' ? [hs, au, mo]
: state.lastImmersion === 'audio' ? [au, mo, hs] : [mo, au, hs];
for (var oi = 0; oi < order.length; oi++) if (order[oi] && order[oi].img) return { src: order[oi].img, caption: order[oi].name };
if (displayImg(state.display)) return { src: displayImg(state.display), caption: DISPLAYS[state.display].name + ' \u00b7 ' + mo.name + ', ' + au.name };
}
if (k === 'colour') {
if (state.carbon) return { src: FINISHES.carbon.img, caption: FINISHES.carbon.name };
var cs = colourShot(); if (cs) return cs;
}
if (k === 'seat' && isGTSeat()) { var gss = gtSeatShot('', ''); if (gss) return gss; }
if (k === 'seat' && hasSeatPhotos()) {
var f = Object.keys(SEAT_FINISHES).filter(function(x) { return state.seatFinish[x]; });
if (f.length) return { src: SEAT_FINISHES[f[f.length - 1]].img, caption: SEAT_FINISHES[f[f.length - 1]].name };
if (state.tricolour && state.tricolour !== 'none' && TRICOLOURS[state.tricolour][2]) return { src: TRICOLOURS[state.tricolour][2], caption: TRICOLOURS[state.tricolour][0] + ' tricolour stitching' };
if (state.stitching !== 'black' && STITCH_IMAGES[state.stitching]) return { src: STITCH_IMAGES[state.stitching], caption: STITCH_COLOURS[state.stitching] + ' stitching' };
var sc = seatColourShot(); if (sc) return sc;
}
if (k === 'review' && !sim().enquireOnly) { var bs = buildShot(); if (bs) return bs; }   // enquiry-only models show their own photos
if (k === 'extras') {
var le = state.lastExtra;
if (le && state.extras[le] && extraImg(le)) return { src: extraImg(le), caption: EXTRAS[le].name };
for (var i = s.extras.length - 1; i >= 0; i--) { var e = s.extras[i]; if (state.extras[e] && extraImg(e)) return { src: extraImg(e), caption: EXTRAS[e].name }; }
return { src: softwareImg(), caption: 'CP-S Software Suite' };   // nothing added yet: open on the included software
}
return null;
}
function renderSlideshow() {
var s = sim(), next, f = null;
if (STEPS[currentStep] && STEPS[currentStep].key === 'sim') {
renderStageGrid(null);
var ex0 = examples(state.sim)[0];
var one = ex0 ? ex0.src : (simImg() || (s.images && s.images[0]));
next = one ? [{ src: one, caption: ex0 ? ex0.caption : s.name }] : [];
} else {
next = s.images.map(function(src) { return { src: src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200', caption: s.name }; });
f = focusImage();
if (f && STEPS[currentStep] && STEPS[currentStep].key === 'colour'
&& state.colour !== NATIVE_SHOT[state.sim]) {
next = next.filter(function(x) { return isData(x.src); });
}
if (f) next.unshift(f);
renderStageGrid(f);
}
var key = next.map(function(x) { return x.src + '~' + (x.caption || ''); }).join('|');   // caption counts: same photo, new wording still refreshes
if (key === slideKey) return;          // nothing changed: leave the DOM alone
slideKey = key; slides = next;
var wrap = $$('cpc-slideshow');
slides.forEach(function(sl, i) {
if (slidePool[sl.src]) return;
var img = document.createElement('img');
img.className = 'slide';
img.alt = sl.caption || '';
img.decoding = 'async';
if (i === 0) { img.loading = 'eager'; img.setAttribute('fetchpriority', 'high'); }
else { img.loading = 'lazy'; }
if (WHOLE_SHOT.test(sl.src)) img.className += ' is-whole';
if (sl.src.indexOf('data:') === 0) {                      // a recoloured canvas render
img.src = sl.src;
if (sl.src.indexOf('data:image/png') === 0) img.className += ' is-keyed';
}
else {
var base = sl.src.replace(/[?&]width=\d+/, '');
var join = base.indexOf('?') > -1 ? '&' : '?';
img.src = base + join + 'width=1200';
img.srcset = [480, 720, 960, 1200, 1500, 1800].map(function(w) { return base + join + 'width=' + w + ' ' + w + 'w'; }).join(', ');
}
img.sizes = '(max-width: 700px) 100vw, 55vw';
img.width = 1200; img.height = 900;
wrap.insertBefore(img, wrap.querySelector('.slide-arrow'));
slidePool[sl.src] = img;
});
Object.keys(slidePool).forEach(function(src) {
var live = slides.some(function(x) { return x.src === src; });
slidePool[src].style.display = live ? '' : 'none';
if (!live && src.indexOf('data:') === 0) {
var dead = slidePool[src];
if (dead.parentNode) dead.parentNode.removeChild(dead);
dead.removeAttribute('src');
delete slidePool[src];
}
});
slideIdx = f ? 0 : Math.min(slideIdx, slides.length - 1);
updateSlideUI();
}
function updateSlideUI() {
if (!slides.length) return;
var cur = slides[slideIdx];
(function(){
var wrap = $$('cpc-slideshow'); if (!wrap) return;
var v = wrap.querySelector('.cpc-clip');
if (cur && cur.video) {
if (!v) {
v = document.createElement('video');
v.className = 'cpc-clip';
v.muted = true; v.defaultMuted = true; v.loop = true;
v.playsInline = true; v.setAttribute('playsinline', '');
v.setAttribute('preload', 'none'); v.setAttribute('disablepictureinpicture', '');
wrap.insertBefore(v, wrap.querySelector('.slide-arrow'));
}
if (v.getAttribute('src') !== cur.video) { v.setAttribute('src', cur.video); v.load(); }
v.style.display = '';
var pr = v.play(); if (pr && pr.catch) pr.catch(function(){ v.style.display = 'none'; });
} else if (v) { v.pause(); v.style.display = 'none'; }
})();
var el = slidePool[cur.src];
if (el && !cur.painted) {
var pn = paintedSrc(cur.src);
if (pn) { cur.painted = true; el.removeAttribute('srcset'); el.src = pn; }
}
var _showTok = ++_slideTok, _target = slidePool[cur.src];
function _reveal() {
if (_showTok !== _slideTok) return;
Object.keys(slidePool).forEach(function(src) { slidePool[src].classList.toggle('visible', src === cur.src); });
}
if (_target && !_target.complete) {
_target.addEventListener('load', _reveal, { once: true });
_target.addEventListener('error', _reveal, { once: true });
setTimeout(_reveal, 1500);          // never strand the viewer on the old frame
} else _reveal();
var many = slides.length > 1;
root().querySelectorAll('.slide-arrow').forEach(function(a) { a.classList.toggle('visible', many); });
var counter = $$('cpc-slide-counter');
counter.textContent = (slideIdx + 1) + ' / ' + slides.length;
counter.classList.toggle('visible', many);
$$('cpc-slide-dots').innerHTML = slides.map(function(_, i) {
return '<span class="slide-dot' + (i === slideIdx ? ' active' : '') + '" onclick="' + fn('SlideTo') + '(' + i + ')"></span>';
}).join('');
$$('cpc-caption').textContent = cur.caption;
}
window['cpcSlideTo_' + SID] = function(i) { if (slides[i]) { slideIdx = i; updateSlideUI(); } };
window['cpcSlideMove_' + SID] = function(d) { if (!slides.length) return; slideIdx = (slideIdx + d + slides.length) % slides.length; updateSlideUI(); };

(function() {
var z = $$('cpc-zoom');
if (z && z.parentNode !== document.body) document.body.appendChild(z);
var mb = $$('cpc-menu');
if (mb && mb.parentNode !== document.body) document.body.appendChild(mb);
})();
function syncStickyCta() {
var me = root() && root().querySelector('.cpc-mobile-enquire-' + SID);
if (!me) return;
var st = STEPS[currentStep];
if (!st || st.key !== 'review') { me.classList.remove('is-early'); return; }
var cta = root().querySelector('.rv-cta');
if (!cta) { me.classList.remove('is-early'); return; }
me.classList.toggle('is-early', cta.getBoundingClientRect().bottom > 0);
}
var _ctaTick = 0;
function scheduleStickyCta() {
if (_ctaTick) return;
_ctaTick = requestAnimationFrame(function() { _ctaTick = 0; syncStickyCta(); });
}
window.addEventListener('scroll', scheduleStickyCta, { passive: true });
window.addEventListener('resize', scheduleStickyCta, { passive: true });
var zList = [], zIdx = 0, zScale = 1, zTx = 0, zTy = 0, zGestureAt = 0;
var Z_MAX = 5, Z_TAP = 2.5;
function zoomFlat() {
var out = [], i, j, sl, p, ps, cap;
for (i = 0; i < slides.length; i++) {
sl = slides[i];
if (sl.grid && sl.grid.length) {
for (j = 0; j < sl.grid.length; j++) {
p = sl.grid[j];
if (!p || !p.src) continue;
ps = paintedSrc(p.src) || p.src;
cap = (p.label && p.name) ? (p.label + ' · ' + p.name) : (p.name || p.label || sl.caption || '');
out.push({ src: ps, caption: cap, slide: i, part: j });
}
} else if (sl.src) {
out.push({ src: sl.src, caption: sl.caption || '', slide: i, part: -1 });
}
}
return out;
}
function zImg() { return $$('cpc-zoom-img'); }
function zStage() { return $$('cpc-zoom-stage'); }
function zClamp() {
var im = zImg(), st = zStage();
if (!im || !st) return;
var mx = Math.max(0, (im.offsetWidth * zScale - st.clientWidth) / 2);
var my = Math.max(0, (im.offsetHeight * zScale - st.clientHeight) / 2);
if (zTx > mx) zTx = mx;
if (zTx < -mx) zTx = -mx;
if (zTy > my) zTy = my;
if (zTy < -my) zTy = -my;
}
function zApply() {
var im = zImg(); if (!im) return;
zClamp();
im.style.transform = 'translate(' + zTx + 'px,' + zTy + 'px) scale(' + zScale + ')';
}
function zReset() {
zScale = 1; zTx = 0; zTy = 0;
var im = zImg();
if (im) { im.classList.remove('is-eased'); im.style.transform = ''; }
}
function zShow(i) {
if (!zList.length) return;
zIdx = (i % zList.length + zList.length) % zList.length;
var it = zList[zIdx], im = zImg(), cap = $$('cpc-zoom-cap'), ct = $$('cpc-zoom-count'), box = $$('cpc-zoom');
if (!im) return;
zReset();
var src = String(it.src);
im.src = src.indexOf('data:') === 0 ? src : sized(src, 1800);
im.alt = it.caption || '';
if (cap) cap.textContent = it.caption || '';
if (ct) ct.textContent = (zIdx + 1) + ' / ' + zList.length;
if (box) box.classList.toggle('has-many', zList.length > 1);
}
window['cpcZoomStep_' + SID] = function(d, e) {
if (e && e.stopPropagation) e.stopPropagation();
if (zList.length > 1) zShow(zIdx + d);
};
window['cpcZoomOpen_' + SID] = function(part) {
if (!slides || !slides.length) return;
zList = zoomFlat();
if (!zList.length) return;
var want = -1, first = -1, i;
for (i = 0; i < zList.length; i++) {
if (zList[i].slide !== slideIdx) continue;
if (first < 0) first = i;
if (typeof part === 'number' && part >= 0 && zList[i].part === part) { want = i; break; }
}
if (want < 0) want = first < 0 ? 0 : first;
var box = $$('cpc-zoom'); if (!box) return;
box.removeAttribute('hidden');
document.documentElement.style.overflow = 'hidden';
zShow(want);
};
window['cpcZoomClose_' + SID] = function(e, force) {
if (e && !force && e.target && e.target.classList && e.target.classList.contains('cpc-zoom-img')) return;
if (e && !force && Date.now() - zGestureAt < 400) return;
var box = $$('cpc-zoom'); if (!box) return;
box.setAttribute('hidden', '');
zReset();
var im = zImg(); if (im) im.removeAttribute('src');
zList = [];
document.documentElement.style.overflow = '';
};
document.addEventListener('keydown', function(e) {
var box = $$('cpc-zoom');
if (!box || box.hasAttribute('hidden')) return;
if (e.key === 'Escape') { window['cpcZoomClose_' + SID](null, true); return; }
if (e.key === 'ArrowRight') { e.preventDefault(); window['cpcZoomStep_' + SID](1); }
else if (e.key === 'ArrowLeft') { e.preventDefault(); window['cpcZoomStep_' + SID](-1); }
});
(function zoomGestures() {
var st = zStage();
if (!st || st._cpcZoomGestures) return;
st._cpcZoomGestures = true;
var mode = 0;                    // 0 idle, 1 one finger, 2 pinch
var sx = 0, sy = 0, sT = 0, moved = false;
var bTx = 0, bTy = 0, bS = 1, bDist = 0, bMx = 0, bMy = 0;
var lastTap = 0, lastTapX = 0, lastTapY = 0;
function offs(x, y) {            // a page point as an offset from the stage centre
var r = st.getBoundingClientRect();
return [x - (r.left + r.width / 2), y - (r.top + r.height / 2)];
}
function gap(a, b) {
var dx = a.clientX - b.clientX, dy = a.clientY - b.clientY;
return Math.max(1, Math.sqrt(dx * dx + dy * dy));
}
function scaleAbout(ns, mx, my) {
zTx = mx - (ns / bS) * (bMx - bTx);
zTy = my - (ns / bS) * (bMy - bTy);
zScale = ns;
zApply();
}
function anchor(px, py) { bTx = zTx; bTy = zTy; bS = zScale; bMx = px; bMy = py; }
function toggleAt(px, py) {
var im = zImg();
anchor(px, py);
if (im) im.classList.add('is-eased');
if (zScale > 1.001) { zScale = 1; zTx = 0; zTy = 0; zApply(); }
else scaleAbout(Z_TAP, px, py);
}
st.addEventListener('touchstart', function(e) {
var im = zImg();
if (im) im.classList.remove('is-eased');
if (e.touches.length === 2) {
e.preventDefault();
mode = 2; moved = true;
var a = e.touches[0], b = e.touches[1];
bDist = gap(a, b);
var c = offs((a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2);
anchor(c[0], c[1]);
return;
}
if (e.touches.length !== 1) { mode = 0; return; }
mode = 1; moved = false;
sx = e.touches[0].clientX; sy = e.touches[0].clientY; sT = Date.now();
bTx = zTx; bTy = zTy; bS = zScale;
}, { passive: false });
st.addEventListener('touchmove', function(e) {
if (mode === 2 && e.touches.length >= 2) {
e.preventDefault();
var a = e.touches[0], b = e.touches[1];
var ns = Math.min(Z_MAX, Math.max(1, bS * (gap(a, b) / bDist)));
var c = offs((a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2);
scaleAbout(ns, c[0], c[1]);
return;
}
if (mode !== 1 || e.touches.length !== 1) return;
var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
if (!moved && Math.abs(dx) + Math.abs(dy) > 6) moved = true;
if (!moved) return;
e.preventDefault();
if (zScale > 1.001) { zTx = bTx + dx; zTy = bTy + dy; zApply(); }
}, { passive: false });
st.addEventListener('touchend', function(e) {
var im = zImg();
if (mode === 2) {
if (e.touches.length === 0) {
mode = 0;
zGestureAt = Date.now();
if (zScale < 1.02) { zScale = 1; zTx = 0; zTy = 0; if (im) im.classList.add('is-eased'); }
zApply();
}
return;
}
if (mode !== 1) return;
mode = 0;
var t = e.changedTouches[0];
var dx = t.clientX - sx, dy = t.clientY - sy;
if (moved) {
zGestureAt = Date.now();
if (zScale <= 1.001 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5 && Date.now() - sT < 700) {
window['cpcZoomStep_' + SID](dx < 0 ? 1 : -1);
}
return;
}
var now = Date.now();
if (now - lastTap < 300 && Math.abs(t.clientX - lastTapX) < 30 && Math.abs(t.clientY - lastTapY) < 30) {
lastTap = 0;
e.preventDefault();
zGestureAt = now;
var p = offs(t.clientX, t.clientY);
toggleAt(p[0], p[1]);
return;
}
lastTap = now; lastTapX = t.clientX; lastTapY = t.clientY;
}, { passive: false });
st.addEventListener('touchcancel', function() { mode = 0; });
st.addEventListener('dblclick', function(e) {
e.preventDefault(); e.stopPropagation();
zGestureAt = Date.now();
var p = offs(e.clientX, e.clientY);
toggleAt(p[0], p[1]);
});
st.addEventListener('wheel', function(e) {
e.preventDefault();
var im = zImg(); if (im) im.classList.remove('is-eased');
var p = offs(e.clientX, e.clientY);
anchor(p[0], p[1]);
var ns = Math.min(Z_MAX, Math.max(1, zScale * (e.deltaY < 0 ? 1.12 : 1 / 1.12)));
scaleAbout(ns, p[0], p[1]);
if (zScale <= 1.001) { zScale = 1; zTx = 0; zTy = 0; zApply(); }
}, { passive: false });
var dragging = false, mx0 = 0, my0 = 0;
st.addEventListener('mousedown', function(e) {
if (zScale <= 1.001 || e.button) return;
dragging = true; mx0 = e.clientX; my0 = e.clientY; bTx = zTx; bTy = zTy;
e.preventDefault();
});
document.addEventListener('mousemove', function(e) {
if (!dragging) return;
zTx = bTx + (e.clientX - mx0); zTy = bTy + (e.clientY - my0); zApply();
});
document.addEventListener('mouseup', function() {
if (!dragging) return;
dragging = false; zGestureAt = Date.now();
});
window.addEventListener('resize', function() {
var box = $$('cpc-zoom');
if (box && !box.hasAttribute('hidden')) zApply();
}, { passive: true });
})();
(function grader() {
if (location.search.indexOf('grade=1') === -1) return;
var rows = [['pop', 'Midtone pop', 0, 0.8, 0.01], ['sh', 'Shadows', -0.3, 0.3, 0.01],
['hl', 'Highlights', -0.3, 0.3, 0.01], ['gain', 'Exposure', 0.7, 1.3, 0.01],
['vBright', 'Viewer brightness', 0.7, 1.4, 0.01], ['vContrast', 'Viewer contrast', 0.7, 1.6, 0.01],
['vSat', 'Viewer saturation', 0.5, 1.6, 0.01]];
var box = document.createElement('div');
box.setAttribute('style', 'position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);z-index:2147483600;width:280px;padding:14px 16px;border-radius:12px;background:rgba(10,12,16,.98);border:2px solid #00A8EA;color:#e8eaee;font:12px/1.35 -apple-system,system-ui,sans-serif;box-shadow:0 20px 60px rgba(0,0,0,.75);cursor:move');
var html = '<div style="font-weight:700;letter-spacing:.1em;text-transform:uppercase;font-size:10px;color:#00A8EA;margin-bottom:8px">Lighting</div>';
rows.forEach(function(r) {
html += '<label style="display:block;margin:7px 0"><span style="display:flex;justify-content:space-between"><span>' + r[1] + '</span><b data-o="' + r[0] + '">' + GRADE[r[0]] + '</b></span>'
+ '<input type="range" data-g="' + r[0] + '" min="' + r[2] + '" max="' + r[3] + '" step="' + r[4] + '" value="' + GRADE[r[0]] + '" style="width:100%"></label>';
});
html += '<div style="font-size:10px;color:#9aa3b2;margin:8px 0 0">Drag by the panel edge. The top four only change Formula Pro &gt; Colour &gt; Custom Colour.</div>';
html += '<button data-act="copy" style="width:100%;margin-top:8px;padding:7px;border-radius:6px;border:1px solid rgba(255,255,255,.2);background:#00A8EA;color:#fff;font-weight:700;cursor:pointer">Copy values</button>'
+ '<div data-out style="margin-top:6px;font-size:10px;color:#9aa3b2;word-break:break-all"></div>';
box.innerHTML = html;
document.body.appendChild(box);
function applyView() {
var r = root(); if (!r) return;
r.style.setProperty('--vb', GRADE.vBright);
r.style.setProperty('--vc', GRADE.vContrast);
r.style.setProperty('--vs', GRADE.vSat);
}
var t = null;
box.addEventListener('input', function(e) {
var g = e.target.getAttribute('data-g'); if (!g) return;
GRADE[g] = parseFloat(e.target.value);
box.querySelector('[data-o="' + g + '"]').textContent = GRADE[g];
if (g.indexOf('v') === 0) { applyView(); return; }
clearTimeout(t);
t = setTimeout(function() { keyedCache = {}; slideKey = ''; refreshViewerNow(); }, 260);
});
box.addEventListener('click', function(e) {
if (e.target.getAttribute('data-act') !== 'copy') return;
var v = 'pop ' + GRADE.pop + ' | shadows ' + GRADE.sh + ' | highlights ' + GRADE.hl + ' | exposure ' + GRADE.gain
+ ' | viewer bright ' + GRADE.vBright + ' contrast ' + GRADE.vContrast + ' sat ' + GRADE.vSat;
box.querySelector('[data-out]').textContent = v;
try { navigator.clipboard.writeText(v); } catch (err) {}
});
(function drag() {
var dx = 0, dy = 0, on = false;
box.addEventListener('pointerdown', function(e) {
if (e.target !== box) return;
on = true; var r = box.getBoundingClientRect();
dx = e.clientX - r.left; dy = e.clientY - r.top;
box.setPointerCapture(e.pointerId);
});
box.addEventListener('pointermove', function(e) {
if (!on) return;
box.style.transform = 'none';
box.style.left = (e.clientX - dx) + 'px';
box.style.top = (e.clientY - dy) + 'px';
});
box.addEventListener('pointerup', function() { on = false; });
})();
applyView();
var mo = new MutationObserver(applyView);
if (root()) mo.observe(root(), { childList: true, subtree: true });
})();

(function swipe() {
var wrap = $$('cpc-slideshow');
if (!wrap || wrap._cpcSwipe) return;
wrap._cpcSwipe = true;
var x0 = 0, y0 = 0, t0 = 0, live = false, swiped = false;
if (!wrap.querySelector('.cpc-zoom-hint')) {
var hint = document.createElement('div');
hint.className = 'cpc-zoom-hint';
hint.setAttribute('aria-hidden', 'true');
hint.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>';
wrap.appendChild(hint);
}
wrap.addEventListener('click', function(e) {
if (swiped) { swiped = false; return; }            // that was a swipe, not a tap
if (e.target.closest('.slide-arrow, .slide-dots, .slide-counter, .cpc-clip')) return;
var card = e.target.closest('.sg-card'), part = -1;
if (card && card.parentNode) {
var sibs = card.parentNode.querySelectorAll('.sg-card');
for (var ci = 0; ci < sibs.length; ci++) { if (sibs[ci] === card) { part = ci; break; } }
}
window['cpcZoomOpen_' + SID](part);
});
wrap.addEventListener('touchstart', function(e) {
if (e.touches.length !== 1) { live = false; return; }
x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now(); live = true;
}, { passive: true });
wrap.addEventListener('touchend', function(e) {
if (!live) return;
live = false;
var t = e.changedTouches[0];
var dx = t.clientX - x0, dy = t.clientY - y0;
if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5 || Date.now() - t0 > 700) return;
swiped = true;                                      // suppress the click that follows
window['cpcSlideMove_' + SID](dx < 0 ? 1 : -1);
}, { passive: true });
})();

var stepEverShown = false;
function track(name) {
try {
if (typeof window.clarity !== 'function') window.clarity = function() { (window.clarity.q = window.clarity.q || []).push(arguments); };
var sk = state && state.sim && simPicked ? state.sim : '';
window.clarity('set', 'cfg_sim', sk || 'none');
window.clarity('event', name);
if (sk) window.clarity('event', name + '__' + sk);
} catch (e) {}
}
var trackedKey = null;
function showStep(n) {
n = Math.max(0, Math.min(STEPS.length - 1, n));
var moved = stepEverShown && n !== currentStep;
stepEverShown = true;
currentStep = n;
renderPanel(n, true);
root().querySelectorAll('.step-panel').forEach(function(p, i) { p.classList.toggle('active', i === n); });
var back = $$('cpc-back');
back.classList.toggle('hidden', n === 0);
back.textContent = n === 1 ? '\u2190 Change simulator' : '\u2190 Back';
var next = $$('cpc-next'), st = STEPS[n];
var tk = (STEPS[n] ? STEPS[n].key : n) + '|' + (state ? state.sim : '');
if (tk !== trackedKey) { trackedKey = tk; track('cfg_step_' + (STEPS[n] ? STEPS[n].key : n)); }
if (st.next) { next.textContent = simNextLabel(st); next.classList.remove('hidden'); } else next.classList.add('hidden');
var vc = $$('cpc-viewer-cta');
if (vc) vc.textContent = st.key === 'sim' ? simUnpicked() ? 'Choose a simulator' : ctaVerb(sim()) + ' ' + sim().name + ' \u2192' : 'Submit Your Build \u2192';
var ln = $$('cpc-learn');
if (ln) { ln.textContent = 'Compare'; ln.setAttribute('aria-label', 'Compare the simulators'); }
var me = root().querySelector('.cpc-mobile-enquire-' + SID);
if (me) me.classList.toggle('hidden', st.key !== 'review');
syncStickyCta();
root().classList.toggle('cpc-last-step', st.key === 'review');
root().classList.toggle('cpc-step-0', n === 0);
var _t1 = $$('cpc-trust-1');
if (_t1) { var _ts = _t1.querySelector('[data-txt]'), _pf = (sim().proof || [])[0];
if (_ts && _pf) _ts.textContent = _pf; }
var _phone = window.innerWidth <= 700;
showSiteHeader(n === 0 && _phone);
var _mb = $$('cpc-menu'); if (_mb) _mb.style.display = (n === 0 && _phone) ? 'none' : '';
if (_mb && _phone) { var _ml = _mb.querySelector('.cpc-menu-lbl'); if (_ml) _ml.textContent = 'Menu'; }
warmNextStep(n);
placeForm(st.key === 'review');   // the viewer column carries the form on the last step
seedPick(st.key);
$$('cpc-step-label').textContent = n === 0 ? '' : 'Step ' + n + ' of ' + (STEPS.length - 1) + ' · ' + st.title;
renderSummary();
if (st.key === 'review') { ensureRef(); showRef(); }
renderSlideshow();
var panel = $$('cpc-step-' + n);
if (panel) panel.querySelector('.step-content').scrollTop = 0;
if (moved && window.matchMedia('(max-width: 700px)').matches) {
var top = root().getBoundingClientRect().top + window.pageYOffset - 8;
window.scrollTo({ top: top, behavior: 'smooth' });
}
if (STEPS[n + 1]) requestAnimationFrame(function() { renderPanel(n + 1, false); warmPanel(n + 1); });
}
window['cpcNext_' + SID] = function() {
if (currentStep === 0 && simUnpicked()) {
var g = root().querySelector('.sim-grid');
if (g) window.scrollTo({ top: g.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
return;
}
showStep(currentStep + 1);
};
window['cpcPrev_' + SID] = function() { showStep(currentStep - 1); };
window['cpcGo_' + SID]   = function(key) { showStep(stepIndex(key)); };

var MAX_COMPARE = 6;
window['cpcCompareTick_' + SID] = function(k, on) {
if (on && Object.keys(compareSel).length >= MAX_COMPARE && !compareSel[k]) {
var box = root().querySelector('input[type=checkbox][onchange*="\'' + k + '\'"]');
if (box) box.checked = false;
return;
}
if (on) compareSel[k] = true; else delete compareSel[k];
state.compare = compareSel;
var btn = root().querySelector('.cpc-compare-btn');
var n = Object.keys(compareSel).length;
var lbl = btn ? btn.querySelector('span') : null;
if (lbl) lbl.textContent = n ? 'Compare ' + n + ' selected' + (n >= MAX_COMPARE ? ' (max)' : '') : 'Compare simulators';
if (btn) btn.classList.toggle('is-armed', n > 0);
};
function headerSection() {
var h = document.querySelector('header.header');
return h && h.closest ? h.closest('.shopify-section') : null;
}
function showSiteHeader(on) {
var sec = headerSection();
if (!sec || sec.getAttribute('data-cpc-menu') === '1') return;
if (on) {
sec.style.setProperty('display', 'block', 'important');
sec.style.removeProperty('position');
sec.style.removeProperty('z-index');
} else {
sec.style.setProperty('display', 'none', 'important');
}
}
window['cpcMenu_' + SID] = function() {
if (window.innerWidth > 700) {
var hdr = document.querySelector('header.header');
var sec = hdr && hdr.closest('.shopify-section');
if (sec) {
function put(k, v) { sec.style.setProperty(k, v, 'important'); }
var mb = $$('cpc-menu'), lbl = mb && mb.querySelector('.cpc-menu-lbl');
if (sec.getAttribute('data-cpc-menu') === '1') {
sec.removeAttribute('data-cpc-menu');
put('display', 'none');
sec.style.removeProperty('pointer-events');
hdr.style.removeProperty('transform');
if (mb) { mb.style.top = ''; mb.setAttribute('aria-expanded', 'false'); }
if (lbl) lbl.textContent = 'Show menu';
} else {
sec.setAttribute('data-cpc-menu', '1');
put('display', 'block');
put('position', 'fixed');
put('top', '0');
put('left', '0');
put('right', '0');
put('z-index', '39');
put('background', '#0a0b0d');
put('border-bottom', '1px solid rgba(255,255,255,0.12)');
put('pointer-events', 'auto');
hdr.style.setProperty('transform', 'none', 'important');
if (mb) { mb.style.top = (Math.round(sec.getBoundingClientRect().height) + 10) + 'px'; mb.setAttribute('aria-expanded', 'true'); }
if (lbl) lbl.textContent = 'Hide menu';
}
return;
}
}
var b = document.querySelector('.menu-drawer-button');
if (b) { b.click(); return; }
var d = document.getElementById('MenuDrawer');
if (d) { if (d.hasAttribute('open')) d.removeAttribute('open'); else d.setAttribute('open', ''); }
};
window['cpcCompare_' + SID] = function() {
track('cfg_compare');
var sims = Object.keys(compareSel);
window.dispatchEvent(new CustomEvent('cpc:compare', { detail: { sims: sims, scroll: true } }));
};
window['cpcSim_' + SID] = function(k) {
if (SIMS[k]) simPicked = true;
if (!SIMS[k] || state.sim === k) { if (SIMS[k] && currentStep === 0) { dirty[0] = true; renderPanel(0); } return; }
resetState(k);
buildPanels();
renderSummary();
showStep(currentStep > 0 ? 1 : 0);
if (currentStep === 0) renderPanel(0);
try { var u = new URL(location.href); u.searchParams.set('sim', k); history.replaceState(null, '', u); } catch (e) {}
};

function applySelection(g, v, isToggle, on) {
var panel = $$('cpc-step-' + currentStep);
if (!panel) return;
var cards = panel.querySelectorAll('[data-g="' + g + '"]');
cards.forEach(function(el) {
var mine = el.getAttribute('data-v') === v;
if (isToggle) { if (mine) { el.classList.toggle('selected', on); el.setAttribute('aria-checked', on ? 'true' : 'false'); } }
else el.classList.toggle('selected', mine);
});
}

window['cpcPick_' + SID] = function(g, v) {
var structural = false, isToggle = false, on = false;
state.lastPick = { step: STEPS[currentStep] ? STEPS[currentStep].key : '', g: g, v: v };   // the image follows the last thing clicked
var wasCustomColour = state.colour === 'custom';
if (g === 'pkg') {
state.pkg = v;
if (!pkg().custom) { state.base = v; applyPreset(pkg()); }
state.display = startDisplay();
structural = true;
}
else if (g.indexOf('comp:') === 0) {
state.comp[g.slice(5)] = v;
if (g === 'comp:pedals' && v !== 'cps-custom' && sportClutch()) state.extras.clutch = false;
var cid = g.slice(5), cdef = (sim().components || []).filter(function(c) { return c.id === cid; })[0];
var copt = cdef ? compLabel(cdef, v) : null;
state.lastPart = copt ? { value: v, label: copt[1] } : null;
syncCustom(); structural = true;
}
else if (g === 'carbon')     { state.carbon = !state.carbon; isToggle = true; on = state.carbon; structural = true; }   // the parts grid appears with the pack
else if (g === 'extra' && v === 'clutch' && sportClutch() && state.comp.pedals !== 'cps-custom') { return; }
else if (g === 'extra') {
function dropDrift() { if (state.extras.drift) { state.extras.drift = false; if (state.motion === 'motion') state.motion = 'none'; } }
state.extras[v] = !state.extras[v]; isToggle = true; on = state.extras[v]; state.lastExtra = v;
var other = SHIFTER_RIVAL[v];
if (other) {                                                            // re-render so the rival greys out / comes back
if (on) { state.extras[other] = false; state.extras.classic = false; state.extras.rally = false; dropDrift(); }
structural = true;
}
if (v === 'classic') {
if (on) { state.extras.hpattern = false; state.extras.sequential = false; state.extras.clutch = false; state.extras.rally = false; }
structural = true;
}
if (v === 'rally') {
if (on) { state.extras.handbrake = false; state.extras.hpattern = false; state.extras.sequential = false; state.extras.classic = false; dropDrift(); }
structural = true;
}
if (v === 'drift') {
if (on) {
state.extras.handbrake = false; state.extras.sequential = false; state.extras.hpattern = false;
state.extras.classic = false; state.extras.rally = false; state.motion = 'motion';
} else if (state.motion === 'motion') state.motion = 'none';
structural = true;
}
if (v === 'clutch' && on && state.extras.classic) { state.extras.classic = false; structural = true; }
if (v === 'handbrake' && on && (state.extras.rally || state.extras.drift)) { state.extras.rally = false; dropDrift(); structural = true; }
}
else if (g === 'seatFinish') { state.seatFinish[v] = !state.seatFinish[v]; isToggle = true; on = state.seatFinish[v]; }
else if (g === 'carbonCustom') { if (state.seatType !== 'carbon') return; state.carbonCustom = !state.carbonCustom; isToggle = true; on = state.carbonCustom; }
else if (g === 'stitchCustom') { state.stitchCustom = !state.stitchCustom; isToggle = true; on = state.stitchCustom; }
else if (g === 'headset') { state.headset = !state.headset; isToggle = true; on = state.headset; state.lastImmersion = 'headset'; }
else { state[g] = v; if (g === 'audio' || g === 'motion') state.lastImmersion = g;
if (g === 'motion' && v !== 'motion' && state.extras.drift) { state.extras.drift = false; structural = true; }
if (g === 'seatType') { if (v !== 'carbon') state.carbonCustom = false; structural = true; } }
if (g === 'colour' && wasCustomColour !== (state.colour === 'custom')) structural = true;
if (g === 'colour' || g === 'finish') warmSeatColours();
currentRef = null;                       // spec changed: a fresh reference is issued at review

markDirty(structural ? -1 : currentStep);
if (structural) {
dirty[currentStep] = true;
var content = $$('cpc-step-' + currentStep).querySelector('.step-content');
var y = content ? content.scrollTop : 0;
var wy = window.pageYOffset || document.documentElement.scrollTop || 0;
renderPanel(currentStep);
content = $$('cpc-step-' + currentStep).querySelector('.step-content');
if (content) content.scrollTop = y;
if (window.innerWidth <= 700) window.scrollTo(0, wy);
} else {
applySelection(g, v, isToggle, on);
}
renderSummary();
renderSlideshow();
};

function generateRef() {
var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', code = '';
for (var i = 0; i < 6; i++) code += chars[Math.floor(Math.random() * chars.length)];
return (helpMode ? 'HELP' : sim().prefix) + '-' + code;
}
var helpMode = false;
function specText() {
if (helpMode) return 'Help choosing a simulator. Last viewed: ' + sim().name;
return summaryRows(1).map(function(r) { return r[0] + ': ' + r[1]; }).join(' | ');
}
function buildPayload() {
var w = window.innerWidth, el = Math.round((Date.now() - _sessionStart) / 1000);
var data = { reference: currentRef, simulator: sim().name, package: pkg().name, spec: specText() };
summaryRows(1).forEach(function(r) { data[r[0].toLowerCase().replace(/\W+/g, '_')] = r[1]; });
var _p = isMixed() ? basePkg() : pkg();
data.display_price = isMixed() ? priceFor(state.sim, _p.id) + ' \u00b7 price on quote' : priceFor(state.sim, _p.id);
data.currency = CURRENCY;
data.session_started_at = new Date(_sessionStart).toISOString();
data.submitted_at = new Date().toISOString();
data.time_to_configure = (el >= 60 ? Math.floor(el / 60) + 'm ' : '') + (el % 60) + 's';
data.device_type = w <= 700 ? 'Mobile' : w <= 1100 ? 'Tablet' : 'Desktop';
try { data.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch (e) {}
data.locale = navigator.language || '';
data.referrer = document.referrer || 'Direct';
data.source_url = location.href;
return data;
}
var QK = 'cpcq' + SID, _qn = Date.now();
function qG() { try { return JSON.parse(sessionStorage.getItem(QK)) || []; } catch (e) { return []; } }
function qP(a) { try { sessionStorage.setItem(QK, JSON.stringify(a.slice(-5))); } catch (e) {} }
function qDel(i) { var a = qG(), o = [], k; for (k = 0; k < a.length; k++) if (a[k].i !== i) o.push(a[k]); qP(o); }
function qRetry() { var a = qG(), k; qP([]); for (k = 0; k < a.length; k++) if (!a[k].r) send(a[k].u, a[k].p, 1); }
function send(u, p, r) {
var i = 'q' + (++_qn), a = qG();
a.push({ i: i, u: u, p: p, r: r }); qP(a);
try { if (navigator.sendBeacon && navigator.sendBeacon(u, new Blob([p], { type: 'text/plain' }))) { qDel(i); return; } } catch (e) {}
try { fetch(u, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: p }).then(function() { qDel(i); }, function() {}); } catch (e) {}
}
function post(url, data) { if (url) send(url, JSON.stringify(data), 0); }
function sendSpec() { post(CREATE_URL, buildPayload()); }
function ensureRef() { if (!currentRef) { currentRef = generateRef(); sendSpec(); } }

var DIAL_LIST = [
['GB', '44', 'United Kingdom'], ['US', '1', 'United States'], ['CA', '1', 'Canada'],
['AU', '61', 'Australia'], ['NZ', '64', 'New Zealand'], ['IE', '353', 'Ireland'],
['AT', '43', 'Austria'], ['BE', '32', 'Belgium'], ['CH', '41', 'Switzerland'],
['DE', '49', 'Germany'], ['DK', '45', 'Denmark'], ['ES', '34', 'Spain'],
['FI', '358', 'Finland'], ['FR', '33', 'France'], ['IT', '39', 'Italy'],
['LU', '352', 'Luxembourg'], ['NL', '31', 'Netherlands'], ['NO', '47', 'Norway'],
['PL', '48', 'Poland'], ['PT', '351', 'Portugal'], ['SE', '46', 'Sweden'],
['AE', '971', 'United Arab Emirates'], ['SA', '966', 'Saudi Arabia'],
['QA', '974', 'Qatar'], ['HK', '852', 'Hong Kong'], ['SG', '65', 'Singapore']
];
var DIAL_CODE = (function() { var m = {}, i; for (i = 0; i < DIAL_LIST.length; i++) m[DIAL_LIST[i][0]] = '+' + DIAL_LIST[i][1]; return m; })();
function phoneField(card) { return card.querySelector('input[data-type="phone"], input[name="phone-1"]'); }
function dialSelect(card) {
var inp = phoneField(card);
if (!inp || inp._cpcDial || !inp.parentNode) return;
inp._cpcDial = 1;
var iso = DIAL_CODE[VISITOR_ISO] ? VISITOR_ISO : 'US';
var html = '', i, r;
for (i = 0; i < DIAL_LIST.length; i++) {
r = DIAL_LIST[i];
html += '<option value="' + r[0] + '" data-code="+' + r[1] + '"' + (r[0] === iso ? ' selected' : '') + '>' + r[2] + ' +' + r[1] + '</option>';
}
html += '<option value="" data-code="Other">Other</option>';
var sel = document.createElement('select');
sel.className = 'cpc-dial';
sel.setAttribute('aria-label', 'Country dialling code');
sel.innerHTML = html;
var shown = document.createElement('span');
shown.className = 'cpc-dial-code';
shown.setAttribute('aria-hidden', 'true');
function showCode() { var o = sel.options[sel.selectedIndex]; shown.textContent = o ? o.getAttribute('data-code') : ''; }
sel.addEventListener('change', showCode);
sel.addEventListener('input', showCode);
showCode();
inp.parentNode.insertBefore(shown, inp);
inp.parentNode.insertBefore(sel, inp);
inp.setAttribute('inputmode', 'tel');
}
function mergeDial(card) {
var inp = phoneField(card), sel = card.querySelector('select.cpc-dial');
if (!inp) return;
var v = (inp.value || '').replace(/\s+/g, ' ').trim();
if (!v) return;
var code = sel ? DIAL_CODE[sel.value] : '';
if (v.indexOf('00') === 0) v = '+' + v.slice(2).replace(/^[\s-]+/, '');
else if (v.charAt(0) !== '+') {
if (!code) return;                       // Other: send exactly what was typed
v = v.replace(/^0+/, '');                // drop the national trunk zero
if (!v) return;
v = code + ' ' + v;
}
if (v === inp.value) return;
inp.value = v;
inp.dispatchEvent(new Event('input', { bubbles: true }));
inp.dispatchEvent(new Event('change', { bubbles: true }));
}

function watchSuccess(card, help) {
if (card._cpcWatch) clearInterval(card._cpcWatch);
var n = 0;
card._cpcWatch = setInterval(function() {
var ok = card.querySelector('.message.success');
if (ok && ok.offsetParent !== null && getComputedStyle(ok).display !== 'none') {
clearInterval(card._cpcWatch); card._cpcWatch = null;
track(help ? 'cfg_submit_success_help' : 'cfg_submit_success');
} else if (++n > 60) { clearInterval(card._cpcWatch); card._cpcWatch = null; }
}, 500);
}
var _obs = null;
function initForm() {
var card = document.getElementById('cpc-modal-card-' + SID);
if (!card) return;
if (_obs) { _obs.disconnect(); _obs = null; }
var refValue = currentRef;   // the reference only: the build reaches Monday through the spec webhook
function set(f, v) { if (f && f.value !== v) { f.value = v; f.dispatchEvent(new Event('input', { bubbles: true })); f.dispatchEvent(new Event('change', { bubbles: true })); } }
function refField() { return card.querySelector('.Build-Reference input, .Build-Reference textarea, input.Build-Reference, textarea.Build-Reference'); }
if (!card._cpcSync) { card._cpcSync = 1; card.addEventListener('submit', function() { track(helpMode ? 'cfg_submit_attempt_help' : 'cfg_submit_attempt'); watchSuccess(card, helpMode); mergeDial(card); ensureRef(); set(refField(), currentRef); setTimeout(sendDetails, 0); }, true); }
function attach(form) {
if (!form || form._cpcListening) return;
form._cpcListening = true;
form.addEventListener('submit', function() {
if (!UPDATE_URL) return;
var name = '', email = '', phone = '';
form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input:not([type])').forEach(function(el) {
var hint = (el.name + ' ' + el.id + ' ' + el.placeholder + ' ' + (el.getAttribute('autocomplete') || '')).toLowerCase(), v = el.value.trim();
if (!v) return;
if (!email && /email|e-mail/.test(hint)) email = v;
else if (!phone && /phone|tel|mobile/.test(hint)) phone = v;
else if (!name && /name|full/.test(hint)) name = v;
});
post(UPDATE_URL, { reference: currentRef, name: name, email: email, phone: phone });
});
}
function attr() {
var m = document.cookie.match(/(?:^|;\s*)cp_attr=([^;]+)/), v = m ? decodeURIComponent(m[1]) : '';
if (v && v !== '{}') set(card.querySelector('input[name="hidden-1"], textarea[name="hidden-1"]'), v);
}
function polish() {
dialSelect(card);
[['input[name="text-1"]', 'name'], ['input[name="email"]', 'email'], ['input[name="phone-1"]', 'tel-national'],
['textarea[name="textarea-2"]', 'off'], ['input.nice-select-search', 'off'], ['input[name="repeater-1[]"]', 'off']].forEach(function(r) {
var f = card.querySelector(r[0]);
if (f && f.getAttribute('autocomplete') !== r[1]) f.setAttribute('autocomplete', r[1]);
});
var ph = card.querySelector('input[name="phone-1"]');
if (ph && !ph._cpcOpt) {
ph._cpcOpt = 1;
ph.removeAttribute('presence'); ph.removeAttribute('required'); ph.setAttribute('placeholder', 'Optional');
var phc = ph.closest('.globo-form-control'), star = phc && phc.querySelector('.globo-label .text-danger');
if (star) star.parentNode.removeChild(star);
}
var cl = card.querySelector('.globo-form-control[data-element-id="country-1"] .globo-label .label-content');
if (cl && cl.textContent !== 'Delivery country') cl.textContent = 'Delivery country';
var mc = card.querySelector('.globo-form-control[data-element-id="textarea-2"]');
if (mc && !mc._cpcToggle) {
mc._cpcToggle = 1;
var ta = mc.querySelector('textarea');
var tg = document.createElement('label');
tg.className = 'cpc-msg-toggle';
tg.innerHTML = '<input type="checkbox"><span>Add a message</span>';
mc.parentNode.insertBefore(tg, mc);
mc.classList.add('cpc-msg-hidden');
var cb = tg.querySelector('input');
cb.addEventListener('change', function() {
mc.classList.toggle('cpc-msg-hidden', !cb.checked);
if (cb.checked) { track('cfg_add_message'); if (ta) ta.focus(); }
else if (ta && ta.value) { ta.value = ''; ta.dispatchEvent(new Event('input', { bubbles: true })); }
});
}
msgMode();
var cs = card.querySelector('select[name="country-1"]');
if (cs && !cs._cpcAuto) {
cs._cpcAuto = 1;
cs.setAttribute('autocomplete', 'country-name');
cs.addEventListener('change', function() {
var ns = cs.parentNode.querySelector('.nice-select'), o = cs.options[cs.selectedIndex];
if (!ns || !o) return;
var cur = ns.querySelector('.current'); if (cur) cur.textContent = o.text;
ns.querySelectorAll('.option').forEach(function(li) {
var on = li.getAttribute('data-value') === cs.value;
li.classList.toggle('selected', on); li.classList.toggle('focus', on);
});
});
}
var dsel = card.querySelector('select.cpc-dial');
if (dsel && dsel.getAttribute('autocomplete') !== 'tel-country-code') dsel.setAttribute('autocomplete', 'tel-country-code');
var em = card.querySelector('input[name="email"]');
if (em) { em.setAttribute('inputmode', 'email'); em.setAttribute('autocapitalize', 'off'); em.setAttribute('spellcheck', 'false'); }
card.querySelectorAll('.globo-form-control').forEach(function(c) {
var lc = c.querySelector('.globo-label .label-content'), f = c.querySelector('input.material_filled-input, textarea.material_filled-input');
if (!lc || !f || f.getAttribute('data-cpc-ph')) return;
f.setAttribute('data-cpc-ph', '1');
var phMap = { 'textarea-2': 'Add any additional message, your build is already attached', 'phone-1': 'Optional', 'text-1': 'Your name', 'email': 'name@example.com' };
f.setAttribute('placeholder', phMap[f.name] || '');
});
var sel = card.querySelector('select[name="country-1"]');
var cc = window.Shopify && Shopify.country;
if (sel && !sel._cpcSet && cc) {
var names = { GB: 'United Kingdom', US: 'United States', CA: 'Canada', AU: 'Australia', AE: 'United Arab Emirates', IE: 'Ireland', DE: 'Germany', FR: 'France', NL: 'Netherlands', CH: 'Switzerland', SA: 'Saudi Arabia', QA: 'Qatar', SG: 'Singapore', HK: 'Hong Kong', NZ: 'New Zealand' };
var want = names[cc], opt = want && [].filter.call(sel.options, function(o) { return o.text.trim() === want || o.value === want; })[0];
if (opt) { sel._cpcSet = true; set(sel, opt.value); }
}
var btn = card.querySelector('form button[type="submit"], form .action.submit');
if (btn && !btn._cpcLabel && /submit/i.test(btn.textContent)) { btn._cpcLabel = true; btn.innerHTML = btn.innerHTML.replace(/Submit/i, 'Send My Build'); }
}
function tryInit() {
set(refField(), refValue); attr(); polish(); attach(card.querySelector('form'));
if (refField() && card.querySelector('form') && _obs) { _obs.disconnect(); _obs = null; }
}
tryInit();
if (!refField() || !card.querySelector('form')) {
_obs = new MutationObserver(tryInit);
_obs.observe(card, { subtree: true, childList: true });
setTimeout(function() { if (_obs) { _obs.disconnect(); _obs = null; } }, 10000);
}
}
function leadLine() { var s = sim(); return (s && s.lead) ? s.lead : 'Built in 6 to 8 weeks'; }
function prepareQuote() {
ensureRef(); qRetry();
var s = sim(), p = pkg(), mixed = isMixed(), hero = simImg();
var box = document.getElementById('cpq-build-' + SID);
if (box) box.innerHTML = '<div class="cpq-build-head">'
+ (hero ? '<img src="' + sized(hero, 240) + '" alt="" width="96" height="72" decoding="async">' : '')
+ '<div><div class="cpq-build-name">' + esc(s.name + (mixed ? ' Custom Hardware Spec' : (s.packages.length > 1 ? ' ' + p.name : ''))) + '</div>'
+ '<div class="cpq-build-price">From ' + esc(priceFor(state.sim, mixed ? basePkg().id : p.id)) + '</div>'
+ '<button type="button" class="cpq-edit" onclick="' + fn('EditBuild') + '()">Edit build</button></div></div>'
+ '<ul class="cpq-spec">' + summaryRows().filter(function(r) { return !/^(Simulator|From)/.test(r[0]) && r[1] !== 'None'; }).map(function(r) {
return '<li><span>' + esc(r[0]) + '</span><b>' + esc(r[1]) + '</b></li>'; }).join('') + '</ul>';
var ld = document.getElementById('cpq-lead-' + SID); if (ld) ld.textContent = leadLine();
initForm();
}
window['cpcEditBuild_' + SID] = function() {
window['cpcGo_' + SID]('review');
var r = document.getElementById('cpc-' + SID); if (r) r.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
window['cpcOpenEnquiry_' + SID] = function() {
prepareQuote();
var ri = stepIndex('review');
if (currentStep !== ri) showStep(ri);
var pane = $$('cpc-reviewform');
if (pane && pane.scrollIntoView) pane.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
window['cpcCloseQuote_' + SID] = function() {
var q = document.getElementById('cpq-' + SID); if (!q || !q.classList.contains('open')) return;
q.classList.remove('in'); document.documentElement.style.overflow = '';
setTimeout(function() { q.classList.remove('open'); }, 220);
};
document.addEventListener('keydown', function(e) { if (e.key === 'Escape') window['cpcCloseQuote_' + SID](); });
window['cpcCloseEnquiry_' + SID] = function() {
var b = document.getElementById('cpc-modal-backdrop-' + SID), c = document.getElementById('cpc-modal-card-' + SID);
if (!b) return;   // no modal any more: the form lives in the page
c.classList.remove('open');
setTimeout(function() { b.classList.remove('open'); document.body.style.overflow = ''; }, 260);
var vp = document.querySelector('meta[name="viewport"]');
if (vp && vp._cpcOrig) { vp.content = vp._cpcOrig; delete vp._cpcOrig; }
};
(function() { var q = document.getElementById('cpq-' + SID); if (q) q.addEventListener('focusin', function() { prepareQuote(); }); })();

var _hh = null, _w = window.innerWidth;
function headerEl() {
var sel = ['header[is="sticky-header"]', '.shopify-section-header-sticky', '.shopify-section-header', 'header[role="banner"]'], r = root();
for (var i = 0; i < sel.length; i++) { var el = document.querySelector(sel[i]); if (el && !(r && r.contains(el))) return el; }
return null;
}
function setHeight(force) {
if (!force && window.scrollY > 0) return;
var el = headerEl(), hh = el ? Math.round(el.getBoundingClientRect().height) : 0;
if (hh === _hh) return;
var rt = root(); if (!rt) return;
_hh = hh; rt.style.setProperty('--cpc-header-h', hh + 'px');
}
window.addEventListener('load', function() { setHeight(); });
window.addEventListener('resize', function() { if (window.innerWidth === _w) return; _w = window.innerWidth; setHeight(true); });

var start = cfg.defaultSim || 'gt-pro';
try { var q = new URL(location.href).searchParams.get('sim'); if (q && SIMS[q]) { start = q; simPicked = true; } } catch (e) {}
resetState(SIMS[start] ? start : 'gt-pro');
buildPanels();
renderSummary();
setHeight(true);
/* ?step=N deep link (used by the collection page Configure buttons): only honoured alongside a valid ?sim=. */
var startStep = 0;
try {
var qs = new URL(location.href).searchParams, qsStep = parseInt(qs.get('step'), 10);
if (qs.get('sim') && SIMS[qs.get('sim')] && qsStep > 0) startStep = Math.min(qsStep, STEPS.length - 1);
} catch (e) {}
showStep(startStep);
}

function cpcRunAll() {
var q = window.cpcBlocks || [], latest = {}, k, c, el;
for (var i = 0; i < q.length; i++) if (q[i] && q[i].sid) latest[q[i].sid] = q[i];
for (k in latest) {
c = latest[k];
el = document.getElementById('cpc-' + c.sid);
if (!el || el.getAttribute('data-cpc-init')) continue;
el.setAttribute('data-cpc-init', '1');
cpcInitConfigurator(c);
}
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cpcRunAll);
else cpcRunAll();
document.addEventListener('shopify:section:load', cpcRunAll);
document.addEventListener('shopify:block:select', cpcRunAll);
})();
